// RPR-S7721: document-picker helpers hoisted to module scope. They capture
// nothing from the service/popup closures, so SonarJS wants them at the
// outermost scope. Prefixed to avoid colliding with other bundled files.
function phStopPropagation(event) { event.stopPropagation(); }

function phFormatBytes(bytes) {
  if (!bytes) { return ''; }
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) { value /= 1024; unit++; }
  return (unit === 0 ? value : value.toFixed(1)) + ' ' + units[unit];
}

// Wire the #file-picker change handler. Inlined map/reduce keep nesting <=4
// (S2004) and avoid extra named callbacks (S7721/S7727).
function phBindFilePicker(scope) {
  $('#file-picker').change(function (event) {
    scope.$apply(function () {
      const files = Array.from(event.target.files || []);
      scope.document_uploader.document.files = event.target.files;
      scope.document_uploader.selected_file_label = files.map(function (f) { return f.name; }).join(', ');
      scope.document_uploader.selected_file_size_label =
        phFormatBytes(files.reduce(function (sum, f) { return sum + (f.size || 0); }, 0));
    });
  });
}

function phPreventDefault(event) { event.preventDefault(); }

// RPR-6748: copy the dropped FileList onto the hidden #file-picker input, then
// fire the same change event the browse button does so phBindFilePicker (above)
// updates the model. Hoisted/closure-free (S7721); try/catch keeps nesting <=4.
function phApplyDroppedFiles(input, fileList) {
  if (!input || !fileList?.length) { return; }
  try {
    const dt = new DataTransfer();
    for (const file of fileList) { dt.items.add(file); }
    input.files = dt.files;
  } catch (err) {
    // browsers that disallow setting input.files: ignore the drop, browse still works
    console.warn('phApplyDroppedFiles: could not set input.files', err); // eslint-disable-line no-console
    return;
  }
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

// RPR-6748: bind drag-and-drop in the dialog's onReady (where jquery-confirm's
// DOM is final and stable) instead of via a compile-time directive, whose native
// listeners don't survive onto the rendered modal. Mirrors phBindFilePicker.
function phBindDropzone() {
  const input = document.getElementById('file-picker');
  if (!input) { return; }
  // Scope to THIS document-manager instance (the one holding #file-picker) so the
  // handlers never touch another dialog that reuses the .document-manager class
  // (e.g. question_bank_popup). Mirrors phBindFilePicker's reliance on #file-picker's id.
  const $manager = $(input).closest('.document-manager');

  // Swallow stray drops anywhere in the popup so a mis-aimed file never opens
  // in the browser (preventDefault only -- a real drop on the zone is handled below).
  $manager
    .off('dragover.dmDrop drop.dmDrop')
    .on('dragover.dmDrop drop.dmDrop', phPreventDefault);

  const $zone = $manager.find('.dm-dropzone');
  $zone.off('.dmDrop');
  $zone.on('dragenter.dmDrop dragover.dmDrop', function (event) {
    phPreventDefault(event);
    $(this).addClass('is-dragover');
  });
  $zone.on('dragleave.dmDrop dragend.dmDrop', function () {
    $(this).removeClass('is-dragover');
  });
  $zone.on('drop.dmDrop', function (event) {
    phPreventDefault(event);
    $(this).removeClass('is-dragover');
    phApplyDroppedFiles(input, event.originalEvent?.dataTransfer?.files);
  });
}

// RPR-6732: client-side magic-byte sniffing so a renamed file (a PDF renamed
// to .mp4, an MP4 renamed to .pdf, an image renamed to .pdf, etc.) is rejected
// with a friendly message BEFORE any upload starts. Defense-in-depth only --
// being client JS it is bypassable, so the API enforces the same rules
// authoritatively (mirrors misc/utils/files.py). Hoisted to module scope (and
// ph-prefixed) per SonarJS, like the other ph* document-picker helpers above.

// Top-level ISO/QuickTime atoms that legitimately begin a video (mirrors
// misc/utils/files.py). Trimmed to these three so a text/CSV doc whose bytes
// 4-8 spell a generic atom isn't mis-sniffed as video.
const PH_ISO_VIDEO_ATOMS = new Set(['ftyp', 'moov', 'mdat']);

// ISO-BMFF 'ftyp' major brands (bytes 8-12) that are NOT video: HEIF/AVIF
// images, JPEG 2000, and audio share the 'ftyp' box, so the brand distinguishes
// a .heic photo / .m4a clip from real video (RPR-6732).
const PH_ISO_NON_VIDEO_BRANDS = new Set([
  'heic', 'heix', 'heim', 'heis', 'hevc', 'hevx', 'mif1', 'msf1', 'avif', 'avis',
  'jp2 ', 'jpx ', 'jpm ', 'jph ', 'M4A ', 'M4B ', 'M4P ', 'F4A ', 'F4B '
]);

// Read the first n bytes of a file as a Uint8Array; resolves to an empty array
// on any read error. Blob#arrayBuffer() avoids the nested FileReader callbacks.
function phReadFileHead(file, n) {
  return file.slice(0, n).arrayBuffer()
    .then(function (buffer) { return new Uint8Array(buffer); })
    .catch(function () { return new Uint8Array(0); });
}

function phBytesStartWith(bytes, sig) {
  if (bytes.length < sig.length) { return false; }
  for (let i = 0; i < sig.length; i++) {
    if (bytes[i] !== sig[i]) { return false; }
  }
  return true;
}

function phAsciiAt(bytes, offset, length) {
  let out = '';
  for (let i = 0; i < length && offset + i < bytes.length; i++) {
    out += String.fromCodePoint(bytes[offset + i]);
  }
  return out;
}

// Bytes 0-3 are the big-endian size of the leading ISO box; a real box is >= 8
// bytes (0 = extends to EOF, 1 = 64-bit size follows are also valid for mdat).
function phBoxSizePlausible(bytes) {
  if (bytes.length < 4) { return false; }
  const size = ((bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3]) >>> 0;
  return size >= 8 || size === 0 || size === 1;
}

// Parse the EBML DocType string (element id 0x4282) rather than substring-
// scanning for 'webm', so a generic .mkv mentioning "webm" in a tag isn't
// mistaken for a WebM. DocType strings are short -> single-byte vint size.
function phEbmlDocType(bytes) {
  let idx = -1;
  for (let i = 0; i + 1 < bytes.length; i++) {
    if (bytes[i] === 0x42 && bytes[i + 1] === 0x82) { idx = i; break; }
  }
  if (idx === -1 || idx + 3 > bytes.length) { return null; }
  const length = bytes[idx + 2] & 0x7f;
  return phAsciiAt(bytes, idx + 3, length);
}

// Returns a Promise resolving to 'pdf' | 'image' | 'video' | null. Reads a few
// KB so the WebM DocType (after a variable EBML header) is always in range;
// still a constant, tiny slice regardless of the (up to 2 GB) file size.
function phSniffFileType(file) {
  return phReadFileHead(file, 4096).then(function (bytes) {
    if (!bytes || bytes.length === 0) { return null; }
    if (phAsciiAt(bytes, 0, 5) === '%PDF-') { return 'pdf'; }
    // MP4 / MOV: an ISO atom at offset 4 with a plausible box size. For 'ftyp',
    // the major brand (bytes 8-12) separates video from HEIC/M4A/JP2.
    if (bytes.length >= 8 && PH_ISO_VIDEO_ATOMS.has(phAsciiAt(bytes, 4, 4)) && phBoxSizePlausible(bytes)) {
      if (phAsciiAt(bytes, 4, 4) === 'ftyp') {
        if (bytes.length >= 12 && !PH_ISO_NON_VIDEO_BRANDS.has(phAsciiAt(bytes, 8, 4))) { return 'video'; }
      } else {
        return 'video';
      }
    }
    // WebM is EBML (1A 45 DF A3) with a 'webm' DocType (excludes generic .mkv).
    if (phBytesStartWith(bytes, [0x1a, 0x45, 0xdf, 0xa3]) && phEbmlDocType(bytes) === 'webm') {
      return 'video';
    }
    if (phBytesStartWith(bytes, [0x89, 0x50, 0x4e, 0x47])) { return 'image'; }
    if (phBytesStartWith(bytes, [0xff, 0xd8, 0xff])) { return 'image'; }
    if (phAsciiAt(bytes, 0, 6) === 'GIF87a' || phAsciiAt(bytes, 0, 6) === 'GIF89a') { return 'image'; }
    if (phAsciiAt(bytes, 0, 2) === 'BM') { return 'image'; }
    if (phAsciiAt(bytes, 0, 4) === 'RIFF' && phAsciiAt(bytes, 8, 4) === 'WEBP') { return 'image'; }
    // TIFF (little/big endian) -- mirrors the server so a TIFF renamed .pdf is
    // caught client-side instead of round-tripping to a server 400.
    if (phBytesStartWith(bytes, [0x49, 0x49, 0x2a, 0x00]) || phBytesStartWith(bytes, [0x4d, 0x4d, 0x00, 0x2a])) {
      return 'image';
    }
    return null;
  });
}

// MediaError.MEDIA_ERR_DECODE. Named so the branch in phProbeVideoDecode reads.
const PH_MEDIA_ERR_DECODE = 3;

// Read n bytes at an arbitrary offset; resolves to an empty array on a read error.
// Companion to phReadFileHead, which only ever reads from 0.
function phReadFileRange(file, start, n) {
  return file.slice(start, start + n).arrayBuffer()
    .then(function (buffer) { return new Uint8Array(buffer); })
    .catch(function () { return new Uint8Array(0); });
}

// Walk the top-level ISO-BMFF boxes looking for 'moov'. Resolves true ONLY when we
// positively proved it is absent; any ambiguity resolves false, matching this file's
// deliberately-lenient policy (the server is authoritative). Reads 16 bytes per box
// and seeks by the box size, so even a 2 GB file costs a handful of tiny reads.
function phMp4WalkForMoov(file, offset, boxesSeen) {
  if (offset >= file.size) { return Promise.resolve(boxesSeen > 0); }
  if (boxesSeen >= 64) { return Promise.resolve(false); }
  return phReadFileRange(file, offset, 16).then(function (bytes) {
    if (bytes.length < 8) { return false; }
    const type = phAsciiAt(bytes, 4, 4);
    // Not ISO-BMFF at all (a WebM, say) -- not ours to judge.
    if (boxesSeen === 0 && !PH_ISO_VIDEO_ATOMS.has(type)) { return false; }
    let size = ((bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3]) >>> 0;
    // A zero size means the box runs to EOF, so nothing follows it.
    const runsToEof = size === 0;
    if (size === 1) {
      if (bytes.length < 16) { return false; }
      // 64-bit largesize read as two exact 32-bit halves -- no BigInt needed, real
      // files sit far below 2^53 bytes.
      const high = ((bytes[8] << 24) | (bytes[9] << 16) | (bytes[10] << 8) | bytes[11]) >>> 0;
      const low = ((bytes[12] << 24) | (bytes[13] << 16) | (bytes[14] << 8) | bytes[15]) >>> 0;
      size = (high * 4294967296) + low;
    }
    if (type === 'moov') {
      // Finding the HEADER is not proof: a file truncated part-way through its moov
      // still begins one (measured -- a 232-byte cut of a real MP4 keeps ftyp plus
      // the first bytes of moov). Require the whole box to fit inside the file. A
      // run-to-EOF moov is ambiguous, so treat it as present and let the decoder rule.
      return !runsToEof && (size < 8 || (offset + size) > file.size);
    }
    if (runsToEof) { return boxesSeen > 0; }
    if (size < 8) { return false; }
    return phMp4WalkForMoov(file, offset + size, boxesSeen + 1);
  });
}

// RPR-6719 (QA re-open 2): structure is the only reliable way to tell a truncated
// recording from a codec this browser merely cannot decode. MEASURED on real files:
// an MP4 truncated with its moov INTACT (faststart layout) surfaces as
// MEDIA_ERR_DECODE once we seek into the missing bytes -- but one truncated with its
// moov cut off reports MEDIA_ERR_SRC_NOT_SUPPORTED, the very same code a perfectly
// good ProRes/DNxHD .mov or HEVC .mp4 reports, and Mux transcodes those fine. Since
// ffmpeg's DEFAULT layout writes moov LAST, any interrupted recording lands in that
// ambiguous bucket. A valid ISO-BMFF file always carries a moov whatever its codec,
// so this catches the broken ones without blocking the unplayable-but-valid ones.
function phMp4IsMissingMoov(file) {
  return phMp4WalkForMoov(file, 0, 0).catch(function () { return false; });
}

// Load the file into a detached <video> and seek to the end. The SEEK is the
// load-bearing half: a truncated-but-parseable MP4 reports a perfectly good duration
// from its surviving moov, and only forcing a decode of the bytes near the end
// surfaces the damage.
function phProbeVideoDecode(file, urlApi) {
  return new Promise(function (resolve) {
    let done = false;
    let settleTimer = null;
    let seekTimer = null;
    const video = document.createElement('video');
    const objectUrl = urlApi.createObjectURL(file);
    const finish = function (failed) {
      if (done) { return; }
      done = true;
      if (settleTimer) { clearTimeout(settleTimer); }
      if (seekTimer) { clearTimeout(seekTimer); }
      if (typeof video.removeAttribute === 'function') { video.removeAttribute('src'); }
      if (typeof video.load === 'function') { video.load(); }
      if (typeof urlApi.revokeObjectURL === 'function') { urlApi.revokeObjectURL(objectUrl); }
      resolve(failed);
    };
    // Only a decode failure is proof of corruption. MEDIA_ERR_SRC_NOT_SUPPORTED just
    // means "this browser can't play it", which is true of codecs Mux handles fine --
    // phMp4IsMissingMoov above is what catches the broken files that also land there.
    const onVideoError = function () { finish(video.error?.code === PH_MEDIA_ERR_DECODE); };
    const verifySeek = function () {
      const duration = Number(video.duration);
      if (!Number.isFinite(duration) || duration <= 0) {
        finish(true);
        return;
      }
      video.addEventListener('seeked', function () { finish(false); }, { once: true });
      seekTimer = setTimeout(function () { finish(false); }, 2000);
      try {
        video.currentTime = Math.max(0, duration - 0.25);
      } catch (e) {
        finish(false);
      }
    };
    settleTimer = setTimeout(function () { finish(false); }, 4000);
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.addEventListener('error', onVideoError, { once: true });
    video.addEventListener('loadedmetadata', verifySeek, { once: true });
    video.src = objectUrl;
    try {
      video.load();
    } catch (e) {
      finish(false);
    }
  });
}

// Bound a promise that carries no internal deadline, resolving to the lenient answer
// if it overruns. phProbeVideoDecode above has its own settleTimer and cannot hang;
// the structural read leg has nothing of the kind, and Blob#arrayBuffer() can stall
// indefinitely rather than reject -- a file on removable media that was unplugged, or
// a disconnected network mount. That matters more than it looks: a stall there never
// settles the chain in upload_method, so document_uploader.verifying_content stays
// latched true and the re-entry guard silently swallows every later Upload click for
// the rest of the session, with no popup and nothing in the console.
function phWithTimeout(promise, ms, fallbackValue) {
  return Promise.race([
    promise,
    new Promise(function (resolve) { setTimeout(function () { resolve(fallbackValue); }, ms); })
  ]);
}

function phBestEffortVideoPrecheck(file) {
  const urlApi = globalThis.URL || globalThis.webkitURL;
  if (!file || !urlApi || typeof urlApi.createObjectURL !== 'function' || typeof document === 'undefined') {
    return Promise.resolve(false);
  }
  // Structural check first: it is deterministic and costs a few small reads, where
  // the decode probe spins up a real decoder. Same 4s ceiling as the probe's settle
  // timer, so the whole precheck is bounded at roughly 8s however badly a read behaves.
  return phWithTimeout(phMp4IsMissingMoov(file), 4000, false).then(function (missingMoov) {
    return missingMoov ? true : phProbeVideoDecode(file, urlApi);
  });
}

// RPR-6719 (QA re-open 2): the Videos picker gates its checkbox on the row's
// mux_processing_status, but nothing ever updated that field after the row was
// created. syncVideoTableAfterUpload adds the row as 'processing' and the Mux poller
// then only wrote to the upload-PROGRESS row, so a clip Mux later rejected stayed
// selectable for the whole life of the dialog -- exactly what QA reported. Push the
// status onto the DataTable row instead, and the existing videoAttachableStatuses
// gate re-renders it disabled, with the badge from videoStatusBadge() explaining why.
//
// RPR-6923: that badge is only ever as complete as the mapping. The status written here
// is whatever onVideoPollerUpdate settled on, which includes the poller's synthetic
// 'timed_out' -- a stall / hard ceiling (RPR-6752) or a give-up after repeated poll
// failures (RPR-6923). videoStatusBadge() had no case for it, so those rows rendered
// disabled with NO badge and only a hover tooltip: the unexplained-disabled-row state
// this comment claims to have fixed. It has a case now; if you add another synthetic
// status, add it there too or you will reopen that hole silently.
function phSyncVideoPickerRowStatus(documentId, status) {
  if (documentId == null || !status) { return; }
  if (!$.fn?.dataTable?.isDataTable?.('#videos-list-table')) { return; }
  const table = $('#videos-list-table').DataTable();
  const wanted = Number.parseInt(documentId, 10);
  const rows = table.rows(function (index, rowData) {
    return rowData && Number.parseInt(rowData.id, 10) === wanted;
  });
  if (!rows.any()) { return; }
  // Captured BEFORE mutating: draw() re-renders every row's HTML, which would
  // silently clear ticks the author has already made elsewhere in this dialog
  // session. The clip we are about to disable is deliberately not restored.
  const checkedIds = $('#videos-list-table input[type=checkbox]:checked:not(:disabled)')
    .map(function () { return $(this).data('id'); }).get()
    .filter(function (id) { return Number.parseInt(id, 10) !== wanted; });
  let changed = false;
  rows.every(function () {
    const current = this.data();
    if (current?.mux_processing_status === status) { return; }
    this.data(_.extend({}, current, { mux_processing_status: status }));
    changed = true;
  });
  // The poller repeats the same status every tick; only redraw on a real transition,
  // so we aren't fighting the author's checkboxes every few seconds.
  if (!changed) { return; }
  table.draw(false);
  for (const id of checkedIds) {
    $('#video-id-' + id).prop('checked', true);
  }
}

// Resolves to null when nothing is clearly wrong, else to a {title, message}
// for the first offending file. Deliberately LENIENT (RPR-6732 backward-compat):
// only blocks files whose bytes are POSITIVELY a wrong known type, so a
// valid-but-unrecognised file is never falsely rejected (the server is
// authoritative).
function phVerifyUploadContent(files, onVideosTab) {
  // The map runs synchronously as an argument to Promise.all, i.e. before any promise
  // exists to turn a throw into a rejection. Starting from Promise.resolve() means even
  // a synchronous fault in there (a `files` entry that is not a real Blob) reaches the
  // caller's .catch. Without it the throw escapes this function outright, so
  // upload_method never gets to attach its .then/.catch at all and verifying_content --
  // latched true one line earlier -- is never cleared.
  return Promise.resolve().then(function () {
    return Promise.all(files.map(phSniffFileType));
  }).then(function (types) {
    const verifyAt = function (index) {
      if (index >= files.length) {
        return null;
      }
      const detected = types[index];
      const fileName = _.escape(files[index].name || 'selected file');
      if (onVideosTab && (detected === 'pdf' || detected === 'image')) {
        return {
          title: 'Unsupported video file',
          message: '"' + fileName + '" is not a video file. Please upload a valid MP4, MOV or WebM file.'
        };
      }
      if (!onVideosTab && (detected === 'video' || detected === 'image')) {
        return {
          title: 'Unsupported document file',
          message: '"' + fileName + '" does not appear to be a PDF. Please upload a genuine PDF document.'
        };
      }
      if (onVideosTab && detected === 'video') {
        return phBestEffortVideoPrecheck(files[index]).then(function (failed) {
          if (failed) {
            // RPR-6719: deliberately says "incomplete or damaged" and NOT
            // "unsupported" -- a format this browser merely cannot decode is now
            // allowed through on purpose (Mux transcodes plenty that Chrome will
            // not play), so the only files reaching here are ones we have positive
            // evidence are broken: missing metadata, or a decode failure part-way
            // through. Naming re-upload as the fix matches the real cause, which is
            // almost always a transfer or recording that stopped early.
            return {
              title: 'Incomplete or damaged video',
              message: '"' + fileName + '" could not be read as a complete video — it looks like the '
                + 'file was cut short or damaged. Please upload it again.'
            };
          }
          return verifyAt(index + 1);
        });
      }
      return verifyAt(index + 1);
    };
    return verifyAt(0);
  });
}

function phPluralizeCount(count, singular, plural) {
  return count + ' ' + (count === 1 ? singular : plural);
}

// RPR-6719: the copy an EM sees when a video's Mux ingest fails. A corrupted but
// structurally well-formed clip passes the upload's server-side check (which only
// magic-byte-sniffs the leading bytes), so the transcoder is the first thing that
// can tell it is broken -- and it says so asynchronously, via the status poller.
// Mux's own wording is internal detail, so the dialog shows this instead.
const PH_VIDEO_INGEST_FAILED_MESSAGE = 'The selected video file is corrupted or could not be processed. '
  + 'Please upload a valid video file.';

// RPR-6719: is this NON-replace poller update a genuine ingest failure -- i.e. is
// the clip unusable, so the EM must be told and its row dropped from the Videos
// tab? (The backend already excludes an ingest-failed, unattached video from the
// repository listings, so an open dialog's table is the only surface where it
// would otherwise survive.)
//
// RPR-6719 guarded this against the poller's OTHER use of the word: a poller that had
// merely lost contact with the backend also reported `status: 'errored'`, and a clip
// that is transcoding perfectly well must never be dressed up as corrupted -- the EM
// would be told their good file was broken AND its row yanked from the Videos tab.
// RPR-6923 removed that collision at the source: the give-up after
// MAX_CONSECUTIVE_FAILURES now reports `{status: 'timed_out', poll_failed: true}` (see
// video_status_poller.js, pinned against the real factory in
// video_status_poller_give_up.spec.js), so the `status === erroredStatus` half of the
// test already excludes a lost-contact update on its own.
//
// The `!update.poll_failed` clause is kept as defence in depth: nothing pairs
// `poll_failed` with 'errored' today, and if anything ever starts to, the toast and the
// row-drop must stay off. video_ingest_failure.spec.js pins that hypothetical input
// deliberately, so the clause cannot be dropped as dead weight without a spec failing.
function phIsVideoIngestFailure(update, erroredStatus) {
  return !!update && update.status === erroredStatus && !update.poll_failed;
}

// RPR-6719: drop a failed clip's row from the Videos tab, keeping the tab's badge
// count in step. A no-op once the dialog has been dismissed (the DataTable is
// gone, and the refreshed client lists simply won't include the row next time).
// `draw(false)` rather than `draw()`: the bare call resets DataTables to page 1,
// which would yank the EM away from wherever they were browsing.
function phDropVideoRow(documentId, uploader) {
  if (documentId == null || !$.fn.dataTable.isDataTable('#videos-list-table')) { return; }
  const videoTable = $('#videos-list-table').DataTable();
  const rows = videoTable.rows(function (idx, rowData) { return rowData.id === documentId; });
  if (!rows.any()) { return; }
  rows.remove();
  videoTable.draw(false);
  if (uploader) {
    uploader.videos_count = Math.max(0, (uploader.videos_count || 0) - 1);
  }
}

// RPR-6758 (QA restyle): one plain-English blast-radius phrase for the replace
// confirm -- "1 question, 2 sections and 1 survey document across 13 countries"
// -- so the panel answers "what's affected?" before the reader reaches the chip
// ledger. Pure string building; the template supplies the lead-in copy around
// it. Returns null when nothing is in use (the template falls back to its plain
// lead-in). Hoisted to module scope (and ph-prefixed) per SonarJS S7721, like
// the other ph* document-picker helpers above.
function phBuildReplaceUsageSummary(usage) {
  if (!usage?.in_use) {
    return null;
  }
  const parts = [];
  if (usage.questions?.length) {
    parts.push(phPluralizeCount(usage.questions.length, 'question', 'questions'));
  }
  if (usage.sections?.length) {
    parts.push(phPluralizeCount(usage.sections.length, 'section', 'sections'));
  }
  if (usage.country_documents?.length) {
    parts.push(phPluralizeCount(usage.country_documents.length, 'survey document', 'survey documents'));
  }
  if (!parts.length) {
    return null;
  }
  // No Array.prototype.at here: it's ES2022 runtime API and would be the first
  // use in the untranspiled portal bundle (raises the browser floor).
  const lastPart = parts.pop();
  const phrase = parts.length ? parts.join(', ') + ' and ' + lastPart : lastPart;

  // Union of country names across all three groups -- a country attached in
  // several places is still one country.
  const countryNames = new Set();
  for (const question of usage.questions || []) {
    for (const country of question.countries || []) { countryNames.add(country.name); }
  }
  for (const section of usage.sections || []) {
    for (const country of section.countries || []) { countryNames.add(country.name); }
  }
  for (const countryDocument of usage.country_documents || []) { countryNames.add(countryDocument.name); }
  // Degraded payloads may omit names; don't let empties inflate the count.
  countryNames.delete(undefined);
  countryNames.delete(null);
  countryNames.delete('');

  if (!countryNames.size) {
    return phrase;
  }
  return phrase + ' across ' + phPluralizeCount(countryNames.size, 'country', 'countries');
}

// RPR-6770: recovery for "you are not the user this endpoint is for" responses.
//
// The session engine is signed_cookies (no server-side store), so right after a
// session switch -- ending "access on behalf of" restores the admin session --
// a request can race ahead of the restored session and come back rejected by a
// user-type permission check. That is transient: reloading once is enough.
// Bouncing to the sub-app root instead (the historic behaviour) discards the
// location, and routing_admin.js's `.otherwise` -- admin/index.html loads only that
// router -- turns a bare root into `redirectTo: '/Administration'`, i.e. the
// dashboard. (Not app_routing.js's `.otherwise -> /Login`; that one serves the
// top-level app at a different URL and is not involved here.)
const PH_WRONG_USER_RETRY_KEY = 'rpr_wrong_user_retry';
// One reload per URL per window. Deliberately self-expiring rather than cleared
// on a successful boot: the failing request is often a sibling of a *successful*
// portalReady, so clearing on success would re-arm the retry and loop forever.
const PH_WRONG_USER_RETRY_WINDOW_MS = 30000;
// Cap on how many URLs we remember, so a long-lived tab cannot grow the marker
// without bound. Well above the handful of screens involved in any real session.
const PH_WRONG_USER_RETRY_MAX_ENTRIES = 20;

// Set once this document has committed to a reload. A page typically fires several
// user-gated requests at once (the IDI screen is the reported case), so without
// this the *second* rejection would skip the retry -- the marker above already
// exists by then -- and bounce to the sub-app root before the reload we just
// scheduled ever commits, reintroducing the dashboard jump.
//
// Only the reload sets this, never the bounce: authHelper.redirectLoggedIn() is
// fire-and-forget and silently no-ops on a malformed cached session (see its own
// comment), so latching on the bounce could swallow every later rejection with no
// navigation and no error at all.
//
// A reload is NOT guaranteed to tear this document down, which is why the latch is
// released on a timer below rather than left to the unload -- see
// PH_WRONG_USER_RELOAD_VETO_MS.
let phWrongUserReloadPending = false;

// How long the latch above may stay set before it is released again.
//
// $window.location.reload() fires beforeunload, and this portal installs handlers
// that *veto* unload: confirm_on_exit.js returns a confirmation string for any
// $dirty registered form (live on ~18 templates, the IDI scope-countries screen
// among them), plus the video-upload guard further down this file,
// admin_advanced_payer_selection.js and payer_expertise_form.component.js. If the
// user answers "Cancel", the reload never commits and the document survives with
// the latch set -- and since nothing else clears it, every later wrong-user
// rejection would return early forever: no reload, no bounce, no dialog
// (toastr.clear() has already run) and no console output. The screen would just sit
// there with blank data, which is strictly worse than the dashboard bounce this
// whole mechanism exists to avoid.
//
// A committed reload tears the timer down with the document, so this only ever
// fires when the reload was actually vetoed. An unload/pagehide listener would not
// work instead: the veto happens before either of those fires.
const PH_WRONG_USER_RELOAD_VETO_MS = 5000;

// Both sessionStorage guards below are deliberately non-fatal, but a silent one is
// indistinguishable from "already retried" or "wasn't a GET" -- and on a
// storage-blocked browser (Safari private, sandboxed iframe, exhausted quota) the
// chain is getItem throws -> setItem throws -> no retry -> historic bounce ->
// dashboard, i.e. RPR-6770's exact symptom silently reintroduced for a whole class
// of browser configuration. So report instead of swallowing.
//
// Sentry loads before the app in every index.html that loads this file, but
// js/sentry.js is a bare Sentry.init() with no captureConsole integration, so the
// console.warn below never reaches it on its own. The guard is not defensive
// styling: this runs inside an error handler, and a blocked vendor bundle must not
// turn a handled rejection into a ReferenceError.
function phReportWrongUserRetryProblem(message, error_) {
  console.warn('portalHelper wrong-user retry: ' + message, error_);
  if (typeof Sentry !== 'undefined' && typeof Sentry.captureMessage === 'function') {
    Sentry.captureMessage('RPR-6770 wrong-user retry: ' + message, 'warning');
  }
}

// Console + Sentry for an error we caught and handled, so handling it does not also
// hide it. Guarded at every step because Sentry is a separate <script> an ad blocker
// can strip. Passes the error object through rather than concatenating it, so the stack
// survives, and puts the variable part in `extra` rather than the event title. Grouping
// differs per branch: captureException fingerprints on the exception type and stack,
// captureMessage on the message. `area` reaches neither -- it is console-only -- so
// adding a caller cannot disturb existing Sentry issue grouping either way.
function phReportCaughtError(area, message, error_) {
  console.warn('portalHelper ' + area + ': ' + message, error_);
  try {
    if (typeof Sentry === 'undefined') {
      return;
    }
    if (typeof Sentry.captureException === 'function') {
      Sentry.captureException(error_, { extra: { reason: message } });
    } else if (typeof Sentry.captureMessage === 'function') {
      Sentry.captureMessage(message, { level: 'warning' });
    }
  } catch (reportingError) {
    console.warn('portalHelper: could not report "' + message + '"', reportingError);
  }
}

// The HTTP methods whose abort showErrorCommon swallows. See the guard itself for why a mutation
// must not be silenced.
//
// This is deliberately a READ-ONLY SUBSET, not a copy of any list elsewhere. In particular it is
// NOT the ['delete', 'get', 'head', 'jsonp'] array HttpAuth builds its cache-aware wrappers from in
// app_common.js: that one includes DELETE, which is a mutation. Do not "resynchronise" the two --
// adding DELETE here would silence aborted deletes, which is precisely what the guard exists to
// prevent.
const PH_ABORT_SILENT_METHODS = new Set(['GET', 'HEAD', 'JSONP']);

// A rejection that reaches showErrorCommon's final branch carrying neither a usable HTTP status nor
// any body is a code fault rather than a transport one -- a TypeError thrown out of a .then, or a
// deliberate app-level `new Error(...)` such as the ones video_upload.js rejects with. An HTTP
// response with a TRUTHY status cannot land here: status_code is now copied off it unconditionally,
// so anything with one takes the template branch instead.
//
// Status 0 is the one response shape that still lands here, and does so on purpose. AngularJS's
// success path leaves status 0 as 0 for a non-file: protocol (see the `0 === c && (c = ...)`
// normalisation in angular.1.8.8.min.js) -- the blocked or opaque cross-origin case. Routing it to
// the template would not help anyone: error_common.html gates its "Response code" line on
// `ng-if="status_code"`, so a bodiless status 0 would render the same empty dialog RPR-6334 is
// about. It gets the message dialog instead, and the report below carries the status rather than
// claiming there was none.
//
// Reported because the dialog such a rejection produces tells the user nothing: before RPR-6334 it
// was literally an empty box, and even with the message it now carries, nobody can say WHAT broke.
// Same shape as the two helpers above; kept separate so Sentry groups it on its own message rather
// than folding code faults in with version-probe failures.
function phReportUnexpectedError(response) {
  console.warn('portalHelper showErrorCommon: rejection carried no usable status and no body', response);
  try {
    if (typeof Sentry === 'undefined') {
      return;
    }
    // instanceof already covers DOMException -- WebIDL puts Error.prototype on its chain, so
    // `new DOMException(...) instanceof Error` is true in every current engine. The stack test is
    // belt and braces for a rejection that is Error-shaped without being an Error: a structured
    // clone across a worker boundary, or a transpiled throw. Either way captureException keeps a
    // usable stack, where captureMessage would throw it away.
    const isThrown = response instanceof Error || 'string' === typeof response?.stack;
    if (isThrown && typeof Sentry.captureException === 'function') {
      Sentry.captureException(response);
    } else if (typeof Sentry.captureMessage === 'function') {
      // A fixed message so Sentry groups these together, with the rejection itself in `extra`.
      // Without the payload every issue in this group is one unactionable line and there is no
      // telling a rejected string from a {} from a mangled response.
      let rendered;
      try {
        rendered = JSON.stringify(response);
      } catch (stringifyError) {
        rendered = Object.prototype.toString.call(response);
      }
      Sentry.captureMessage(
        'RPR-6334 showErrorCommon: rejection with no usable status and no body',
        {level: 'warning', extra: {rejection: rendered, type: typeof response, status: response?.status}}
      );
    }
  } catch (reportingError) {
    console.warn('portalHelper: could not report the unexpected error', reportingError);
  }
}

// For a throw out of checkPortalVersionIfNeeded's own success handler, which is a code fault rather
// than a transport one and so cannot be reported as an HTTP failure. Same shape as
// ahReportStaleSession in auth_helper.js; deliberately NOT folded into
// phReportWrongUserRetryProblem, whose 'RPR-6770 wrong-user retry: ' captureMessage prefix IS
// load-bearing -- captureMessage groups by message, so reusing it would merge portal-version
// events into that issue. The delegation below leaves this function's own Sentry payload
// unchanged (captureException + extra.reason, exactly as before). Its console prefix stays
// byte-exact for log continuity, NOT for Sentry: js/sentry.js is a bare init() with no
// captureConsole integration, so console output never reaches Sentry at all.
function phReportPortalVersionProblem(message, error_) {
  phReportCaughtError('portal-version check', message, error_);
}

function phIsWrongUserResponse(response) {
  // `!Array.isArray(response)` -- note it tests `response`, NOT `response.data` --
  // is carried over verbatim from the original guard. It is almost certainly always
  // true, because an $http response is an object, never a bare array. Do NOT
  // "correct" it to `response.data`: that would change behaviour for every
  // array-bodied response on a path shared by 540 showErrorCommon call sites across
  // 144 files.
  // The typeof check keeps matching to string details only, so a list-valued
  // `detail` is not newly swept in.
  return !!(response?.data && !Array.isArray(response)
    && typeof response.data.detail === 'string'
    && response.data.detail.includes('Only allowed for'));
}

// Only replay idempotent reads. A reload re-runs the document GET and the boot
// requests, which is a sensible retry for a read that lost the session race; it
// replays nothing at all for a rejected mutation, so there is no point reloading
// the page out from under whatever the user was doing.
function phIsReplayableRequest(response) {
  const method = response?.config?.method;
  return typeof method === 'string' && method.toUpperCase() === 'GET';
}

// Attempts are keyed by URL rather than held as a single "last URL" marker.
// With one marker, alternating between two rejecting pages (A -> B -> A) lets B's
// write evict A's and re-arm A for a second reload inside the same window, so the
// bound above was only ever "one reload per *most recent* URL". Keying by URL makes
// it strictly more restrictive, never less -- it can only remove reloads.
function phShouldRetryWrongUser(url, now) {
  let attempts = {};
  try {
    const raw = sessionStorage.getItem(PH_WRONG_USER_RETRY_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    // Only a plain object is usable. Anything else -- including the single
    // {url, ts} marker earlier builds wrote -- is dropped rather than migrated;
    // the worst case is one extra reload on the first rejection after a deploy.
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      attempts = parsed;
    }
  } catch (error_) {
    // Unreadable or corrupt marker. Fall through and overwrite it below rather
    // than bail -- bailing here would leave the corrupt value in place and disable
    // the retry for the rest of the tab's session.
    attempts = {};
    phReportWrongUserRetryProblem('could not read the retry marker; overwriting it', error_);
  }
  const previousTs = attempts[url];
  if (typeof previousTs === 'number' && now - previousTs < PH_WRONG_USER_RETRY_WINDOW_MS) {
    return false;
  }
  // Keep only entries still inside the window, newest first, leaving one slot for
  // this URL -- so the entry we are about to write can never be the one evicted.
  const fresh = {};
  Object.keys(attempts)
    .filter((key) => key !== url
      && typeof attempts[key] === 'number'
      && now - attempts[key] < PH_WRONG_USER_RETRY_WINDOW_MS)
    .sort((a, b) => attempts[b] - attempts[a])
    .slice(0, PH_WRONG_USER_RETRY_MAX_ENTRIES - 1)
    .forEach((key) => {
      fresh[key] = attempts[key];
    });
  fresh[url] = now;
  try {
    sessionStorage.setItem(PH_WRONG_USER_RETRY_KEY, JSON.stringify(fresh));
    return true;
  } catch (error_) {
    // Storage unavailable or full: without a marker we cannot bound the retry, so
    // never retry rather than risk a reload loop. Report it -- this is the path that
    // silently degrades back to the dashboard bounce, and it is otherwise
    // indistinguishable from a legitimately consumed window.
    phReportWrongUserRetryProblem(
      'retry marker is not writable, so the wrong-user retry is disabled for this tab',
      error_
    );
    return false;
  }
}

// Flatten each option's rationale_placeholder to the string field(s) the API expects. The
// placeholder shape follows the type the question was loaded as (see convertScaleOptionsFromResponse),
// not the type being saved - so flatten unconditionally. Hoisted to module scope: it captures
// nothing from the service closure (SonarJS javascript:S7721).
function phConvertScaleOptionsForRequest(options) {
  if (!options || !Array.isArray(options)) {
    return options;
  }
  return options.map(function (option) {
    const transformedOption = angular.copy(option);
    const placeholder = option.rationale_placeholder;
    if (placeholder && typeof placeholder === 'object') {
      // Always send all three: an omitted key leaves the stored value in place, because the
      // API applies a partial update over the posted keys only.
      transformedOption.rationale_placeholder = typeof placeholder['0'] === 'string' ? placeholder['0'] : '';
      transformedOption.rationale_placeholder1 = typeof placeholder['1'] === 'string' ? placeholder['1'] : '';
      transformedOption.rationale_placeholder2 = typeof placeholder['2'] === 'string' ? placeholder['2'] : '';
    } else if (Object.hasOwn(option, 'rationale_placeholder') && typeof placeholder !== 'string') {
      // '' is significant - it is how the author clears the box - so it must be posted, not dropped.
      // An absent key stays absent, so a partial update cannot blank a stored value.
      transformedOption.rationale_placeholder = '';
    }
    return transformedOption;
  });
}

const PH_ON_HOLD_SUFFIX = ' (On-hold)';

// The status maps are built from the portal's own CONSTANTS, so a status the API adds later has no
// label here and reaches the user as a raw snake_case token. Say so once per unknown value: that
// silence is exactly what RPR-6938 was raised for.
const PH_REPORTED_UNKNOWN_STATUSES = new Set();

function phReportUnknownProjectStatus(status) {
  if (PH_REPORTED_UNKNOWN_STATUSES.has(status)) {
    return;
  }
  PH_REPORTED_UNKNOWN_STATUSES.add(status);
  console.warn('portalHelper: unmapped project status from the API: ' + status);
  if (typeof Sentry !== 'undefined' && typeof Sentry.captureMessage === 'function') {
    Sentry.captureMessage('portalHelper: unmapped project status: ' + status, 'warning');
  }
}

// Helpers for portalHelper.flattenValidationErrors (RPR-7017).
function phIsPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function phFlattenErrorValue(value, prefix) {
  if (typeof value === 'string') {
    return [prefix + value];
  }
  if (Array.isArray(value)) {
    return value.flatMap(function (item) { return phFlattenErrorValue(item, prefix); });
  }
  if (phIsPlainObject(value)) {
    return Object.keys(value).flatMap(function (subKey) {
      return phFlattenErrorValue(value[subKey], prefix + subKey + ': ');
    });
  }
  return [];
}

app.service('portalHelper',
  ['SETTINGS', '$timeout', '$location', '$window', 'authHelper', '$ngConfirm', 'apiHelper', '$routeParams',
    'HttpAuth', '$http', '$rootScope', '$filter', '$anchorScroll', 'CONSTANTS', '$compile', 'stringHelper',
    'clientListService', 'tor2Service', 'storageService', '$injector',
    function (SETTINGS, $timeout, $location, $window, authHelper, $ngConfirm, apiHelper, $routeParams,
      HttpAuth, $http, $rootScope, $filter, $anchorScroll, CONSTANTS, $compile, stringHelper, clientListService,
      tor2Service, storageService, $injector) {

      const portalHelperService = this;

      // TTL-based portal version check: re-check every 60 seconds
      const PORTAL_VERSION_CHECK_TTL_MS = 60000;
      let lastPortalVersionCheckTime = 0;

      // Hook called before portal version redirect (e.g., to save survey draft).
      // Must return a promise that resolves when pre-redirect work is done.
      let beforePortalRedirectHook = null;

      portalHelperService.registerBeforePortalRedirect = function (hookFn) {
        beforePortalRedirectHook = hookFn;
      };

      portalHelperService.unregisterBeforePortalRedirect = function () {
        beforePortalRedirectHook = null;
      };

      portalHelperService.payerCountLabel = function (count) {
        return count === 1 ? '1 payer' : count + ' payers';
      };

      // Translates an old-portal hash path (e.g. "/Payers/ViewSurvey/123") to the URL suffix
      // for the new Angular portal. The new portal's routing defines legacy redirects that map
      // "Payers/..." paths to the corresponding new routes, so we just strip the leading slash
      // and hand the path off as-is. Returns '' for empty/root paths.
      portalHelperService.translateLegacyPayerPath = function (oldPath) {
        if (!oldPath || oldPath === '/' || oldPath === '') {
          return '';
        }
        return oldPath.replace(/^\//, '');
      };

      // Build the full new-portal URL for a given old-portal hash path, preserving the path
      // so the payer lands on the same page in the new portal.
      portalHelperService.buildNewPortalUrl = function (oldPath) {
        if (!SETTINGS.NEW_PORTAL_URL) {
          return null;
        }
        const pathSuffix = portalHelperService.translateLegacyPayerPath(oldPath);
        return pathSuffix
          ? SETTINGS.NEW_PORTAL_URL + '/' + pathSuffix
          : SETTINGS.NEW_PORTAL_URL;
      };

      // Check whether the current user should use the new Angular portal, and if so,
      // redirect them there preserving the given old-portal path. Returns a promise that
      // resolves to true if a redirect is in progress (caller should stop) or false
      // otherwise (caller should continue with the default flow). Errors (not authenticated,
      // not a payer, network failure) resolve to false so callers can fall through safely.
      portalHelperService.checkAndRedirectToNewPortalIfPayer = function (oldPath) {
        if (!SETTINGS.NEW_PORTAL_URL) {
          return Promise.resolve(false);
        }
        const url = apiHelper.getApiUrl() + '/api/payer/portal-version/';
        return HttpAuth.get(url).then(
          function (result) {
            if (result.data?.use_legacy_portal === false) {
              $window.location.href = portalHelperService.buildNewPortalUrl(oldPath);
              return true;
            }
            return false;
          },
          function () {
            return false;
          }
        );
      };

      portalHelperService.fix_undefined = function(x) {
        return (typeof x == 'undefined' ? '' : x);
      };

      portalHelperService.convertVWInputsToFloat= function(responses){

        _.map(responses, function(response){
          if (!response.van_westendorp_response){
            return;
          }
          response.van_westendorp_responses.acceptable = parseFloat(response.van_westendorp_responses.acceptable);
          response.van_westendorp_responses.expansive = parseFloat(response.van_westendorp_responses.expansive);
          response.van_westendorp_responses.too_expansive = parseFloat(response.van_westendorp_responses.too_expansive);
          response.van_westendorp_responses.prohibitive = parseFloat(response.van_westendorp_responses.prohibitive);
        });

        return responses;
      };

      // Gets original and shuffled row numbers from the table_responses_2 structure.
      const getOriginalAndShuffledSequence = function (table_responses_2, seed) {
        const row_numbers = _.pluck(table_responses_2, 'row');
        const originalSequence = (_.uniq(row_numbers)).sort(
          function (first, second) {
            return first-second;
          }
        );
        let shuffledSequence = angular.copy(originalSequence);
        shuffledSequence =  portalHelperService.shuffleArrayWithSeed(shuffledSequence, seed);
        return {
          'originalSequence': originalSequence,
          'shuffledSequence': shuffledSequence
        };
      };

      portalHelperService.randomizeTORInputs = function (table_responses_2, seed) {
        const result = getOriginalAndShuffledSequence(table_responses_2, seed);
        const originalSequence = result.originalSequence;
        const shuffledSequence = result.shuffledSequence;

        // Arrange rows in the order of shuffled sequence
        // so that it matches the shuffling of options in question
        let rearranged_rows = [];
        for (let i = 0; i < originalSequence.length; i++) {
          const originalRows = angular.copy(table_responses_2);

          // There are multiple rows in table_responses_2 data structure to represent a single row in TOR (One row in datastructure for each column of a TOR row).
          const rows_with_shuffled_index = _.filter(
            originalRows, {'row': shuffledSequence[i]}
          );

          // Changing only row numbers of TOR datasctructure according to the options in question datastructure.
          _.map(rows_with_shuffled_index, function (item) {
            item.row = originalSequence[i];
          });

          // setting rearranged rows as the rows with suffled indexes.
          rearranged_rows = rearranged_rows.concat(
            rows_with_shuffled_index
          );
        }

        return rearranged_rows;
      };

      portalHelperService.undoRandomizedTORInputs = function (table_responses_2, seed) {
        const result = getOriginalAndShuffledSequence(table_responses_2, seed);
        const originalSequence = result.originalSequence;
        const shuffledSequence = result.shuffledSequence;

        /**
         * Arrange data as per randomized indexes. While reading data from TOR2 for saving
         * responses. It is read with normal indexes and randomizedIndexes are not taken care of.
         * So, we need to arrange data as per randomization done earlier while displaying data.
         *  */
        for (let i = 0; i < table_responses_2.length; i++) {
          const readIndex = table_responses_2[i].row;
          const actualIndex = shuffledSequence[
            originalSequence.indexOf(readIndex)
          ];
          table_responses_2[i].row = actualIndex;
        }

        return table_responses_2;
      };

      portalHelperService.arrangeRandomizedTOR2Inputs = function (responses) {
        _.map(responses, function(response){

          if (response.table_responses_2 && response.randomization_seed){
            portalHelperService.undoRandomizedTORInputs(
              response.randomizedTORInputRows,
              response.randomization_seed
            );
          }

          if (response.randomizedTORInputRows) {
            response.table_responses_2 = response.randomizedTORInputRows;
          }
          // delete response.randomizedTORInputRows;
        });

        return responses;
      };

      const randomizeRatingOptions = function (question, response, seed) {
        let randomizedOptions = [];
        if (question.randomize_options && seed) {
          const copyOfOptions = angular.copy(question.options);
          randomizedOptions = _.sortBy(copyOfOptions, 'option_value');
          portalHelperService.shuffleArrayWithSeed(randomizedOptions, seed);
          for (let i = 0; i < randomizedOptions.length; i++) {
            randomizedOptions[i].option_value = i + 1 ;
          }
        }
        else {
          randomizedOptions = question.options;
        }
        return randomizedOptions;
      };

      const randomizeSliderRatingOptions = function (question, response, seed) {
        let randomizedOptions = [];
        if (question.randomize_options && seed) {
          const copyOfOptions = angular.copy(question.options);
          randomizedOptions = _.sortBy(copyOfOptions, 'option_value');
          portalHelperService.shuffleArrayWithSeed(randomizedOptions, seed);
          for (let i = 0; i < randomizedOptions.length; i++) {
            randomizedOptions[i].option_value = i + 1 ;
          }
        }
        else {
          randomizedOptions = question.options;
        }
        return randomizedOptions;
      };

      const randomizeRadioRankingOptions = function (question, response, seed) {
        let randomizedOptions = [];
        if (!question || !question.scale || !question.scale.options) {
          return randomizedOptions;
        }
        if (question.randomize_options && seed) {
          const copyOfOptions = angular.copy(question.scale.options);
          randomizedOptions = _.sortBy(copyOfOptions, 'sequence_number');
          portalHelperService.shuffleArrayWithSeed(randomizedOptions, seed);
          for (let i = 0; i < randomizedOptions.length; i++) {
            randomizedOptions[i].sequence_number = i + 1 ;
          }
        } else {
          randomizedOptions = question.scale.options;
        }
        return randomizedOptions;
      };

      const randomizeDragAndDropRankingOptions = function (question, response, seed) {
        let randomizedOptions = [];
        /***
           * Different data structure need to be randomized before and after payer has responded
           * When payer has not responded (response.ranking_responses_not_saved) are the options seen by him
           * And when the payer has already responded, he need to be shown (response.ranking_responses)
           */
        let options = question.scale.options;
        if (response && response.ranking_responses_not_saved) {
          options = response.ranking_responses_not_saved;
        }

        if (question.randomize_options && seed) {
          const copyOfOptions = angular.copy(options);
          randomizedOptions = _.sortBy(copyOfOptions, 'option');
          portalHelperService.shuffleArrayWithSeed(randomizedOptions, seed);
          response.ranking_responses_not_saved = randomizedOptions;
        }
        else {
          randomizedOptions = options;
        }
        return randomizedOptions;
      };

      const randomizeTORGroupRows = function (question, response, seed) {
        const TYPE_OF_CELL = tor2Service.TYPE_OF_CELL;
        const INPUT_CELLS = [
          TYPE_OF_CELL.TEXT_BOX, TYPE_OF_CELL.CHECK_BOX, TYPE_OF_CELL.DROP_DOWN
        ];
        let randomizedOptions = [];
        if (question.randomize_options && seed) {
          const data = angular.copy(question.tor2_data.cells);
          outer: for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].length; j++) {
              const isInputCellFound = INPUT_CELLS.indexOf(data[i][j].type) >= 0;
              if (isInputCellFound) {
                let shuffledRows = data.splice(i, data.length);
                portalHelperService.shuffleArrayWithSeed(
                  shuffledRows, seed
                );
                shuffledRows = data.concat(shuffledRows);
                const tor2_data_copy = angular.copy(question.tor2_data);
                tor2_data_copy.cells = shuffledRows;
                randomizedOptions = tor2_data_copy;
                response.randomizedTORInputRows = portalHelperService.randomizeTORInputs(
                  response.table_responses_2,
                  seed
                );
                break outer;
              }
            }
          }
        }
        else {
          // Randomizing the TOR2 Question options
          randomizedOptions = question.tor2_data;

          /* Randomizing the TOR2 Response Options
           * Checking if there is already a `randomizedTORInputRows` in the response - which will
           * be synced with the form values on the page (server response object does not have that
           * attribute). Hence, do not replace that with `table_responses_2` if it is already there.
           */
          if (response && !response.randomizedTORInputRows) {
            response.randomizedTORInputRows = response.table_responses_2;
          }
        }
        return randomizedOptions;
      };

      /**
       * @param {*} question Question object to display question.
       * @param {*} response Response object to display inputs to the question.
       * @param {*} seed This is used to pseudo-randomize the options of a question.
       * @returns This returns the randomizedOptions for a question if randomize_options flag is
       * true and a seed is passed, otherwise options are returned as they are.
       */
      portalHelperService.getRandomizedOptions = function (
        question,
        response,
        seed
      ) {

        if (question.type == CONSTANTS.questionTypeIds.RATING) {
          return randomizeRatingOptions(question, response, seed);
        }
        if (question.type == CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE) {
          return randomizeSliderRatingOptions(question, response, seed);
        }
        else if (question.type == CONSTANTS.questionTypeIds.RADIO_RANKING) {
          return randomizeRadioRankingOptions(question, response, seed);
        }
        else if (question.type == CONSTANTS.questionTypeIds.DRAG_DROP_RANKING) {
          return randomizeDragAndDropRankingOptions(question, response, seed);
        }
        else if (question.type == CONSTANTS.questionTypeIds.TABLE_OF_RESPONSES_2) {
          return randomizeTORGroupRows(question, response, seed);
        }
      };

      portalHelperService.is_randomization_allowed = function (question) {
        return [
          CONSTANTS.questionTypeIds.RATING,
          CONSTANTS.questionTypeIds.RADIO_RANKING,
          CONSTANTS.questionTypeIds.DRAG_DROP_RANKING,
          CONSTANTS.questionTypeIds.TABLE_OF_RESPONSES_2,
          CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE
        ].indexOf(question.type) != -1;
      };

      /** This will generate random number between min and max  */
      portalHelperService.getRandomInt = function (min, max) {
        if (!globalThis.crypto?.getRandomValues) {
          throw new Error('crypto.getRandomValues is not available in this environment');
        }
        const randomBuffer = new Uint32Array(1);
        crypto.getRandomValues(randomBuffer);
        return Math.floor((randomBuffer[0] / 4294967296) * (max - min + 1) + min);
      };

      /***
       * Generates a random 9 character ID
       * For example: v8rw6k6xb, yn487078q
       * @return {string}
       */
      portalHelperService.generate_random_id = function () {
        const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
        const array = new Uint8Array(9);
        crypto.getRandomValues(array);
        let id = '';
        for (const byte of array) {
          id += alphabet.charAt(byte % alphabet.length);
        }
        return id;
      };

      /***
       * Converts each word in a sentence into a word starting with a capital letter.
       * @param text
       * @returns {string}
       */
      portalHelperService.getTitleCase = function (text) {
        const sentence = text.toLowerCase().split(' ');
        for (let i = 0; i< sentence.length; i++){
          sentence[i] = this.getSentenceCase(sentence[i]);
        }

        return sentence.join(' ');
      };

      /***
       * Converts the first character of a string into a capital letter.
       * @param text
       * @returns {string}
       */
      portalHelperService.getSentenceCase = function (text) {
        return text[0].toUpperCase() + text.slice(1);
      };

      /***
       * RPR-6713: small inline badge describing a video's Mux processing
       * status. Returns '' for ready/archived (playable) videos so only
       * not-ready ones are flagged. Used by the video picker and survey form.
       * @param {string} status mux_processing_status value
       * @returns {string} HTML for the badge, or '' when playable / unknown
       */
      // Shared instances rather than a fresh object per call: the survey, question and
      // section templates call videoStatusBadge() from ng-if/ng-class, i.e. on every
      // digest for every attached document.
      const PH_BADGE_PROCESSING = { label: 'Processing', cls: 'video-status-badge video-status-processing' };
      const PH_BADGE_ERRORED = { label: 'Errored', cls: 'video-status-badge video-status-errored' };
      const PH_BADGE_DELETED = { label: 'Deleted', cls: 'video-status-badge video-status-errored' };
      // RPR-6923: the poller's synthetic 'timed_out'. Deliberately the PROCESSING class, not
      // the errored one -- the asset is still transcoding as far as anyone knows; what ran out
      // was our patience or our ability to ask. Same wording as BOTH of the Document Manager's
      // `upload.status === 'timed_out'` badges (client_document_manager.html splits the two
      // give-up flavours to correct one tooltip and keeps this label on each) and the
      // associated-documents row's `takingLonger` pill, so a stall cannot be described three
      // ways across the three surfaces that render it. This badge is picked from the status
      // word alone, so it says the same for a lost-contact give-up too -- where
      // associated_documents shows its "Status unavailable" note in place of the pill.
      const PH_BADGE_TAKING_LONGER = {
        label: 'Processing (taking longer)', cls: 'video-status-badge video-status-processing'
      };

      /***
       * RPR-6719 (QA re-open 2): the single status -> badge mapping. It used to exist
       * only as an HTML-string builder for DataTables, so the Angular templates that
       * needed the same badge hand-inlined their own copy of the rules -- and
       * question_form.html never got one at all, leaving QA's own surface with no
       * indication that an attached video had failed. Returns null when there is
       * nothing to show (ready / archived / not a video).
       * @param {string} status mux_processing_status value
       * @returns {?{label: string, cls: string}}
       */
      portalHelperService.videoStatusBadge = function (status) {
        const statuses = CONSTANTS.videoProcessingStatuses;
        switch (status) {
          case statuses.PROCESSING:
          case statuses.UPLOADING:
            return PH_BADGE_PROCESSING;
          case statuses.ERRORED:
            return PH_BADGE_ERRORED;
          case statuses.SOFT_DELETED:
            return PH_BADGE_DELETED;
          // RPR-6923: a literal, not a CONSTANTS key, because 'timed_out' is not a backend
          // status -- videoProcessingStatuses holds only words the API sends. The poller
          // synthesises this one client-side for two cases, a stall / hard-ceiling timeout
          // (RPR-6752) and a give-up after repeated poll failures (RPR-6923), and
          // phSyncVideoPickerRowStatus writes it straight into the picker row's
          // mux_processing_status. videoAttachableStatuses now INCLUDES 'timed_out' (this
          // PR), so the row stays tickable in the picker -- but with no case here it would
          // still render with no badge and no explanation for why a "timed_out" video is
          // selectable at all. This badge is that explanation, not a disabled-row fix.
          case 'timed_out':
            return PH_BADGE_TAKING_LONGER;
          default:
            // ready, archived, '' (non-video) -> no badge
            return null;
        }
      };

      // String adapter over the mapping above, for the DataTables render context.
      portalHelperService.videoStatusBadgeHtml = function (status) {
        const badge = portalHelperService.videoStatusBadge(status);
        return badge ? ' <span class="' + badge.cls + '">' + badge.label + '</span>' : '';
      };

      /***
       * RPR-6713: deep link to where a not-ready video is attached, so the
       * author can jump straight to fixing it. Survey-document/section
       * attachments open the relevant country tab (sections also scroll to and
       * expand the element via ?layout_element_id); question attachments open
       * the question inline. Returns '' when we lack the owner to build a link.
       * @param {number} surveyId
       * @param {number} ownerId survey owner (client user) id
       * @param {object} location one entry from a not_ready_videos[].attachments
       * @returns {string} hash URL into the questionnaire editor
       */
      portalHelperService.videoAttachmentUrl = function (surveyId, ownerId, location) {
        if (!ownerId) {
          return '';
        }
        let url = '#/Admin/ManageQuestions/' + surveyId + '/' + ownerId;
        if (location.type === 'question' && location.survey_country_id && location.question_id) {
          url += '/Country/' + location.survey_country_id + '/question/' + location.question_id;
        } else if (location.survey_country_id) {
          url += '/Country/' + location.survey_country_id;
          if (location.layout_element_id) {
            url += '?layout_element_id=' + location.layout_element_id;
          }
        }
        return url;
      };

      /***
       * RPR-6713: human label for a not-ready video's attachment location,
       * including the country so multi-country surveys are unambiguous.
       * @param {object} location one entry from a not_ready_videos[].attachments
       * @returns {string}
       */
      portalHelperService.videoLocationLabel = function (location) {
        const prefixes = {
          survey_document: 'Survey documents',
          section: 'Section',
          question: 'Question'
        };
        let label = prefixes[location.type] || 'Attachment';
        if (location.type !== 'survey_document' && location.label) {
          label += ' "' + location.label + '"';
        }
        if (location.country_name) {
          label += ' — ' + location.country_name;
        }
        return label;
      };

      /***
       * RPR-6713: DataTable render for the video picker's selection checkbox.
       * Gates selection on processing status -- a ready/processing video is
       * attachable (processing self-heals), errored/soft-deleted/still-uploading
       * is not. Defined as a named method (not an inline column callback) to
       * keep the picker's render functions from nesting too deeply.
       *
       * RPR-6719 (QA re-open 2): this function existed since RPR-6713 but was
       * wired to NOTHING -- the videos column carried its own inline render that
       * only ever looked at `is_attached`, so no video was ever gated on its
       * processing status and an errored clip stayed selectable. The RPR-6721
       * attached-row behaviour is folded in here so the column has a single
       * render and the two rules cannot drift apart again.
       */
      portalHelperService.renderVideoPickerCheckbox = function (data, type, row) {
        // RPR-6721: attached videos are read-only -- a disabled (checked) checkbox
        // shows they're already in; the "Attached" tag sits beside the name.
        // Add-Selected collectors skip :disabled.
        if (row.is_attached) {
          return [
            '<div class=\'center aligned\'>',
            '<input type=\'checkbox\' checked disabled title=\'Already attached to this survey\' />',
            '</div>'
          ].join('\n');
        }
        const attachable = CONSTANTS.videoAttachableStatuses.includes(row.mux_processing_status);
        const disabledAttr = attachable
          ? ''
          : ' disabled title=\'This video is not ready to attach (' +
            _.escape(row.mux_processing_status || 'unknown') + ').\'';
        return [
          '<div class=\'center aligned\'>',
          '<input type=\'checkbox\' data-id=\'' + data + '\' id=\'video-id-' + data + '\'' + disabledAttr + ' />',
          '</div>'
        ].join('\n');
      };

      /***
       * RPR-6713: DataTable render for the video picker's name cell -- the file
       * name plus a Mux processing-status badge so the author understands a
       * disabled row. Named method to avoid deeply nested column callbacks.
       *
       * RPR-6719 (QA re-open 2): as with the checkbox above, this was orphaned and
       * the column rendered its own name cell with no status badge -- so a disabled
       * row would have carried no explanation. The RPR-6721 attached/replaced tags
       * and the RPR-6754 hover tooltip are folded in.
       */
      portalHelperService.renderVideoPickerNameCell = function (data, type, row) {
        const nameClass = row.is_attached ? ' class=\'attached-doc-name\'' : '';
        // RPR-6721: a freshly-overwritten clip reads "Replaced" (green) for this
        // picker session; otherwise the usual "Attached" pill.
        let tag = '';
        if (row.is_recently_replaced) {
          tag = '<span class=\'replaced-tag\' title=\'Just replaced\'>Replaced</span>';
        } else if (row.is_attached) {
          tag = '<span class=\'attached-tag\' title=\'Already attached to this survey\'>Attached</span>';
        }
        // RPR-6754: title tooltip so long ellipsis-truncated names stay readable.
        const escapedName = _.escape(data);
        return '<label' + nameClass + ' title=\'' + escapedName + '\'>' + escapedName + '</label>' +
          tag + portalHelperService.videoStatusBadgeHtml(row.mux_processing_status);
      };

      /***
       * RPR-6719 (QA re-open 2): the picker hands back raw checkbox ids, which have to
       * be resolved against the cached document list before anything is attached.
       * Shared by all three attach paths -- survey country, question and section -- so
       * an id the cache cannot resolve behaves the same way in each. Before this they
       * behaved three different ways: the question and survey-country paths each had
       * their own inline _.findWhere and pushed angular.copy(undefined) when it missed
       * -- which is what broke the render and then the save -- while the section path
       * used a separate ===-matching loop that could not push undefined but dropped the
       * id in silence instead. QA hit the question path; the country path had the same
       * shape and the same latent bug.
       *
       * Everything normalises because the id sources disagree on type: jQuery's
       * .data('id') coerces a numeric id to Number, while API records and angular.copy'd
       * documents can carry either.
       */
      portalHelperService.normalizeDocumentId = function (id) {
        const parsed = Number.parseInt(id, 10);
        return Number.isNaN(parsed) ? null : parsed;
      };

      portalHelperService.findDocumentById = function (documents, id) {
        const normalizedId = portalHelperService.normalizeDocumentId(id);
        if (normalizedId === null || !Array.isArray(documents)) {
          return null;
        }
        for (const doc of documents) {
          if (portalHelperService.normalizeDocumentId(doc?.id) === normalizedId) {
            return doc;
          }
        }
        return null;
      };

      // Deliberately expressed in terms of the finder rather than a second copy of the
      // same loop, so the two can never disagree about what "same document" means.
      portalHelperService.hasDocumentWithId = function (documents, id) {
        return portalHelperService.findDocumentById(documents, id) !== null;
      };

      /***
       * Tell the author when a selection silently went nowhere, i.e. an id the picker
       * handed back that the re-read list no longer contains.
       *
       * CAREFUL with the wording here. RPR-6719 round 2 (a6bfea9d7,
       * exclude_failed_video_uploads) drops errored-and-unattached videos from the
       * listing endpoints, which is the tidiest way for an id to stop resolving -- but
       * that commit is on uat and is NOT on develop, where the only exclusion is
       * exclude_incomplete_video_uploads (RPR-6745: still 'uploading' with no asset id).
       * So on develop the errored clip is still listed and this path is the backstop to
       * the picker gate rather than the common case. The message therefore says what we
       * observed ("no longer in the list") and offers the likely cause, and deliberately
       * does NOT promise that failed videos are removed automatically -- that would read
       * as a lie until the backend half merges down. "No longer available" on its own
       * sent QA hunting for a ghost, hence naming a cause and a way out at all.
       */
      portalHelperService.showSkippedDocumentsWarning = function (skippedIds) {
        const normalized = [];
        for (const skippedId of skippedIds || []) {
          const id = portalHelperService.normalizeDocumentId(skippedId);
          if (id !== null && !normalized.includes(id)) {
            normalized.push(id);
          }
        }
        if (!normalized.length) {
          return;
        }
        const single = normalized.length === 1;
        portalHelperService.showToast(
          CONSTANTS.typeOfToasts.WARNING,
          (single
            ? 'One selected document could not be attached because it is'
            : normalized.length + ' selected documents could not be attached because they are')
          + ' no longer in the list. The usual cause is a video that failed to process'
          + ' — please re-upload ' + (single ? 'it' : 'them') + ' and try again.',
          'Documents not attached'
        );
      };

      // Fetch client user's ID. This shouldn't be called from Admin portal.
      portalHelperService.fetchClientUserId = function (loginData) {

        if ($routeParams.clientUserId){
          return parseInt($routeParams.clientUserId);
        }
        else {
          const isClientPortal = $location.absUrl().indexOf('client/#/Client') !== -1;
          if (loginData != undefined && loginData.me != undefined && isClientPortal) {
            return loginData.me.id;
          }
        }

        return null;
      };


      /** This function is responsible to select the client user before going to the create survey screen
       * Any controller can pass clientUsers and it's scope in this method
       * to reach /admin/#/Admin/CreateSurvey/{{surveyId}}/{{clientUserId}}
      */
      portalHelperService.selectClientUserToCreateSurvey = function(clientUsers, $scope){

        const clientUserColumns = [
          {
            data: 'full_name',
            title: 'Client User'
          },
          {
            data: 'client_name',
            title: 'Client'
          },
          {
            data: 'client_code',
            title: 'Client ID'
          },
          {
            data: null,
            orderable: false,
            render: function(data, type, row){
              return '<button ng-click="setClientUserId('+ row.id +')" class="mat ui primary small wide button">Select</button>';
            }
          }
        ];

        const clientSelectionWindow = $ngConfirm({
          'title': 'Please select client user to associate this survey with:',
          'columnClass': 'large',
          'contentUrl': '../' + 'html_templates/dialogs/client_users_list.61002edd.html',
          'type': 'blue',
          'scope': $scope,
          onReady: function (scope) {
            scope.users_table = $('#client-users').DataTable({
              autoWidth: true,
              data: dataTableSafeData(clientUsers),
              ordering: true,
              order: [[0, 'asc']],
              pagingType: 'full_numbers',
              scrollX: false,
              columns: clientUserColumns,
              createdRow: function (row, data, index) {
                $compile(angular.element(row).contents())($scope);
              },
              initComplete: function (settings, json) {
                // Wait a bit to make datatable recalculate it's dimensions to be responsive
                $timeout(function () {
                  angular.element('#' + $scope.tableId)
                    .DataTable()
                    .columns
                    .adjust()
                    .responsive
                    .recalc();
                  preventDataTableMenuClipping();

                  $scope.tableInitComplete = true;
                }, 500);
              }
            });
          }
        });

        $scope.setClientUserId = function(clientUserId){
          $scope.clientUserId = clientUserId;
          clientSelectionWindow.close();
        };

        return clientSelectionWindow;

      };

      portalHelperService.setupProjectCodeDetailsForUI = function (project) {
        project.client_code_part = '';
        project.licence_code_part = '';

        if (project.licence_code && project.licence_code.length > 5) {
          project.client_code_part = project.licence_code.substr(0, (project.licence_code.length - 2));
          project.licence_code_part = project.licence_code.substr(project.licence_code.length - 2);
        }

        return project;
      };

      portalHelperService.setupProjectCodeDetailsForAPI = function (project) {
        if (project.client_code_part != null && project.licence_code_part != null) {
          project.licence_code = [
            project.client_code_part,
            project.licence_code_part].join('');

          project.project_code = [
            project.licence_code,
            project.code,
            '_',
            project.topic
          ].join('');
        }

        return project;
      };

      portalHelperService.generateId = function (length) {
        // 62 Characters in our character set.
        const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let id = '';
        const characters = [];

        for (let i = 0; i < length; i++) {
          const randomIndex = portalHelperService.getRandomInt(0, 62);
          characters.push(alphabet[randomIndex]);
        }

        id = characters.join('');
        return id;
      };

      portalHelperService.exportResponseStatuses = {
        'rejected': {
          'title': 'Payer Rejected Survey',
          'description': 'Payer has rejected the survey assignment.',
          'class': 'fa fa-times fa-fw red-icon'
        },
        'waiting_for_response': {
          'title': 'Waiting for survey response',
          'description': 'Payer has accepted the assignment but survey responses are in draft stage.',
          'class': 'fa fa-fw fa-clock-o orange-icon'
        },
        'waiting_for_admin_approval': {
          'title': 'Waiting for admin approval',
          'description': 'Payer has submitted responses but admin needs to approve them.',
          'class': 'fa fa-fw fa-exclamation-triangle red-icon'
        },
        'not_sent_clarification': {
          'title': 'Clarification not sent to payer as yet',
          'description': 'Admin has raised a clarification request but survey is not returned to payer.',
          'class': 'fa fa-fw fa-hourglass-o orange-icon'
        },
        'pending_clarification': {
          'title': 'Waiting for clarification response',
          'description': 'Survey has been returned to payer for clarification response.',
          'class': 'fa fa-fw fa-clock-o orange-icon'
        },
        'clarification_response_submitted': {
          'title': 'Clarification response submitted by Payer',
          'description': 'Payer has submitted clarification response.',
          'class': 'fa fa-fw fa-cloud-download blue-icon'
        },
        'response_approved': {
          'title': 'All responses approved',
          'description': 'All responses approved by admin.',
          'class': 'fa fa-fw fa-check-circle green-icon'
        },
        'expired': {
          'title': 'Survey assignment expired',
          'description': 'Payer has not responded even after extended end date.',
          'class': 'fa fa-fw fa-calendar red-icon'
        },
        'overdue': {
          'title': 'Overdue',
          'description': 'Payer has not responded before assignment end date.',
          'class': 'fa fa-fw fa-calendar red-icon'
        }
      };

      portalHelperService.getExportResponseStatus = function (status) {
        return portalHelperService.exportResponseStatuses[status];
      };

      // Relative URLs are not used directly in our codebase.
      // Because our plugin to append hash can't work properly on relative URLs.
      // Removing this function breaks the revAll plugin used in gulpfile.js
      portalHelperService.getUrl = function (relUrl) {
        return '../' + relUrl;
      };

      portalHelperService.prevent_dblclick = function () {
        return false;
      };

      portalHelperService.columnUserListTfaHidden = {
        data: null,
        className: 'skipCol',
        visible: false,
        render: function (data, type, row) {

          if (row.tfa_configured) {
            return 1;
          }

          // mandatory, but not configured
          if (row.tfa_mandatory) {
            return 2;
          }

          // not mandatory: gray circle
          return 3;
        }
      };

      portalHelperService.columnUserListTfaVisible = {
        title: '2FA',
        data: null,
        orderData: [1],
        className: 'center aligned',
        render: function (data, type, row) {
          // show yes/no/Pending in export
          if ('export' === type) {
            if (row.tfa_configured) {
              return 'Active';
            }
            // mandatory, but not configured
            if (row.tfa_mandatory) {
              return 'Inactive (Mandatory)';
            }
            // not mandatory: gray circle
            return 'Inactive';
          }

          if (row.tfa_configured) {
            return '<i class="fa fa-check-circle green-icon"></i>';
          }

          // mandatory, but not configured
          if (row.tfa_mandatory) {
            return '<i class="fa fa-dot-circle-o blue-icon"></i>';
          }

          // not mandatory: gray circle
          return '<i class="fa fa-circle"></i>';
        }
      };

      portalHelperService.getGaborGrangerFirstPrice = function (q) {
        const price = q.pricing_model.display_decimal_points_in_pricing ? parseFloat(q.pricing_model.first_price).toFixed(1) : Math.trunc(q.pricing_model.first_price);
        if (q.pricing_model.use_percentage_instead_of_currency) {
          return price + '%';
        } else if (q.pricing_model.currency) {
          return q.pricing_model.currency + ' ' + price;
        }

        return price;
      };

      portalHelperService.formatGaborGrangerQuestionText = function(text, currency, price, displayDecimalPoints, pricingModel) {
        const locale = navigator.language || navigator.userLanguage;

        const formattedPrice = displayDecimalPoints
          ? parseFloat(price).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
          : Math.trunc(price).toLocaleString(locale);

        if (pricingModel.use_percentage_instead_of_currency) {
          return text.replace('#price#', `<span class="animate"> ${formattedPrice}%</span>`);
        }

        return text.replace('#price#', `<span class="animate">${currency} ${formattedPrice}</span>`);
      };

      this.getUrlRev = function (relUrl) {
        return portalHelperService.getUrl(relUrl);
      };

      portalHelperService.convert_to_local_time = function (utcTime, time_format) {
        if (utcTime != null) {
          if (!time_format) {
            return moment(utcTime)
              .local()
              .format(CONSTANTS.dateTimeFormatMoment.MEDIUM_24H_TIME_SEC);
          } else {
            return moment(utcTime).local().format(time_format);
          }
        }

        return '';
      };

      /**
       * @elem        This is querySelector for the element you wish to scroll to
       * @offset      This is the offset you want with respect to the element's position
       * @duration    This is the time in milliseconds you want to take for the animation while scrolling
       */
      portalHelperService.scrollToElement = function (elem, offset, duration) {
        if (!duration) {
          duration = 500;
        }

        if (!offset) {
          offset = 0;
        }

        if ($(elem) != null && $(elem).offset() != null) {
          $([document.documentElement, document.body]).animate({
            scrollTop: $(elem).offset().top + offset
          }, duration);
        }
      };

      portalHelperService.getDisplayWidth = function () {
        if (screen.width && !window.devicePixelRatio) {
          return screen.width;
        }

        if (screen.width && window.devicePixelRatio) {
          return Math.round(screen.width * window.devicePixelRatio);
        }

        return 0;
      };

      portalHelperService.getDisplayHeight = function () {
        if (screen.height && !window.devicePixelRatio) {
          return screen.height;
        }

        if (screen.height && window.devicePixelRatio) {
          return Math.round(screen.height * window.devicePixelRatio);
        }

        return 0;
      };

      portalHelperService.showSurveyPopup = function (surveyId, countryId, screen_width, screen_height, popupHash) {
        if (portalHelperService.globalPopup && portalHelperService.globalPopup.opener) {
          portalHelperService.globalPopup.focus();
          return portalHelperService.globalPopup;
        }

        angular.element('html, body').css({
          overflow: 'hidden',
          height: '100%'
        });

        $('.navbar-nav li a').css('z-index', '2');
        $('.menu-container').css('z-index', '2');
        $('.overlay').css('display', 'block');

        let popupWidth;
        let popupHeight;
        if (!screen_width) {
          popupWidth = portalHelperService.getDisplayWidth() * 0.85;
          popupHeight = portalHelperService.getDisplayHeight() * 0.90;
        } else {
          popupWidth = screen_width * 0.85;
          popupHeight = screen_height * 0.90;
        }

        const options = 'toolbars=0, toolbar=no, location=no, scrollbars=yes, resizable=yes, top=150, left=150, width='
          + popupWidth + ', height=' + popupHeight;

        portalHelperService.globalPopup = portalHelperService.popup_window_open(($location.absUrl()
          .split('#')[0] + popupHash +
          surveyId + '/' + countryId + '?insidePopup=true'),
        'surveyPopup', options);

        return $timeout(function () {
          portalHelperService.globalPopup.onunload = function () {
            portalHelperService.globalPopup = null;
            angular.element('html, body').css({
              overflow: 'auto',
              height: 'auto'
            });

            $('.navbar-nav li a').css('z-index', 'auto');
            $('.overlay').css('display', 'none');
            $('.menu-container').css('z-index', '10');
          };
        }, 1000);
      };

      portalHelperService.reset_form_field = function (form, field_name) {
        let dirty_count = 0;
        angular.forEach(form, function (element, name) {
          if (name.indexOf('$') !== 0) {
            // element is a form element!

            if (name == field_name) {
              element.$setPristine();
              element.$setUntouched();
            } else if (element.$dirty) {
              dirty_count += 1;
            }
          }
        });

        if (!dirty_count) {
          form.$setPristine();
          form.$setUntouched();
        }
      };

      portalHelperService.getFullAddress = function (user, country, detail_lists) {
        // Constructing the address
        let payer_address = [];
        if (user.address) {
          payer_address = user.address.split('\n');
        }

        if (user.address_line1) {
          payer_address.push(user.address_line1);
        }

        if (user.address_line2) {
          payer_address.push(user.address_line2);
        }

        let lastAddressLine = '';
        if (user.address_line3) {
          lastAddressLine = user.address_line3;
        }
        if (user.address_line4) {
          lastAddressLine += ', ' + user.address_line4;
        }

        if (lastAddressLine.indexOf(', ') === 0) {
          lastAddressLine = lastAddressLine.substring(2);
        }

        if (lastAddressLine !== '') {
          lastAddressLine += ' ';
        }

        lastAddressLine += (user.postcode || '');

        if (lastAddressLine != '') {
          payer_address.push(lastAddressLine);
        }

        if (country && detail_lists && detail_lists.country_of_residence) {
          const country_name = $filter('filter')(
            detail_lists.country_of_residence,
            { 'id': country },
            true);
          if (country_name) {
            payer_address.push(country_name[0].name);
          }
        }

        return payer_address.join('<br />');
      };

      portalHelperService.get_clarification_count = function (response) {
        let count = 0;

        if (response.clarification_request) {
          count = 1;  // Clarification counts as 1
        }

        if (!response.clarification_response) {
          return count;
        }

        const histories = response.clarification_response.rejection_history;
        const historyDateResponses = [];

        histories.forEach(function (val) {
          // we cant use isNullOrEmpty, as payer may submit blank clarification
          if (val.clarification !== null) {
            count += 1;
          }

          if (!stringHelper.isNullOrEmpty(val.reason)) {
            count += 1;
          }

          if (!stringHelper.isNullOrEmpty(val.response_datetime)) {
            historyDateResponses.push(val.response_datetime);
          }
        });

        // Getting the last payer response date
        const lastPayerResponseDate = historyDateResponses.length > 0
          ? Math.max(historyDateResponses.map(function (t) {
            return new Date(t).getTime();
          }))
          : new Date(0).getTime();

        if (new Date(response.clarification_response.submission_datetime).getTime() > lastPayerResponseDate) {
          count += 1;
        }

        return count;
      };

      portalHelperService.toggle_rejection_body = function (clarId) {
        const headerDiv = $('#rejection-history-title-' + clarId);
        const bodyDiv = $('#rejection-history-body-' + clarId);

        if (bodyDiv.css('display') === 'none') {
          headerDiv.find('i').removeClass('fa-caret-down').addClass('fa-caret-up');
          headerDiv.find('.rejection-history-count').fadeOut();
          bodyDiv.slideDown();
        } else {
          $('#rejection-history-body-' + clarId + ' .reviewer-rejection:last').removeClass('border-glow-animation');

          headerDiv.find('i').removeClass('fa-caret-up').addClass('fa-caret-down');
          headerDiv.find('.rejection-history-count').fadeIn();
          bodyDiv.slideUp();
        }
      };

      portalHelperService.highlight_clarification = function (clarId, questionId) {

        const divToHighlight = $('#latest-request-' + clarId);
        portalHelperService.scrollToElement('#latest-request-' + clarId, -250);
        divToHighlight.addClass('border-glow-animation');

      };

      portalHelperService.is_last_payer_clarification = function (response) {
        if (!response.clarification_response) {
          return;
        }

        const dateOfSubmission = new Date(response.clarification_response.submission_datetime).getTime();
        const historyDateResponses = [];

        response.clarification_response.rejection_history.forEach(function (t) {
          if (!stringHelper.isNullOrEmpty(t.response_datetime)) {
            historyDateResponses.push(new Date(t.response_datetime).getTime());
          }
        });

        return historyDateResponses.length === 0 || dateOfSubmission > Math.max.apply(Math,
          historyDateResponses);
      };

      portalHelperService.validateNewPasswords = function (scope, password1, password2) {
        // optional parameter: scope.username
        scope.error_list = [];

        const regex_special_char = /[!@#$%^&+=*<>?]/;
        const regex_digit = /[\d]+/;
        const regex_small_letter = /[a-z]+/;
        const regex_capital_letter = /[A-Z]+/;

        let all_regex_ok = true;

        if (scope.username && password1.indexOf(scope.username) !== -1) {
          scope.error_list.push('Password can\'t contain username');
          all_regex_ok = false;
        }

        if (!regex_special_char.test(password1)) {
          scope.error_list.push('Password must contain at least 1 special character');
          all_regex_ok = false;
        }

        if (!regex_digit.test(password1)) {
          scope.error_list.push('Password must contain at least 1 digit');
          all_regex_ok = false;
        }

        if (!regex_small_letter.test(password1)) {
          scope.error_list.push('Password must contain at least 1 lower case letter');
          all_regex_ok = false;
        }

        if (!regex_capital_letter.test(password1)) {
          scope.error_list.push('Password must contain at least 1 upper case letter');
          all_regex_ok = false;
        }

        if (!all_regex_ok) {
          return;
        }

        if (!scope.password_show) {
          if (!password2) {
            scope.error_list.push('Please confirm password');
            return;
          }

          if (password1 !== password2) {
            scope.error_list.push('Passwords do not match');
            return;
          }
        }

        return true;
      };

      portalHelperService.fixLeadingZero = function (number, digit_count) {
        const cur_number = '' + number;
        const zeroes = Array(digit_count + 1).join('0');
        return (zeroes + cur_number).slice(-digit_count);
      };

      portalHelperService.getNumberSuffix = function (i) {
        const j = i % 10,
          k = i % 100;
        if (j === 1 && k !== 11) {
          return 'st';
        }
        if (j === 2 && k !== 12) {
          return 'nd';
        }
        if (j === 3 && k !== 13) {
          return 'rd';
        }
        return 'th';
      };

      portalHelperService.getMaxUploadSize = function () {
        // use value from settings or 20 Mb as default
        return (SETTINGS.MAX_UPLOAD_SIZE) ? SETTINGS.MAX_UPLOAD_SIZE : 20971520;
      };

      // RPR-7017: Croppie re-encodes the cropped image and its default output format is PNG, so the
      // format has to be asked for explicitly or a .jpg upload is sent as PNG bytes. Croppie only
      // supports 'jpeg' | 'png' | 'webp'; anything else (gif, bmp, no type) maps to 'png'.
      portalHelperService.croppieOutputFormat = function (mimeType) {
        const formats = { 'image/jpeg': 'jpeg', 'image/png': 'png', 'image/webp': 'webp' };
        return formats[String(mimeType || '').toLowerCase()] || 'png';
      };

      // RPR-7017: names a file after the format of the bytes it actually holds. The backend checks
      // the content against the extension, so "photo.jpg" carrying PNG bytes is rejected. A filename
      // whose extension already matches the MIME family is returned unchanged; an unknown MIME type
      // leaves the name alone.
      portalHelperService.filenameForImageMime = function (filename, mimeType) {
        const extensionsByMime = { 'image/jpeg': ['jpg', 'jpeg'], 'image/png': ['png'], 'image/webp': ['webp'] };
        const accepted = extensionsByMime[String(mimeType || '').toLowerCase()];
        if (!accepted) {
          return filename;
        }
        const dotIndex = filename.lastIndexOf('.');
        const currentExtension = dotIndex === -1 ? '' : filename.slice(dotIndex + 1).toLowerCase();
        if (accepted.includes(currentExtension)) {
          return filename;
        }
        const stem = dotIndex === -1 ? filename : filename.slice(0, dotIndex);
        return stem + '.' + accepted[0];
      };

      // RPR-7017: decodes a cropped image's data URL into the File that is uploaded. The name is
      // re-derived from the data URL's MIME type rather than the chosen file, because the canvas can
      // emit a different format (gif/bmp come out as PNG).
      portalHelperService.imageFileFromDataUrl = function (dataUrl, filename) {
        const base64String = dataUrl.split(',')[1];
        const mimeType = dataUrl.split(',')[0].split(':')[1].split(';')[0];
        const binary = atob(base64String);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.codePointAt(i));
        }
        return new File([new Uint8Array(array)], portalHelperService.filenameForImageMime(filename, mimeType),
          { type: mimeType });
      };

      // RPR-7017: turns a DRF 400 body into {field: [message, ...]} for the 400 dialog. A nested
      // serializer (many=True) yields a list of dicts, e.g. {"image_files": [{}, {"file": ["msg"]}]},
      // which the dialog used to print as "[object Object]". Nested messages are prefixed with their
      // sub-key ("file: msg"); the empty {} DRF emits for each valid list item is dropped. Messages
      // are not escaped: the template renders them with ng-bind-html, and some contain <br />.
      portalHelperService.flattenValidationErrors = function (data) {
        const flattened = {};
        if (Array.isArray(data)) {
          // DRF's body for a bare `raise ValidationError("msg")` is a top-level list. The empty key
          // lets the dialog show the messages without a "key:" label.
          flattened[''] = phFlattenErrorValue(data, '');
          return flattened;
        }
        if (!phIsPlainObject(data)) {
          return flattened;
        }
        Object.keys(data).forEach(function (key) {
          flattened[key] = phFlattenErrorValue(data[key], '');
        });
        return flattened;
      };

      portalHelperService.popupDateOptionsAny = {
        maxDate: new Date(2050, 5, 22),
        minDate: new Date(1970, 1, 1),
        startingDay: 1,
        showWeeks: false
      };

      portalHelperService.truncateString = function (val, max_length) {
        if (val && val.length > max_length) {
          val = val.substr(0, max_length) + '...';
        }

        return val;
      };

      // TODO: remove this function
      portalHelperService.getTemplateUrl = function (url) {
        return url;
      };

      portalHelperService.impersonateByAdmin = function (user_id) {
        // The page the admin is on now — the backend stores it in the session and
        // returns it from end_impersonation so "Finish Access" comes back here (RPR-6770).
        const impersonatedFromUrl = $window.location.href;
        const data = { 'user_id': user_id, 'return_url': impersonatedFromUrl };
        const myDetails = portalHelperService.getMyDetails();
        // Saving information for admin user in local storage before starting impersonation
        authHelper.setLogin(myDetails, true);

        HttpAuth.post(apiHelper.getApiUrl() + '/auth/start_impersonation/', data)
          .then(
            function (response) {
              // Deprecated (RPR-6770): remove next release. Local copy is a
              // mid-deploy fallback only — the session is now the source of truth.
              // Written only on success so a rejected start can't leave a stale value.
              localStorage.setItem('impersonated_from_url', impersonatedFromUrl);
              authHelper.setImpersonationData();
              authHelper.isLoggedIn().then(
                function (result) {
                  if (result) {
                    authHelper.setLogin(result.data, false);
                  }
                  // If the backend returned a redirect URL (e.g. new payer portal), use it.
                  // Deprecated (RPR-6770): the returnUrl query param only feeds the
                  // payer portal's fallback path now; remove next release.
                  //
                  // Load-bearing for RPR-6770, so do not collapse this branch into the else. This is
                  // the only redirectLoggedIn() reached with the impersonation target's session in
                  // cache (isLoggedIn above just wrote it) -- not the only one reached from /admin/,
                  // which admin_create_bills.js:240 and the wrong-user fallback below also are; the
                  // cache state is the load-bearing part. redirectLoggedIn's new-portal branch is
                  // gated on
                  // !isAdminOrClientSubApp(), so if start_impersonation ever stopped returning
                  // redirect_url for a new-portal payer, the else below would hand the admin to the
                  // legacy '../payer/' sub-app rather than the new portal. That self-corrects --
                  // /payer/ hands off on its own -- but at the cost of the extra cross-portal hop
                  // this whole ticket is about. The backend contract is what keeps it off that path.
                  if (response?.data?.redirect_url) {
                    let redirectUrl = response.data.redirect_url;
                    const separator = redirectUrl.includes('?') ? '&' : '?';
                    redirectUrl += separator + 'returnUrl=' + encodeURIComponent(impersonatedFromUrl);
                    $window.location.href = redirectUrl;
                  } else {
                    authHelper.redirectLoggedIn();
                  }
                }
              );
            },
            portalHelperService.showErrorCommon
          );
      };

      portalHelperService.sendWelcomeEmail = function (userId, user_type_name, cb_success) {
        const url = apiHelper.getApiUrl() + '/api/admin/user/reset_password/' + userId + '.json';
        HttpAuth.put(url, {}).then(
          function (result) {
            portalHelperService.showPopup('Email Sent!',
              'A welcome email has been sent to the ' + user_type_name,
              cb_success);
          },
          portalHelperService.showErrorCommon
        );
      };

      const generatePasswordAndWelcomeEmailLinks = function(apiUrl, waitMessage, popupTitle,
        popupMessage, cb_success) {

        portalHelperService.showToast(CONSTANTS.typeOfToasts.INFO, waitMessage);

        HttpAuth.put(apiUrl, {}).then(
          function (result) {
            const url = result.data.link;
            portalHelperService.showCopyableTextPopup(popupTitle, popupMessage, url, cb_success);
          },
          function (result) {
            if (portalHelperService.responseContains(result, 'unlock the user')) {
              portalHelperService.showPopupError('Error', result.data[0]);
            } else {
              portalHelperService.showErrorCommon(result);
            }
          }
        );
      };

      portalHelperService.passwordResetAsAdmin = function (userId, user_type_name, cb_success) {
        const url = apiHelper.getApiUrl() + '/api/admin/user/reset_password/' + userId + '.json';
        HttpAuth.put(url, {}).then(
          function (result) {
            portalHelperService.showPopup('Email Sent!',
              'A password reset email has been sent to the ' + user_type_name,
              cb_success);
          },
          function (result) {
            if (portalHelperService.responseContains(result, 'unlock the user')) {
              portalHelperService.showPopupError('Error', result.data[0]);
            } else {
              portalHelperService.showErrorCommon(result);
            }
          }
        );
      };

      portalHelperService.bulkPasswordResetAsAdmin = function (userIds, user_type_name, cb_success) {
        const url = apiHelper.getApiUrl() + '/api/admin/user/reset_password.json';
        HttpAuth.post(url, { users: userIds }).then(
          function (result) {
            let popupContent = '<p>' + result.data.success + ' Emails sent successfully, ' +
              result.data.omit + ' omitted and ' + result.data.errors.length + ' errors </p>';

            if (result.data.errors.length) {
              popupContent += '<p>Errors are: <br>';
              result.data.errors.forEach((error, index) => {
                popupContent += (index + 1) + ') ' + error + '<br>';
              });
              popupContent += '</p>';
            }

            portalHelperService.showPopup('Alert', popupContent, cb_success, 'blue');
          },
          function (result) {
            portalHelperService.showErrorCommon(result);
          }
        );
      };

      portalHelperService.passwordResetLinkAsAdmin = function (userId, user_type_name, cb_success) {
        const apiUrl = apiHelper.getApiUrl() + '/api/admin/user/reset_password_link/' + userId + '.json';
        const waitMessage = 'We are generating the password reset link. Please wait...';
        const popupTitle = 'Reset Password Link Generated';
        const popupMessage = 'The reset password link is:';

        return generatePasswordAndWelcomeEmailLinks(apiUrl,
          waitMessage,
          popupTitle,
          popupMessage,
          cb_success);
      };

      portalHelperService.showCopyableTextPopup = function (title, message, copyableText, callback) {
        const messageBoxHtml = [
          message + '<br />',
          '<input ' +
          'readonly="readonly"',
          'onclick="this.setSelectionRange(0, this.value.length)"',
          'class="wide mt-3"',
          'type="text"',
          'value="' + copyableText + '"/>',
          '<div class="mt-2">',
          '<a href="javascript:" onclick="return copyToClipboard(\'' + copyableText + '\')">Copy to Clipboard</a>',
          '</div>'
        ].join('\n');

        portalHelperService.showPopup(title, messageBoxHtml, callback);
      };

      const removeTfaForUser = function (user, scope, confirmHandle, cb_success) {
        const data = {
          'user_id': user.id,
          'current_otp': scope.current_otp,
          'current_password': scope.current_password
        };
        scope.error = '';
        scope.is_saving = true;
        HttpAuth.post(apiHelper.getApiUrl() + '/auth/remove-tfa/', data).then(
          function (result) {
            user.tfa_configured = false;
            confirmHandle.close();

            if (cb_success) {
              cb_success();
            }

            portalHelperService.showPopupOK('Success', 'Two-Factor Authentication has been removed for this user.');
          }, function (response) {
            const errors = response.data?.non_field_errors;
            if (response.status === 400 && errors?.length > 0) {
              scope.error = errors[0];
              scope.current_otp = '';
              scope.current_password = '';
              return;
            }
            confirmHandle.close();
            portalHelperService.showErrorCommon(response);
          }
        ).finally(function () {
          scope.is_saving = false;
        });
      };

      portalHelperService.getUTCDate = function (dateStr) {
        const localDate = new Date(dateStr);
        // Convert local date to UTC
        const utcYear = localDate.getUTCFullYear();
        const utcMonth = localDate.getUTCMonth();
        const utcDay = localDate.getUTCDate();
        const utcHours = 0;
        const utcMinutes = 0;
        const utcSeconds = 0;

        // Create a new UTC date object
        const utcDate = new Date(utcYear, utcMonth, utcDay, utcHours, utcMinutes, utcSeconds);
        return utcDate;
      };

      portalHelperService.removeTfaConfirm = function (user, cb_success) {
        const scope = $rootScope.$new(true);
        scope.user_name = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email;
        scope.current_otp = '';
        scope.current_password = '';
        scope.error = '';
        scope.is_saving = false;

        const confirmHandle = $ngConfirm({
          title: 'Remove Two-Factor Authentication?',
          content: [
            '<div class="tfa-reauth">',
            '<p>This removes the authenticator device for <b data-ng-bind="user_name"></b>.',
            ' They will need to set up Two-Factor Authentication again.</p>',
            '<p>To confirm it is you, enter a code from <b>your own</b> authenticator app,',
            ' or your account password.</p>',
            '<div class="mb-2"><input type="text" name="current_otp" class="form-control"',
            ' inputmode="numeric" autocomplete="one-time-code" placeholder="Your current 6-digit code"',
            ' data-ng-model="current_otp"></div>',
            '<div class="mb-2"><input type="password" name="current_password" class="form-control"',
            ' autocomplete="current-password" placeholder="Or your account password"',
            ' data-ng-model="current_password"></div>',
            '<div class="alert alert-danger tfa-reauth-error" data-ng-show="error" data-ng-bind="error"></div>',
            '<p class="text-muted mb-0"><i class="fa fa-info-circle fa-fw"></i>',
            'This action is recorded in the audit log with your name.</p>',
            '</div>'
          ].join(''),
          columnClass: 'medium',
          type: 'orange',
          closeIcon: false,
          escapeKey: false,
          backgroundDismiss: false,
          scope: scope,
          onDestroy: function () {
            scope.$destroy();
          },
          buttons: {
            Remove: {
              text: 'Remove 2FA',
              btnClass: 'mat ui primary button',
              action: function () {
                if (!scope.is_saving) {
                  if (scope.current_otp || scope.current_password) {
                    removeTfaForUser(user, scope, confirmHandle, cb_success);
                  } else {
                    scope.error = 'Enter a code from your authenticator app, or your account password.';
                  }
                }
                return false;
              }
            },
            Cancel: {
              btnClass: 'mat ui critical button'
            }
          }
        });
      };

      /**
       * setLockStatusForUsers to call endpoint to set lock status for users
       * @param {users} array containing user objets to be updated
       * @param {lockStatus} value of locked status to be set
       * @return {promise}
       */
      const setLockStatusForUsers = function (users, lockStatus) {
        const url = apiHelper.getApiUrl() + '/api/admin/user/lock.json';
        const data = {
          'locked': lockStatus,
          'users': users
        };

        return HttpAuth.post(url, data);
      };

      /**
       * setActiveStatusForUsers to call endpoint to set active status for users
       * @param {users} array containing user objets to be updated
       * @param {lockStatus} value of active status to be set
       * @return {promise}
       */
      const setActiveStatusForUsers = function (users, activeFlag) {
        const url = apiHelper.getApiUrl() + '/api/admin/user/active.json';
        const data = {
          'active': activeFlag,
          'users': users
        };

        return HttpAuth.post(url, data);
      };

      /**
       * showUpdateUIForUsers to show UI to ask for reason to lock/deactivate users
       * @param {users} array containing user objets to be updated
       * @param {flag} signifies if active or locked status of user need to be updated
       * @return {promise} return a promise object
       */
      const showUpdateUIForUsers = function (users, flag) {
        const showUpdateUIForUsersPromise = new Promise(function(resolve, reject){
          const updateActiveStatus = flag == CONSTANTS.updateUsersFlagTypes.ACTIVE ? true : false;

          const activeUsers = _.filter(users, function(user) {
            return updateActiveStatus ? user.active : !user.locked;
          });

          const multi_users = activeUsers.length > 1 ? true : false;
          const config = {
            active: {
              buttonText: 'Deactivate',
              title: multi_users ? 'Deactivate Payers ?' : 'Deactivate Payer'
            },
            lock: {
              buttonText: 'Lock',
              title: multi_users ? 'Lock Payers ?' : 'Lock Payer'
            }
          };

          //create new isolated scope instead of using parent scope, to avoid any accidental
          //changes to parent scope
          const popUpScope = $rootScope.$new(true);
          //reason is used in case user want to use same reason for selected users
          popUpScope.reason = '';
          popUpScope.is_same_reason = multi_users;
          //flags specifies if users want to lock/deactivate
          popUpScope.flag = flag;
          popUpScope.is_input_invalid = false;
          popUpScope.constants = {
            'REASON' : 'reason',
            'IS_SAME_REASON' : 'is_same_reason'
          };

          // change_callback will be  called whenever there is update in the
          // keys like reason, same reason checkbox, reason for each user
          popUpScope.change_callback = function(key, value) {
            if (popUpScope.constants.REASON == key || popUpScope.constants.IS_SAME_REASON == key) {
              popUpScope[key] = value;
            } else {
              // update user specific reason
              popUpScope.users[key].reason = value;
            }
          };

          popUpScope.users = _.map(activeUsers, function (user, index) {
            let payerName = user.full_name;

            if (payerName == '' || payerName == null) {
              payerName = user.first_name + ' ' + user.last_name;
            }

            if (payerName == ' ' || payerName == '' || payerName == null) {
              payerName = 'Payer ' + (index + 1);
            }

            const activeSurveys = _.map(user.live_surveys, function (survey) {
              return 'MAT_' + survey;
            }).join(', ');

            return {
              'id' : user.id,
              'full_name': payerName,
              'surveys': activeSurveys,
              'reason' : ''  //reason to deactivate/lock user
            };
          });
          $ngConfirm({
            title: config[flag].title,
            contentUrl: '../html_templates/payers_change_status.427b121e.html',
            scope: popUpScope,
            columnClass: 'col-md-10',
            type: 'orange',
            closeIcon: true,
            escapeKey: true,
            backgroundDismiss: true,
            buttons: {
              Cancel: {
                btnClass: 'mat ui primary button'
              },
              button: {
                text: config[flag].buttonText,
                btnClass: 'mat ui critical button',
                action: function() {
                  //for same reason we have a separate feild mapped to component
                  //which we need to set in each users reason field to be sent
                  //to backend
                  if (popUpScope.is_same_reason) {
                    //reason field can't be blank,
                    if (popUpScope.reason.trim() == '') {
                      popUpScope.is_input_invalid = true;
                      return false; //reason is required
                    }

                    popUpScope.users = _.map(popUpScope.users, function(user) {
                      user.reason = popUpScope.reason;
                      return user;
                    });
                  } else {
                    popUpScope.is_input_invalid = _.reduce(popUpScope.users, function(preVal, user) {
                      return preVal || !user.reason || user.reason.trim() == '';
                    }, false);
                  }

                  //reason not specified for all/some
                  if (popUpScope.is_input_invalid) {
                    return false;
                  }
                  //getting only fields requried at backend i.e.: userId, reason
                  const userIds =  _.map(popUpScope.users, function(user) {
                    return {'id' : user.id, 'reason' : user.reason};
                  });

                  if (updateActiveStatus) {
                    return setActiveStatusForUsers(userIds, false).then(resolve, reject);
                  }

                  return setLockStatusForUsers(userIds, true).then(resolve, reject);
                }
              }
            }
          });
        });
        return showUpdateUIForUsersPromise;
      };
      /**
       * Update lock status for given array of users.
       * @param {users} users array of users for which lock status need to be updated.
       * @param {lockStatus} lockStatus boolean, value of locked to be set, true signifies locking users,
       *  false signifies unlocking users
       * @param {arePayers} arePayers boolean, signifies if users are payers or not.
       * @return {promise} return a promise object
       */
      portalHelperService.update_lock_status_for_users = function (users, lockStatus, arePayers) {
        const proimseSuccess = function(result) {
          const strActiveStatus = lockStatus ? 'Locked' : 'Unlocked';
          let message = 'The user has been ' + strActiveStatus.toLowerCase() + ' successfully';
          const title = strActiveStatus;

          if (users.length >= 1) {
            message = 'All selected payers have been ' + strActiveStatus.toLowerCase() + '.';
          }

          portalHelperService.showToast(CONSTANTS.typeOfToasts.SUCCESS, message, title);
          return result;
        };

        const promiseFailure = function(error) {
          portalHelperService.showErrorCommon(error);
          throw error;
        };

        if (lockStatus && arePayers) {
          return showUpdateUIForUsers(users, CONSTANTS.updateUsersFlagTypes.LOCK).then(proimseSuccess, promiseFailure);
        }

        const userIds = _.map(users, function (user) {
          return {'id' : user.id};
        });

        return setLockStatusForUsers(userIds, lockStatus).then(proimseSuccess, promiseFailure);
      };

      portalHelperService.lockClientAsAdmin = function (user) {
        const data = { 'locked': !user.locked };
        const url = apiHelper.getApiUrl() + '/api/admin/client/locked/' + user.id + '.json';

        HttpAuth.put(url, data).then(
          function (result) {
            user.locked = !user.locked;

            const message = user.locked
              ? 'Client has been locked successfully'
              : 'Client has been unlocked successfully';

            const title = user.locked
              ? 'Locked'
              : 'Unlocked';

            portalHelperService.showToast(CONSTANTS.typeOfToasts.SUCCESS, message, title);
          },
          function (result) {
            portalHelperService.showErrorCommon(result);
          }
        );
      };

      portalHelperService.activateClientAsAdmin = function (client) {
        const data = { 'active': !client.active };
        const url = apiHelper.getApiUrl() + '/api/admin/client/active/' + client.id + '.json';

        HttpAuth.put(url, data).then(
          function (result) {
            client.active = !client.active;

            const message = client.active
              ? 'Client has been activated successfully'
              : 'Client has been deactivated successfully';

            const title = client.active
              ? 'Activated'
              : 'Deactivated';

            portalHelperService.showToast(CONSTANTS.typeOfToasts.SUCCESS, message, title);
          },
          function (result) {
            portalHelperService.showErrorCommon(result);
          }

        );
      };

      /**
       * Update active status for given array of users.
       * @param {users} users array of users for which lock status need to be update.
       * @param {activeFlag} activeFlag boolean, value of active to be set, true signifies activating users,
       *  false signifies deactivating users
       * @param {arePayers} arePayers boolean, signifies if users are payers or not.
       * @return {promise} return a promise object
       */
      portalHelperService.update_active_status_for_users = function (users, activeFlag, arePayers) {
        const proimseSuccess = function(result) {
          const strActiveStatus = activeFlag ? 'Activated' : 'Deactivated';
          let message = 'The user has been ' + strActiveStatus.toLowerCase() + ' successfully';
          const title = strActiveStatus;

          if (users.length >= 1) {
            message = 'All selected payers have been ' + strActiveStatus.toLowerCase() + '.';
          }

          portalHelperService.showToast(CONSTANTS.typeOfToasts.SUCCESS, message, title);

          return result;
        };

        const promiseFailure = function(error) {
          portalHelperService.showErrorCommon(error);
          throw error;
        };

        if (arePayers && activeFlag == false) {
          return showUpdateUIForUsers(users, CONSTANTS.updateUsersFlagTypes.ACTIVE).then(proimseSuccess, promiseFailure);
        }

        const userIds = _.map(users, function (user) {
          return {'id' : user.id};
        });
        return setActiveStatusForUsers(userIds, activeFlag).then(proimseSuccess, promiseFailure);
      };

      portalHelperService.getFileIconPath = function (file_name) {
        if (file_name.match(/.pdf$/i)) {
          return portalHelperService.getUrl('Images/pdf.png');
        } else if (file_name.match(/.xlsx$/i) || file_name.match(/.xls$/i)) {
          return portalHelperService.getUrl('Images/excel.png');
        } else if (file_name.match(/.doc$/i) || file_name.match(/.docx$/i)) {
          return portalHelperService.getUrl('Images/word.png');
        } else if (file_name.match(/.ppt$/i) || file_name.match(/.pptx$/i)) {
          return portalHelperService.getUrl('Images/ppt.png');
        }

        return './Images/excel.png';
      };

      portalHelperService.getIconClassFromFilename = function (file_name) {
        if (file_name.match(/.pdf$/i)) {
          return 'fa fw fa-file-pdf-o';
        } else if (file_name.match(/.xlsx$/i) || file_name.match(/.xls$/i)) {
          return 'fa fw fa-file-excel-o';
        } else if (file_name.match(/.doc$/i) || file_name.match(/.docx$/i)) {
          return 'fa fw fa-file-word-o';
        } else if (file_name.match(/.ppt$/i) || file_name.match(/.pptx$/i)) {
          return 'fa fw fa-file-powerpoint-o';
        }

        return 'fa fw fa-file-text-o';
      };

      portalHelperService.meSharedReady = function (cb_success) {
        // waits until MeShared and MeSharedOrig initialized
        portalHelperService.retrieveMeShared(function (data) {
          cb_success();
        });
      };

      portalHelperService.retrieveMeShared = function (cb_success, useOrigLogin, forceRetrieval, cb_error) {
        if (!forceRetrieval) {
          const meShared = (useOrigLogin) ? authHelper.getMeSharedOrig() : authHelper.getMeShared();
          if (angular.isDefined(meShared) && angular.isDefined(meShared.email)) {
            // data already retrieved
            cb_success(authHelper.getMeShared());
            return;
          }
        }

        const url_me = apiHelper.getApiUrl() + '/api/mydetails/';
        const config = { 'skip_impersonation': !!(useOrigLogin) };

        HttpAuth.get(url_me, config).then(function (result) {
          authHelper.setMeShared(result.data);
          cb_success(result.data);
        }, function (result) {
          if (cb_error) {
            cb_error(result.data);
          }
        });
      };

      portalHelperService.getQuestionNumber = function (question_id, sections, questions, filterQuestionsByCountry) {
        let questions_total = 0;

        for (let i0 = 0; i0 < sections.length; i0++) {
          const group = sections[i0];
          let group_questions = $filter('filter')(questions, { 'section': group.id });

          if (filterQuestionsByCountry) {
            group_questions = $filter('filter')(questions, filterQuestionsByCountry);
          }

          for (let i1 = 0; i1 < group_questions.length; i1++) {
            questions_total += 1;
            const q = group_questions[i1];

            if (q.id == question_id ||
              q.question_id == question_id //sometimes it's in different field. e.g.: admin view responses
            ) {
              return questions_total;
            }
          }
        }

        return questions_total;
      };

      portalHelperService.responseContains = function (result, text) {
        return JSON.stringify(result.data).indexOf(text) !== -1;
      };

      portalHelperService.MAX_DROPDOWN_OPTION_LENGTH = 250;

      portalHelperService.getDateOnlyFormat = function () {
        return 'dd MMM yyyy';
      };

      portalHelperService.countryCode = { UK: 77, US: 233, Canada: 38 };
      portalHelperService.otherOptions = { NO_OTHER: 0, SINGLE_OTHER: 1, MULTIPLE_OTHER: 2 };

      portalHelperService.scaleTypeIds = {
        RATING: 1,
        RANKING: 2,
        SLIDER_RATING: 5
      };

      portalHelperService.questionTypes = {
        1: 'Free Text',
        2: 'Dropdown List',
        3: 'Radio Buttons',
        4: 'Check Boxes',
        5: 'Rating Scale',
        6: 'Drag and Drop Ranking',
        8: 'Radio Button Ranking',
        9: 'Points Allocation',
        10: 'Van Westendorp Pricing Model',
        11: 'Gabor-Granger',
        12: 'Table of Responses',
        13: 'Slider Rating Scale'
      };

      portalHelperService.questionTypeBackend = {
        1: 'free_text',
        2: 'dropdown_list',
        3: 'radio_buttons',
        4: 'check_boxes',
        5: 'rating_scale',
        6: 'ranking_scale',
        8: 'radio_ranking_scale',
        9: 'points_allocation',
        10: 'table_of_responses_2',
        11: 'slider_rating_scale'
      };

      // this is the order they appear in on the "Manage Questions page"
      portalHelperService.orderedQuestionTypes = [
        [1, portalHelperService.questionTypes[1]],
        [2, portalHelperService.questionTypes[2]],
        [3, portalHelperService.questionTypes[3]],
        [4, portalHelperService.questionTypes[4]],
        [5, portalHelperService.questionTypes[5]],
        [6, portalHelperService.questionTypes[6]],
        [8, portalHelperService.questionTypes[8]],
        [12, portalHelperService.questionTypes[12]],
        [9, portalHelperService.questionTypes[9]],
        [10, portalHelperService.questionTypes[10]],
        [11, portalHelperService.questionTypes[11]],
        [13, portalHelperService.questionTypes[13]]
      ];

      portalHelperService.multiChoiceQuestions = [2, 3, 4];
      portalHelperService.scaleQuestions = [5, 6, 8, 13];

      const surveyStatusNamePairs = [
        [CONSTANTS.surveyStatuses.SCOPING, 'Scoping'],
        [CONSTANTS.surveyStatuses.QUESTION_DEVELOPMENT, 'Question Development'],
        [CONSTANTS.surveyStatuses.COMPLIANCE, 'Compliance'],
        [CONSTANTS.surveyStatuses.FIELDING_AND_ANALYSIS, 'Fielding And Analysis'],
        [CONSTANTS.surveyStatuses.FOLLOW_UP, 'Follow Up'],
        [CONSTANTS.surveyStatuses.DELIVERED, 'Delivered'],
        [CONSTANTS.surveyStatuses.ON_HOLD, 'On Hold'],
        [CONSTANTS.surveyStatuses.CANCELLED, 'Cancelled'],
        [CONSTANTS.surveyStatuses.DELETED, 'Deleted']
      ];

      portalHelperService.surveyStatusNames = {};
      surveyStatusNamePairs.forEach(function (pair) {
        portalHelperService.surveyStatusNames[pair[0]] = pair[1];
      });

      const idiStatusNamePairs = [
        [CONSTANTS.idiStatuses.SCOPING, 'Scoping'],
        [CONSTANTS.idiStatuses.LIVE, 'Live'],
        [CONSTANTS.idiStatuses.DELIVERED, 'Delivered'],
        [CONSTANTS.idiStatuses.ON_HOLD, 'On Hold'],
        [CONSTANTS.idiStatuses.CANCELLED, 'Cancelled'],
        [CONSTANTS.idiStatuses.DELETED, 'Deleted']
      ];

      portalHelperService.idiStatusNames = {};
      idiStatusNamePairs.forEach(function (pair) {
        portalHelperService.idiStatusNames[pair[0]] = pair[1];
      });

      const responseStatusNamePairs = [
        [CONSTANTS.responseStatuses.DRAFT, 'Draft'],
        [CONSTANTS.responseStatuses.SUBMITTED, 'Submitted'],
        [CONSTANTS.responseStatuses.APPROVED, 'Approved']
      ];

      portalHelperService.responseStatusNames = {};
      responseStatusNamePairs.forEach(function (pair) {
        portalHelperService.responseStatusNames[pair[0]] = pair[1];
      });

      // Spans both status vocabularies for screens listing surveys and IDI projects together. The
      // IDI labels match the survey ones on every shared key and add the IDI-only 'live'.
      portalHelperService.projectStatusDisplayNames = angular.extend(
        {}, CONSTANTS.surveyStatusDisplayNames, portalHelperService.idiStatusNames
      );

      // A project at the legacy 'on_hold' status is held whatever the flag says. Both status
      // vocabularies spell that value the same, so the survey constant covers IDI too.
      portalHelperService.isProjectOnHold = function (status, onHold) {
        return !!onHold || status === CONSTANTS.surveyStatuses.ON_HOLD;
      };

      // Advanced Search keeps the milestone visible under a hold; other screens just say 'On Hold'.
      // A status with no label falls back to its raw value rather than rendering 'undefined', and
      // is reported once so the drift is not silent.
      portalHelperService.getProjectStatusDisplayName = function (status, onHold) {
        if (!status) {
          return '';
        }
        let name = status;
        if (Object.hasOwn(portalHelperService.projectStatusDisplayNames, status)) {
          name = portalHelperService.projectStatusDisplayNames[status];
        } else {
          phReportUnknownProjectStatus(status);
        }
        return (onHold && status !== CONSTANTS.surveyStatuses.ON_HOLD) ? name + PH_ON_HOLD_SUFFIX : name;
      };

      portalHelperService.getReadableSurveyStatusName = function (status, onHold) {
        return onHold ? 'On Hold' : portalHelperService.surveyStatusNames[status];
      };

      portalHelperService.getReadableIDIStatusName = function (status, onHold) {
        return onHold ? 'On Hold' : portalHelperService.idiStatusNames[status];
      };

      portalHelperService.isValidRdUid = function (rdUid) {
        return !rdUid || /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{2,10}$/.test(rdUid);
      };

      portalHelperService.getErrors = function (response) {
        if (response.data.non_field_errors && response.data.non_field_errors.length > 0) {
          portalHelperService.scrollToElementById('error_list');
          return response.data.non_field_errors;
        }

        portalHelperService.showErrorCommon(response);
      };

      portalHelperService.handle_status_404 = function(scope){

        const popupHandle404 = $ngConfirm({
          title: '',
          contentUrl: portalHelperService.getUrlRev('html_templates/dialogs/404_not_found.4b80166a.html'),
          type: 'red',
          columnClass: 'col-md-8',
          closeIcon: true,
          escapteKey: true,
          scope: scope,
          onOpen: function(scope){
            scope.closeMe = function(){
              popupHandle404.close();
            };
          },
          buttons: {
            Close: {
              btnClass: 'mat ui primary button'
            }
          }
        });

      };

      portalHelperService.handle_status_400 = function(scope){

        // RPR-7017: the dialog template iterates this flattened shape, not the raw response body.
        scope.errorFields = portalHelperService.flattenValidationErrors(scope.response?.data);

        const popupHandle400 = $ngConfirm({
          title: '',
          contentUrl: portalHelperService.getUrlRev('html_templates/dialogs/400_bad_request.402350c4.html'),
          type: 'red',
          columnClass: 'medium',
          closeIcon: true,
          escapeKey: true,
          scope: scope,
          onOpen: function(scope) {
            scope.closeMe = function(){
              popupHandle400.close();
            };
          },
          buttons: {
            Close: {
              btnClass: 'mat ui primary button'
            }
          }
        });

      };

      // Handles a "you are not the user this endpoint is for" rejection, returning
      // true if it took care of it. Kept out of showErrorCommon so that already
      // over-budget function gets simpler, not more complex (S3776).
      function handleWrongUserResponse(response) {
        if (!phIsWrongUserResponse(response)) {
          return false;
        }
        // A reload is already committed for this document: swallow sibling
        // rejections instead of letting them navigate before it lands.
        if (phWrongUserReloadPending) {
          return true;
        }
        // Retry the page once before giving up: the session we need may simply not
        // have landed yet (RPR-6770). Only then fall back to the historic bounce,
        // which discards the location and so lands on the dashboard.
        //
        // Accepted cost, not an oversight: all eight "Only allowed for" strings are DRF
        // BasePermission.message values (api/misc/permissions.py), and they fire for
        // *permanent* user-type mismatches too -- a client user on a bookmarked
        // rpr.<env>/admin/#/Admin/... deep link, which is what the original code existed
        // to handle. Those are always GETs, so phIsReplayableRequest gives no protection,
        // and the response carries nothing that distinguishes "session still settling"
        // from "you will never be allowed here". Such a link therefore costs one extra
        // page load before the same bounce. That is deliberately paid: a single extra
        // load on a rare wrong-sub-app deep link is much cheaper than the dashboard
        // bounce it prevents on the common path. Do not "fix" it by widening the match.
        if (phIsReplayableRequest(response) && phShouldRetryWrongUser($location.url(), Date.now())) {
          phWrongUserReloadPending = true;
          // Release the latch if the reload never commits -- a beforeunload handler can
          // veto it and leave this document alive (see PH_WRONG_USER_RELOAD_VETO_MS).
          // invokeApply=false: this must not schedule a digest of its own.
          $timeout(function () {
            phWrongUserReloadPending = false;
          }, PH_WRONG_USER_RELOAD_VETO_MS, false);
          $window.location.reload();
          return true;
        }
        // Not latched: redirectLoggedIn() can silently no-op, so a later sibling
        // must still get its own attempt. Repeating it is harmless -- same target.
        authHelper.redirectLoggedIn();
        return true;
      }

      // The tail of showErrorCommon: whatever is left once the wrong-user, abort, no-internet, 404
      // and 400 cases have been taken out. Extracted rather than left inline because
      // showErrorCommon is already over budget for cognitive complexity (S3776) -- the same
      // reasoning as handleWrongUserResponse above, and what makes the RPR-6334 abort guard
      // affordable to add.
      function showUnidentifiedError(scope, response) {
        // `'status_code' in scope` used to gate this, and was always true: status_code is
        // initialised to '' by the caller, so the `in` test only ever asked whether a key we had
        // just written ourselves exists. Every rejection reaching here got a dialog, and one that
        // populated neither field got an EMPTY one -- the contentless "Something went wrong" of
        // RPR-6334.
        if (scope.status_code || scope.error_list.length) {
          $ngConfirm({
            title: 'Something went wrong',
            contentUrl: portalHelperService.getUrlRev('html_templates/dialogs/error_common.6c729c11.html'),
            type: 'red',
            scope: scope,
            buttons: {
              OK: {
                btnClass: 'mat ui critical button'
              }
            }
          });
          return;
        }

        // Deliberately still a dialog, not a silent return. RPR-6334 does not change HOW MANY
        // dialogs this function shows, only what the blank one says. A rejection with no usable
        // status and no body means a code fault, and the screen behind it is broken whether or not
        // we admit it -- swallowing it would leave the user reading stale or empty data with nothing
        // to suggest anything failed. So it gets a message instead of a blank box, plus a report
        // so it stops being invisible.
        phReportUnexpectedError(response);
        $ngConfirm({
          title: 'Something went wrong',
          content: 'An unexpected error occurred. Please refresh the page and try again.',
          type: 'red',
          scope: scope,
          buttons: {
            OK: {
              btnClass: 'mat ui critical button'
            }
          }
        });
      }

      portalHelperService.showErrorCommon = function (response) {
        //
        // check if accessing functionality of another user
        //

        // clear any existing wait toasts
        toastr.clear();

        // An aborted request is not a failure anyone can act on: the browser killed it because the
        // document started navigating, or because the user pressed Stop. Firefox tears these down
        // as soon as a navigation begins where Chrome usually lets them finish, which is why
        // RPR-6334 came in as a Firefox bug -- but nothing on this path is browser-specific, and
        // the karma spec pinning it fails just as loudly under headless Chrome.
        //
        // This is the suppression the status -1 branch below LOOKS like it provides and never did:
        // with xhrStatus 'abort' that branch's condition is false, so execution fell through to the
        // unidentified-error handler and popped a contentless "Something went wrong".
        //
        // Exactly two showErrorCommon call sites had already worked around that locally, and both
        // are in this file -- the getMyDetails rejection handlers inside portalHelperService
        // .portalReady and portalHelperService.routeResolve. Those two are now redundant, and are
        // left in place because they read as intent at the call site and cost nothing. (Named
        // rather than given line numbers: the numbers this comment first carried were already
        // wrong by the time it was reviewed. `grep -n "xhrStatus" portal/services/portal_helper.js`
        // finds them.)
        //
        // Do NOT read the rest of the portal's `xhrStatus != 'abort'` family as redundant on the
        // strength of this line. Every other member guards something that is NOT this dialog, and
        // none of them is affected by it -- deleting any would reintroduce a real regression on
        // every navigation-abort:
        //
        //   auth_helper.js, getMyDetails rejection handler   redirectToBackendLoginPage()
        //   common_auth_check_controller.js, isLoggedIn      authHelper.doLogoutAll(true)
        //   client_admin_survey_print_preview.js             an error toast
        //   client_admin_preview_survey.js                   a failed-country list entry
        //   admin_survey_manage_payers.js                    a console.warn (isReportableRefreshFailure)
        //
        // Several of those carry the comment "only abort is silent (see the xhrStatus check in
        // showErrorCommon)". That was a belief about this function, not a description of it; this
        // line is what finally makes it true.
        //
        // The toast clear above still runs. A vetoed navigation leaves the document alive, and a
        // stale "please wait" toast with no request behind it would sit there forever.
        //
        // 'timeout' is deliberately NOT included: AngularJS's onabort handler picks between the
        // two, and a timeout is a real failure the user should hear about.
        //
        // Restricted to reads, which is the case the paragraphs above actually argue for. A read
        // killed by a navigation is not actionable -- the user is leaving. A WRITE killed by one
        // is: both survivable aborts named above (a vetoed beforeunload, a Stop press) leave the
        // document alive, so the user is left looking at a normal-seeming form with a save that
        // may or may not have reached the server. Saying nothing there is worse than the empty
        // dialog this ticket removes, so mutations keep whatever the branches below give them.
        //
        // A missing config.method fails LOUD, not silent. Nothing reaches this line without one
        // today -- the vendored AngularJS always attaches config, and the guard additionally needs
        // xhrStatus 'abort', which nothing outside real $http sets -- so this is about which way
        // the code fails rather than a reachable path. Defaulting an unknown method to 'GET' would
        // have made "we could not tell what this was" mean "swallow it", in a guard whose whole
        // argument is that a mutation must stay loud.
        const abortedMethod = response?.config?.method?.toUpperCase();
        if ('abort' === response?.xhrStatus && abortedMethod && PH_ABORT_SILENT_METHODS.has(abortedMethod)) {
          return;
        }

        if (handleWrongUserResponse(response)) {
          return;
        }

        const scope = $rootScope.$new(true);
        scope.error_list = [];
        scope.status_code = '';
        scope.response = response;
        //
        // check no internet
        // In firefox on changing page also requested getting aborted with status -1
        // so do not show No internet popup for aborted requests with status -1
        if (response && !Array.isArray(response) && response.status == -1 && 'abort' != response.xhrStatus) {

          // if popup is already shown, exit silently
          if (portalHelperService.no_internet_popup) {
            return;
          }

          // Status -1 also covers server failures the browser refused to hand
          // over to us (e.g. a 502 error page from the proxy without CORS
          // headers), so only blame the user's connection when the browser
          // reports it is actually offline.
          const is_offline = window.navigator?.onLine === false;
          portalHelperService.no_internet_popup = $ngConfirm({
            title: is_offline ? 'No internet' : 'Connection problem',
            content: is_offline ?
              'Please check your internet connection' :
              'The server could not be reached. Please try again in a few moments.',
            type: 'red',
            scope: scope,
            buttons: {
              OK: {
                btnClass: 'mat ui critical button',
                action: function () {
                  portalHelperService.no_internet_popup = null;
                }
              }
            }
          });
          return;
        }

        // Handle 404 response.
        //
        // Optional chaining here and on the 400 below: a bare $q.reject() or a `throw undefined`
        // routed into .catch(showErrorCommon) used to raise a TypeError INSIDE the error handler,
        // so the most degenerate no-status-no-body rejection -- the exact category
        // showUnidentifiedError was written to catch -- produced no dialog at all.
        if (404 === response?.status){
          portalHelperService.handle_status_404(scope);
          return;
        }

        // Handle 400 response.
        if (400 === response?.status){
          portalHelperService.handle_status_400(scope);
          return;
        }


        // unidentified error handling
        if (response && Array.isArray(response)) {
          for (let i = 0; i < response.length; i++) {
            if (Array.isArray(response[i].data)) {
              scope.error_list = scope.error_list.concat(response[i].data);
            }

            if (!scope.status_code && response[i].status != 200) {
              scope.status_code = response[i].status;
            }
          }
        } else {
          if (response?.data) {
            if (Array.isArray(response.data)) {
              scope.error_list = response.data;
            } else if (response.data.detail) {
              scope.error_list = [response.data.detail];
            } else {
              scope.error_list = [JSON.stringify(response.data)];
            }
          }
          // Hoisted out of the `response.data` guard it used to sit inside. A real HTTP failure
          // with an empty body -- a bodiless 502 from the proxy, a 500 or 401 with no payload --
          // left status_code at '' and so reached showUnidentifiedError looking exactly like a
          // code fault: the user lost the "Response code" line that error_common.html exists to
          // show, and Sentry was told the rejection carried no status, which was false. That
          // mattered more after RPR-6334, because the blank dialog those produced is precisely
          // what this ticket set out to remove.
          //
          // Assigned unconditionally rather than guarded on `response.status` existing: a
          // rejection that is not a response has none, which lands undefined here, and both the
          // gate below and the template's ng-if treat that the same as the '' it replaced.
          scope.status_code = response?.status;
        }

        showUnidentifiedError(scope, response);

      };

      portalHelperService.isMultiRationale = function (rationale_type) {
        return rationale_type == 2;
      };

      portalHelperService.isSingleRationale = function (rationale_type) {
        return rationale_type == 1;
      };

      portalHelperService.prepareDownloadUrl = function (file_rel_url, query_args) {
        // var url_file = apiHelper.getApiUrl() + file_rel_url + '?token=' + token;
        let url_file = apiHelper.getApiUrl() + file_rel_url;

        if (query_args) {
          url_file += '?';
          for (const arg_name in query_args) {

            if (Array.isArray(query_args[arg_name])) {
              for (let i = 0; i < query_args[arg_name].length; i++) {
                url_file += '&' + arg_name + '=' + query_args[arg_name][i];
              }
            } else {
              url_file = url_file + '&' + arg_name + '=' + query_args[arg_name];
            }
          }
        }

        return url_file;
      };

      portalHelperService.downloadFileWithUrl = function (url_file, query_args) {
        const downloadUrl = portalHelperService.prepareDownloadUrl(
          url_file, query_args
        );
        window.open(downloadUrl, '_blank');
      };

      portalHelperService.downloadFile = function (url_file, query_args) {
        const downloadUrl = portalHelperService.prepareDownloadUrl(
          url_file, query_args
        );
        return HttpAuth.get(downloadUrl);
      };

      portalHelperService.downloadReport = function (report_id) {
        const downloadUrl = portalHelperService.prepareDownloadUrl(
          '/api/surveyreport/' + report_id + '.json'
        );
        window.open(downloadUrl, '_blank');
      };

      // Trigger a client-side download of in-memory text as a .txt file.
      portalHelperService.downloadTextFile = function (content, filename) {
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        const url = globalThis.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(url);
      };

      portalHelperService.admin_export_excel_confirm = function ($scope, survey_id) {
        const url_order = apiHelper.getApiUrl() + '/reports/api/admin/survey/response/order/' + survey_id + '.json';
        $scope.dialog = {};

        HttpAuth.get(url_order).then(
          function (result) {
            const cur_scope = $rootScope.$new(true);
            cur_scope.response_order = result.data;

            cur_scope.response_sortable = {
              orderChanged: function (event) {
                // reset export_order
                for (let i = 0; i < cur_scope.response_order.responses.length; i++) {
                  cur_scope.response_order.responses[i]['export_order'] = i + 1;
                }
              }
            };

            $scope.dialog = $ngConfirm({
              title: 'Change order',
              contentUrl: portalHelperService.getUrlRev(
                'html_templates/dialogs/admin_export_response_order.d3457f68.html'),
              columnClass: 'medium',
              scope: cur_scope,
              buttons: {
                Save: {
                  btnClass: 'mat ui primary button',
                  text: 'Save order and export',
                  action: function (scope, button) {
                    HttpAuth.put(url_order, scope.response_order).then(function (result) {
                      $scope.dialog.close();
                      $scope.export_excel();
                    }, function (result) {
                      portalHelperService.showErrorCommon(result);
                    });
                  }
                },
                Export: {
                  btnClass: 'mat ui primary button',
                  text: 'Export',
                  action: function (scope, button) {
                    $scope.export_excel();
                  }
                },
                Cancel: {
                  btnClass: 'mat ui critical button',
                  action: function (scope, button) {
                    // closes the modal
                  }
                }
              }
            });
          },
          function (result) {
            portalHelperService.showErrorCommon(result);
          }
        );
      };

      portalHelperService.getQuestionTypeName = function (type) {
        return portalHelperService.questionTypes[type];
      };

      portalHelperService.getQuestionTypeNameBackend = function (type) {
        return portalHelperService.questionTypeBackend[type];
      };

      portalHelperService.setupInfoIconTooltips = function (tooltipClassName, isHtml) {
        const className = tooltipClassName + ':not(\'.tooltipstered\')';
        const obj = $(className);
        if (obj && obj.tooltipster) {
          obj.tooltipster({
            contentAsHTML: (isHtml === true),
            delay: 0,
            animation: 'grow'
          });
        }
      };

      portalHelperService.isFreeTextQuestion = function (question_type) {
        if (question_type == CONSTANTS.questionTypeIds.FREE_TEXT) {
          return true;
        }
      };

      portalHelperService.isMultiChoiceQuestion = function (question_type) {
        if (portalHelperService.multiChoiceQuestions.indexOf(question_type) !== -1) {
          return true;
        }
      };

      portalHelperService.isRatingScaleQuestion = function (question_type) {
        if (question_type == 5) {
          return true;
        }
      };

      portalHelperService.isPointsQuestion = function (question_type) {
        if (question_type == 9) {
          return true;
        }
      };

      portalHelperService.isVanWestendorp = function (question_type) {
        if (question_type == CONSTANTS.questionTypeIds.VAN_WESTENDORP_PRICING_MODEL) {
          return true;
        }
      };

      portalHelperService.isScaleQuestion = function (question_type) {
        if (portalHelperService.scaleQuestions.indexOf(question_type) !== -1) {
          return true;
        }
      };

      portalHelperService.checkTfaRequired = function (me) {
        return !!(me.tfa_mandatory && !me.tfa_configured);
      };

      portalHelperService.redirectTfaRequired = function () {
        $window.location.href = '../login/#/TfaRequired';
      };

      /** This function will send the payer to contract page
       *  except for the pages which are allowed before signing contract */
      const sendPayerToContractPage = function () {
        const urlsAllowedBeforeSigningContract = [
          '/forgotten/password',
          '/forgotten/username',
          '/reset',
          '/firstpassword',
          '/tfarequired',
          '/tfasetupintro',
          '/tfasetup',
          '/payers/contractsign',
          'payers/payerexpertiseform'
        ];
        let isUrlAccessAllowedBeforeContract = false;
        const url = $location.url().toLowerCase();
        for (let i = 0; i < urlsAllowedBeforeSigningContract.length; i++) {
          isUrlAccessAllowedBeforeContract = url.indexOf(urlsAllowedBeforeSigningContract[i]) !== -1;
          if (isUrlAccessAllowedBeforeContract){
            break;
          }
        }
        if (!isUrlAccessAllowedBeforeContract) {
          authHelper.redirectLoggedIn('/Payers/ContractSign');
        }
      };

      const sendPayerToTermsOfUsePage = function () {
        const urlsAllowedBeforeTermsCheck = [
          'payers/payerexpertiseform'
        ];
        let isUrlAccessAllowedBeforeTermsCheck = false;
        const url = $location.url().toLowerCase();
        for (let i = 0; i < urlsAllowedBeforeTermsCheck.length; i++) {
          isUrlAccessAllowedBeforeTermsCheck = url.indexOf(urlsAllowedBeforeTermsCheck[i]) !== -1;
          if (isUrlAccessAllowedBeforeTermsCheck){
            break;
          }
        }
        if (!isUrlAccessAllowedBeforeTermsCheck) {
          authHelper.redirectLoggedIn('/Payers/terms-of-use');
        }
      };

      /**
       * Check portal version via lightweight endpoint if TTL has expired.
       * If the payer should use the new portal, show a message and redirect.
       * Returns a promise that resolves to true if redirect is happening.
       */
      const checkPortalVersionIfNeeded = function () {
        // Authenticated payers use the auth'd endpoint (reflects their per-user flag).
        // Admin/client users skip the check. Unauthenticated visitors fall through to
        // the public endpoint so stale old-portal email links still redirect anonymous
        // users to the new portal when that's the configured default.
        // Via authHelper rather than sessionStorage directly, so a session that cannot belong to
        // this sub-app is discarded rather than trusted (RPR-6770) -- otherwise a payer session
        // left on /admin/ by an impersonation round trip makes this probe the *payer* flag on an
        // admin page. authHelper also owns the JSON parsing, hence no try/catch here any more.
        const cachedDetails = authHelper.getCachedLoginDetails();
        let isPayerSession = false;
        if (cachedDetails) {
          isPayerSession = cachedDetails.user_type_name === 'payer';
          if (!isPayerSession) {
            return Promise.resolve(false);
          }
        } else if (authHelper.refusedCachedSession()) {
          // A REFUSED session is not an anonymous visitor, and the two must not be conflated
          // (RPR-6770). An admin or client opening a /payer/ URL -- e.g. the authenticated
          // expertise-form link the backend itself builds -- has their own session cached, which
          // getCachedLoginDetails refuses here because it belongs to another sub-app. Falling into
          // the anonymous branch below would then probe the PUBLIC portal-version flag, which
          // reports the global force-legacy setting (false by default) for any non-payer, and
          // redirect them to the new payer portal -- whose guard sees a non-payer and bounces them
          // back. That is this very ticket's bug with the sub-apps swapped.
          //
          // Reached for an unparseable or unusable cached value too, not just another sub-app's
          // session -- refusedCachedSession() latches all three. Those two exits used to leave it
          // false and land here in the `else`, which is the same misroute by a different door.
          //
          // Note what this does and does not fix, because it is easy to over-read. The refused-cache
          // path is the one that fires when the `unload` cleanup does NOT run -- the Edge/bfcache
          // conditions this ticket is about. When it DOES run, the cache here is simply *empty*, the
          // `else` below is reached, and an admin is still misrouted. That is pre-existing (measured
          // against develop, which behaves identically) and left to its own ticket: fixing it means
          // not treating "cache not yet populated" as "anonymous", which is a boot-ordering change.
          return Promise.resolve(false);
        } else {
          // No cached session — portal_helper.js is shared across all old-portal
          // sub-apps (admin, client, payer, login, document). Only probe the public
          // payer-portal flag for anonymous visitors actually landing on the payer
          // sub-app; otherwise an admin/client visitor would be rerouted to the new
          // payer portal on first load (before isLoggedIn populates the cache),
          // causing a redirect loop.
          const path = ($window.location.pathname || '');
          const inPayerSubApp = path === '/payer' || path.indexOf('/payer/') === 0;
          if (!inPayerSubApp) {
            return Promise.resolve(false);
          }
        }

        const now = Date.now();
        if (now - lastPortalVersionCheckTime < PORTAL_VERSION_CHECK_TTL_MS) {
          return Promise.resolve(false);
        }
        const isFirstCheck = lastPortalVersionCheckTime === 0;
        lastPortalVersionCheckTime = now;

        const url = isPayerSession
          ? apiHelper.getApiUrl() + '/api/payer/portal-version/'
          : apiHelper.getApiUrl() + '/api/portal-version/public/';
        const httpService = isPayerSession ? HttpAuth : $http;
        return httpService.get(url).then(
          function (result) {
            // `?.` because this is the only unguarded read of a response body on a path whose
            // failure mode is a page that never finishes loading. AngularJS is kinder here than it
            // looks -- an empty body arrives as '' and ''.use_legacy_portal is undefined, not a
            // throw -- but a JSON `null` body with an application/json content type does become
            // null, and then this throws. Our own views cannot emit that (both always return a dict,
            // and DRF renders None as an empty body), so this guards the intermediary case only.
            if (result.data?.use_legacy_portal === false && SETTINGS.NEW_PORTAL_URL) {
              // Keep cached session details consistent so portalReady's own check matches -- by
              // writing a COPY back, never by mutating the object authHelper handed back.
              // getCachedLoginDetails memoizes on the stored string, so its return value is shared
              // by every reader on this page load. Mutating it would be observed portal-wide, and if
              // the setItem below throws, all of them would go on acting on a change that never
              // reached storage. The write-back is what makes the change visible: it changes the
              // stored string, which is exactly what invalidates that memo.
              //
              // The write stays wrapped even though authHelper now owns the JSON parsing: setItem
              // throws on a quota-exhausted or access-restricted store (Safari private, blocked
              // cookies, sandboxed iframe), and this runs inside an $http success handler whose
              // rejection nothing handles -- portalReady's own OUTER .then (the one on
              // checkPortalVersionIfNeeded; the inner getLoginDetails().then does have a handler)
              // has no error callback, and its callers throughout portal/controllers/ discard the
              // return value. An escape here would strand the page with no
              // data, no error and no redirect, instead of merely failing to refresh a cache.
              if (isPayerSession && cachedDetails) {
                try {
                  const refreshedDetails = { ...cachedDetails, use_legacy_portal: false };
                  sessionStorage.setItem(CONSTANTS.LOGIN_DETAILS_KEY, JSON.stringify(refreshedDetails));
                } catch (error_) {
                  console.warn('Failed to update cached login details:', error_);
                }
              }
              const redirectUrl = portalHelperService.buildNewPortalUrl($location.path());

              // If a before-redirect hook is registered (e.g., survey draft save), call it first
              const hookPromise = beforePortalRedirectHook
                ? beforePortalRedirectHook()
                : Promise.resolve();

              return hookPromise.then(function () {
                if (!isFirstCheck) {
                  $window.alert('You are being redirected to the updated portal. Thank you for your patience as we continue to improve your experience.');
                }
                $window.location.href = redirectUrl;
                return true;
              }, function (error) {
                // Hook failed — redirect anyway to avoid the payer getting stuck
                console.error('Before-redirect hook failed:', error);
                if (!isFirstCheck) {
                  $window.alert('You are being redirected to the updated portal. Thank you for your patience as we continue to improve your experience.');
                }
                $window.location.href = redirectUrl;
                return true;
              });
            }
            return false;
          },
          function () {
            // Silently ignore errors — the main portalReady flow will handle auth issues
            return false;
          }
        ).catch(function (error_) {
          // A THROW out of the success handler above lands HERE, not in the handler sitting next to
          // it: `.then(f, g)` gives g the rejections of the promise it is attached to, never f's own
          // throws. Without this the rejection propagated out of checkPortalVersionIfNeeded, and
          // portalReady's `.then` below takes no error callback, and none of its 132 call sites keep
          // the returned promise -- so cb_success() never ran and the screen simply never finished
          // loading, with no error and no redirect. The try/catch around the setItem above exists
          // because of this same gap, for the one statement that was worried about at the time.
          //
          // `return false` is deliberately the SAME decision the transport-failure handler makes: a
          // version check we could not complete means "do not redirect, carry on with portalReady".
          // The asymmetry -- transport failures carry on, code failures hang the page -- was the
          // actual defect. Reported rather than swallowed, because unlike a transport failure this
          // can only mean a bug in the handler.
          phReportPortalVersionProblem('the success handler threw; continuing without redirecting',
            error_);
          return false;
        });
      };

      portalHelperService.portalReady = function (cb_success, is_contract_sign_required) {
        // This function will do all necessary checks, and if all successful - call cb_success
        // But if something fails, it might redirect to login page, without calling cb_success

        // here is what we need to check and retrieve:
        // 1. isLoggedIn
        // 2. meSharedReady
        // 3. checkTfaRequired

        // First, check if portal version flag has changed (TTL-based, at most once per 60s)
        return checkPortalVersionIfNeeded().then(function (redirecting) {
          if (redirecting) {
            return; // redirect in progress, skip remaining checks
          }

          //return authHelper.isLoggedIn().then(
          return authHelper.getLoginDetails().then(
            function (result) {
              const myDetails = result;
              // If payer should use new portal, redirect them.
              //
              // Never from the /admin/ or /client/ sub-app though (RPR-6770). This exact line was
              // the bounce QA reported: a payer session left on the legacy origin by an
              // impersonation round trip made an /admin/ page navigate itself to the new payer
              // portal, whose auth guard saw an admin and sent them straight back. An admin or
              // client user is never a new-portal payer, and impersonation always redirects to the
              // impersonated user's own portal, so this reading can only ever be someone else's
              // session here. Second line of defence: getLoginDetails() should already have
              // discarded such a session, and this is cheap, so keep both.
              if (myDetails.use_legacy_portal === false
                  && SETTINGS.NEW_PORTAL_URL
                  && !authHelper.isAdminOrClientSubApp()) {
                $window.location.href = portalHelperService.buildNewPortalUrl($location.path());
                return;
              }
              // If contract signing required, send the payer to contract page.
              if (myDetails.is_contract_sign_required && myDetails.docusign_enabled) {
                sendPayerToContractPage();
              }
              // If terms are not yet accpeted, send to the terms of use page.
              else if (myDetails.show_terms) {
                sendPayerToTermsOfUsePage();
              }
              // all checks passed, call cb_success
              if (cb_success) {
                cb_success();
              }
              return myDetails;
            },
            function (error) {
              // firefox aborts the current requests in case we change the page
              // which result in logout
              if ('abort' != error.xhrStatus) {
                portalHelperService.showErrorCommon(error);
              }
            }
          );
        });
      };

      portalHelperService.highlightAndScrollToElementById = function (id) {
        this.scrollToElementById(id);

        // Set glowing animation on the element
        const element = angular.element('#' + id);
        element.addClass('border-glow-animation');
        setTimeout(function () {
          element.removeClass('border-glow-animation');
        }, 4000);
        return element;
      };

      /*
      * use this incase you need to scroll with custom y offest.
        For normal cases prefer @scrollToElementById
      */
      portalHelperService.scrollTo = function (id, yOffset) {
        $timeout(function () {
          $anchorScroll.yOffset = (yOffset) ? yOffset : 0;
          if (id) {
            $anchorScroll(id);
          } else {
            // scrolls to the top
            $anchorScroll();
          }
        });
      };
      /**
       * See https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
       * for scroll options docs and usage
       * */
      portalHelperService.scrollToElementById = function (id, scrollOptions) {
        const defaultOptions = {
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        };

        const elems = angular.element('#' + id);
        if (elems && elems.length > 0) {
          elems[0].scrollIntoView(scrollOptions || defaultOptions);
        }
      };

      /**
       * See https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
       * for scroll options docs and usage
       * */
      portalHelperService.scrollToElementByClassName = function (cls, scrollOptions) {
        const defaultOptions = {
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        };

        const elems = angular.element(cls);
        if (elems && elems.length > 0) {
          elems[0].scrollIntoView(scrollOptions || defaultOptions);
        }
      };

      portalHelperService.scrollToTop = function () {
        $timeout(function () {
          // scrolls to the top
          $anchorScroll();
        });
      };

      portalHelperService.getDaysRemaining = function (date_string) {
        return Math.round(((new Date(date_string)).getTime() - (new Date()).getTime()) / 1000 / 3600 / 24);
      };

      portalHelperService.getHoursRemaining = function (date_string) {
        return Math.round(((new Date(date_string)).getTime() - (new Date()).getTime()) / 1000 / 3600);
      };

      portalHelperService.getSecondsRemaining = function (date_string) {
        return Math.round(((new Date(date_string)).getTime() - (new Date()).getTime()) / 1000);
      };

      portalHelperService.days_since = function(date) {
        return -portalHelperService.getDaysRemaining(date);
      };

      // Return Today or Yesterday  if date is today or yesterday, else false
      portalHelperService.today_or_yesterday = function(dateString) {
        if (dateString) {
          const dt = new Date(dateString);
          const today = new Date();

          //  Set one day before today as yesterday
          const yesterday = new Date(new Date().setDate(today.getDate() - 1));
          if (dt.getDate() === today.getDate() && dt.getMonth() === today.getMonth() && dt.getYear() === today.getYear()) {
            return 'Today';
          }

          if (dt.getDate() === yesterday.getDate() && dt.getMonth() === yesterday.getMonth() && dt.getYear() === yesterday.getYear()) {
            return 'Yesterday';
          }
        }

        return false;
      };

      portalHelperService.get_days_month_years = function(old_date) {
        const days_since = portalHelperService.days_since(old_date);
        const months_since = portalHelperService.numberOfMonths(old_date);
        const years_since = parseInt(months_since / 12);

        if (days_since <= 31) {
          return days_since + ' days ago';
        } else if (months_since < 13) {
          return months_since + (months_since > 1 ? ' months' : ' month') + ' ago';
        } else {
          return years_since + (years_since > 1 ? ' years' : ' year') + ' ago';
        }
      };

      portalHelperService.numberOfMonths = function(old_date) {
        const today = new Date();
        old_date = new Date(old_date);
        const years_since = today.getYear() - old_date.getYear();
        let months_since = today.getMonth() - old_date.getMonth();
        months_since = months_since + years_since * 12;
        return months_since;
      };

      portalHelperService.getTimeRemaining = function (date_string, zero_string) {
        // this returns units as well as a value
        // we will return time max up to two percision levels like
        // days and hours
        // hours and minutes if (days is zero)
        // minutes and seconds if (days and hours are zero)
        // days and minutes (if hours are zero)
        // days (if hours and mintues are zero)
        // and so on
        // negative values are returned as <zero_string>
        if (zero_string === undefined) {
          zero_string = '0';
        }

        if (new Date(date_string) < new Date()) {
          return zero_string;
        }

        const diffTime = moment(new Date(date_string)).diff(moment());
        const duration = moment.duration(diffTime);
        const days = duration.days(),
          hours = duration.hours(),
          minutes = duration.minutes(),
          seconds = duration.seconds();

        let timeRemStr = '';
        if (days >= 1) {
          timeRemStr =  (days === 1 ? '1 day' : days + ' days') ;
        }

        if (hours >= 1) {
          const hoursStr = (hours === 1 ? '1 hour' : hours + ' hours');
          if (timeRemStr) {
            return timeRemStr + ' and ' + hoursStr;
          }

          timeRemStr = hoursStr;
        }

        if (minutes >= 1) {
          const minutesStr = (minutes === 1 ? '1 minute' : minutes + ' minutes');
          if (timeRemStr) {
            return timeRemStr + ' and ' + minutesStr;
          }

          timeRemStr = minutesStr;
        }

        if (seconds >= 1) {
          const secondsStr = (seconds === 1 ? '1 second' : seconds + ' seconds');
          if (timeRemStr) {
            // add seconds only if days is < 1
            // to make sure we are not returning strings like 10 days 5 seconds
            // and we reach here means hours and minutes are < 1
            // if days >=1 and hours >=1 or mintues >=1 we will not reach
            // at this point, we will return either from hours or minutes block
            return timeRemStr + ' and ' + secondsStr;
          }

          return secondsStr;
        }

        return timeRemStr || '0';
      };

      portalHelperService.getPayerTimeRemaining = function (date_string, overdue_string, expired_string) {
        // like getTimeRemaining, but 24 hours of overdue_string before expired_string
        const seconds = Math.round(((new Date(date_string)).getTime() - (new Date()).getTime()) / 1000);
        if (seconds < -24 * 3600) {
          return expired_string;
        }

        return portalHelperService.getTimeRemaining(date_string, overdue_string);
      };

      portalHelperService.getPayerTimeRemainingClassName = function (date_string) {
        // like getTimeRemaining, but 24 hours of overdue_string before expired_string
        const seconds = Math.round(((new Date(date_string)).getTime() - (new Date()).getTime()) / 1000);
        const SECONDS_IN_DAY = 24 * 60 * 60;
        if (seconds < SECONDS_IN_DAY) {
          if (seconds > (2 * 3600)) {
            return 'text-warning fw-bold';
          }
          return 'text-danger fw-bold';
        }
        return 'text-success fw-bold';
      };

      portalHelperService.getPayerTimeRemainingIconClassName = function (date_string) {
        return portalHelperService.getPayerTimeRemainingClassName(date_string).includes('text-success') ?
          'fa fa-lg fa-clock-o' :
          'fa fa-exclamation-triangle';
      };

      portalHelperService.escapeDocumentNames = function (documents_list) {
        if (!documents_list){
          return;
        }

        for (let i = 0; i < documents_list.length; ++i) {
          //documents_list[i].name_esc = documents_list[i].name.replace(/\//g, "%252F").replace(/\&/, "%2526").replace(/\?/, "%253F").replace(/#/, "%2523").replace(/"/, "%2522").replace(/\\/, "%255C");
          documents_list[i].name_esc = encodeURIComponent(documents_list[i].name).replace(/%2F/g,
            '%252F');
        }
      };

      portalHelperService.getFlagUrl = function (flag_name) {
        return '../Images/Flags/' + flag_name;
      };

      portalHelperService.addApostrophe = function (text) {
        if (text == null || text == '') {
          return '';
        }

        if (text[text.length - 1] === 's') {
          return text + '\'';
        }

        return text + '\'s';
      };

      portalHelperService.showPopupError = function (title, text, ok_callback, scope) {
        return $ngConfirm({
          title: title,
          scope: scope,
          content: text,
          type: 'red',
          buttons: {
            OK: {
              btnClass: 'mat ui critical button',
              action: ok_callback
            }
          }
        });
      };

      portalHelperService.showPopupWarning = function (title, text, ok_callback, scope) {
        return $ngConfirm({
          title: title,
          scope: scope,
          content: text,
          type: 'orange',
          buttons: {
            OK: {
              btnClass: 'mat ui primary button',
              action: ok_callback
            }
          }
        });
      };

      portalHelperService.showPopupYesNo = function (
        title, text, yes_callback, no_callback, yes_text, no_text, destroy_callback, color) {

        yes_callback = portalHelperService.fix_undefined(yes_callback);
        no_callback = portalHelperService.fix_undefined(no_callback);

        yes_text = (yes_text) ? yes_text : 'Yes';
        no_text = (no_text) ? no_text : 'No';

        return $ngConfirm({
          title: title,
          content: text,
          type: color || 'orange',
          closeIcon: false,
          escapeKey: false,
          backgroundDismiss: false,
          onDestroy: destroy_callback,
          buttons: {
            Yes: {
              text: yes_text,
              btnClass: 'mat ui primary button',
              action: function (scope, button) {
                if (yes_callback) {
                  return yes_callback(scope, button);
                }
              }
            },
            No: {
              btnClass: 'mat ui critical button',
              text: no_text,
              action: function (scope, button) {
                if (no_callback) {
                  return no_callback(scope, button);
                }
              }
            }
          }
        });
      };

      portalHelperService.showActionRequiredPopup = function (title, content, buttonText, targetUrl) {
        return $ngConfirm({
          title: title,
          content: content,
          type: 'red',
          columnClass: 'medium',
          closeIcon: true,
          escapeKey: true,
          buttons: {
            GoToTarget: {
              text: buttonText,
              btnClass: 'mat ui primary button',
              action: function () {
                globalThis.location.href = targetUrl;
              }
            },
            Close: {
              btnClass: 'mat ui primary button'
            }
          }
        });
      };

      portalHelperService.getRouteParam = function (name) {
        return $routeParams[name];
      };

      portalHelperService.clearRouteParam = function (name) {
        delete $routeParams[name];
        $location.search(name, null);
      };

      portalHelperService.showPopupOK = function (title, text, callback) {
        $.confirm({
          title: title,
          content: text,
          type: 'green',
          typeAnimated: true,
          buttons: {
            OK: {
              btnClass: 'mat ui primary button',
              action: function () {
                if (callback && typeof (callback) === 'function') {
                  callback();
                }
              }
            }
          }
        });
      };

      portalHelperService.showConfirmOkWithDestroy = function (title, text, fn_ok) {
        const cur_scope = $rootScope.$new(true);
        cur_scope.clicked = false;

        $ngConfirm({
          title: title,
          content: text,
          type: 'green',
          onDestroy: function () {
            // submit only after popup is destroyed, otherwise scroll does not work!!!
            if (cur_scope.clicked && fn_ok) {
              fn_ok();
            }
          },
          buttons: {
            OK: {
              btnClass: 'mat ui primary button',
              action: function () {
                cur_scope.clicked = true;
              }
            }
          }
        });
      };

      portalHelperService.showToast = function (toastType, text, title, make_sticky) {
        const allowedTypes = ['info', 'warning', 'success', 'error'];
        if (!_.contains(allowedTypes, toastType)) {
          toastType = 'info';
        }

        const toastrOptions = make_sticky && (make_sticky === true)
          ? { 'timeOut': 0, 'extendedTimeOut': 0 }
          : {};

        toastr[toastType](text, title, toastrOptions);
      };

      portalHelperService.showPopup = function (title, text, close_callback, color) {
        close_callback = portalHelperService.fix_undefined(close_callback);

        $.confirm({
          title: title,
          content: text,
          type: (color) ? color : 'green',
          typeAnimated: true,
          buttons: {
            Ok: {
              text: 'Ok',
              btnClass: 'mat ui primary button',
              action: function () {
                if (close_callback) {
                  close_callback();
                }
              }
            }
          }
        });
      };

      portalHelperService.initPostcodeInput = function ($scope) {
        // Helper function for payer edit view (admin portal, payer portal)

        $scope.postcode_regex = '';
        $scope.postcode_placeholder = '';

        // UK
        if ($scope.payer.country_of_residence == portalHelperService.countryCode.UK) {
          $scope.postcode_regex = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s+[0-9][A-Z]{2}$/i;
          $scope.postcode_placeholder = 'e.g. CB3 9ET';
        }
        // US
        else if ($scope.payer.country_of_residence == portalHelperService.countryCode.US) {
          $scope.postcode_regex = /^[0-9]{5}$/i;
          $scope.postcode_placeholder = 'e.g. 82190';
        }
      };

      portalHelperService.clearStateIfNeeded = function ($scope) {
        // Helper function for payer edit view (admin portal, payer portal)
        // Clears state selection if current model value is not in dropdown

        const state = $scope.payer.address_line4;
        let states_list = '';

        // Canada
        if ($scope.payer.country_of_residence == portalHelperService.countryCode.Canada) {
          states_list = $scope.payer_lists['states']['Canada'];
        }
        // US
        else if ($scope.payer.country_of_residence == portalHelperService.countryCode.US) {
          states_list = $scope.payer_lists['states']['United States'];
        }

        if (states_list && states_list.indexOf(state) === -1) {
          // clear state
          $scope.payer.address_line4 = '';
        }
      };

      portalHelperService.overWritePayerOptionSelectedValues = function (oldResponses, newResponses) {
        for (const key in oldResponses) {
          if (Object.prototype.hasOwnProperty.call(newResponses, key)) {
            newResponses[key].payer_option_selected = oldResponses[key].payer_option_selected;
          }
        }
      };

      portalHelperService.populatePayerOptionSelected = function (responses) {
        for (let i = 0; i < responses.length; i++) {
          responses[i].payer_option_selected = !stringHelper.isNullOrEmpty(responses[i].payer_option);
        }
      };

      /***
       * Adds a flag in each response which determines if the clarification request is editable / delete-able
       * @param responses
       */
      portalHelperService.populateClarificationRequestEditable = function (responses) {
        for (let i=0; i<responses.length; i++) {
          responses[i].is_clar_request_editable = false;
          if (responses[i].clarification_response == null) {
            responses[i].is_clar_request_editable = responses[i].clarification_request !== null;
          } else if (responses[i].clarification_response.rejection_history == null || responses[i].clarification_response.rejection_history.length === 0) {
            responses[i].is_clar_request_editable = false;
          } else if (responses[i].clarification_response.is_rejected == null) {
            responses[i].is_clar_request_editable = false;
          } else {
            responses[i].is_clar_request_editable = responses[i].clarification_response.is_rejected;
          }
        }
      };

      portalHelperService.handleFloatValues = function (responses) {
        for (let i = 0; i < responses.length; i++) {
          if (!responses[i].van_westendorp_responses) {
            // Do nothing
          } else {
            responses[i].van_westendorp_responses.acceptable =
              parseFloat(responses[i].van_westendorp_responses.acceptable);
            responses[i].van_westendorp_responses.expensive =
              parseFloat(responses[i].van_westendorp_responses.expensive);
            responses[i].van_westendorp_responses.too_expensive =
              parseFloat(responses[i].van_westendorp_responses.too_expensive);
            responses[i].van_westendorp_responses.prohibitive =
              parseFloat(responses[i].van_westendorp_responses.prohibitive);
          }
        }

        return responses;
      };

      /**
       * @namespace portalHelper
       * @desc Shows a pop up which allows client to upload new document or select an existing document.
       *
       * @param {Object} cur_scope
       * The current scope of the calling controller.
       *
       * @param {Number} new_document_owner_id
       * The ID of the owner to whom a new uploaded document should belong to
       *
       * @param {Array} list_of_documents
       * Array of document objects to list in the table. Should contain `id` and `name`.
       *
       * @param {Array} selected_document_ids
       * Array of integers representing selected Ids which should not be shown in the table.
       *
       * @param {Function} callback
       * Callback method which returns a list of selected Ids and a flag which shows whether a new document was uploaded
       * (in case documents need to be refreshed in parent).
       *
       * @param {Function} callback_on_doc_uploaded
       * Callback method which can be used to do some action after document upload is successfull.
       *
       * @returns {Object}
       * selected_documents: Array of integers.
       * new_document_added: Boolean flag.
       */
      // RPR-6752: seconds -> "about N minutes" (min 1 minute); null when not
      // usable. Single source of truth for the video-processing ETA label,
      // reused by the rprVideoPlayer directive, the Document Manager upload
      // rows, and the associatedDocuments status pill.
      //
      // The Math.max(1, ...) below is where the "about 1 minute" floor comes from:
      // the backend's raw estimate decays toward zero, but every value under 60s
      // renders identically here. That is why the backend records overrun deadlines
      // against ETA_DISPLAY_FLOOR_SECONDS rather than the raw seconds -- so what it
      // enforces matches what this function actually promises the user.
      portalHelperService.formatVideoEta = function (seconds) {
        if (typeof seconds !== 'number' || Number.isNaN(seconds) || seconds <= 0) { return null; }
        const minutes = Math.max(1, Math.round(seconds / 60));
        return 'about ' + minutes + ' minute' + (minutes === 1 ? '' : 's');
      };

      // RPR-6752 (QA re-open, comment 64616): compose the Document Manager's
      // video-processing note as ONE line. It previously rendered as two stacked
      // <small> notes ("needs extended processing" and the ETA), which is exactly
      // what QA reported. Single source of truth so the reason, the ETA and the
      // overrun state can never split across lines again.
      //
      // `overrun` means the transcode has outlived the ETA the backend promised
      // (the displayed estimate only ever ratchets downward, and formatVideoEta
      // above renders anything under a minute as "about 1 minute", so without this
      // it sits there indefinitely). We then say so instead of quoting a stale
      // number. A 'timed_out' row already renders a
      // "Processing (taking longer)" pill, so the overrun clause is suppressed
      // there rather than said twice on adjacent lines.
      //
      // Returns null when there is nothing to say, so the template renders no
      // element at all rather than an empty one.
      portalHelperService.formatVideoProcessingNote = function (row) {
        const parts = [];
        if (row?.non_standard) { parts.push('needs extended processing'); }
        // Nested rather than `overrun && status !== 'timed_out'` in the first
        // arm: with that shape a timed_out row fell through to the `else if` and
        // quoted the ETA -- a stale number on the one row meant to have stopped
        // quoting one. Unreachable only because the backend never returns an ETA
        // and an overrun together; nesting makes it structural instead.
        if (row?.overrun) {
          if (row.status !== 'timed_out') { parts.push('taking longer than expected'); }
        } else if (row?.eta_label) {
          parts.push(row.eta_label + ' remaining');
        }
        if (!parts.length) { return null; }
        const note = parts.join(' — ');
        return note.charAt(0).toUpperCase() + note.slice(1);
      };

      // RPR-6752: map one status-poll payload onto the row the Document Manager
      // renders -- progress percent, non-standard flag, overrun verdict, ETA
      // label, and (RPR-6923) which flavour of give-up produced a 'timed_out'.
      // On the service (not inside onVideoPollerUpdate's closure) so the
      // mapping is unit-testable; keep it free of DOM/scope work.
      // progress_percent is sticky: the backend's short-TTL, reconcile-throttled
      // progress cache reports null routinely mid-transcode, so clearing it would
      // flicker the "Processing N%" pill (a terminal status hides the pill
      // anyway). non_standard tracks the backend flag so a standard replacement
      // of a non-standard original no longer stays flagged. Backward-compatible:
      // older backends omit these keys, leaving the pill on plain "Processing".
      portalHelperService.applyVideoProcessingFields = function (uploadRow, update) {
        if (update?.progress?.percent != null) {
          uploadRow.progress_percent = update.progress.percent;
        }
        if (update && 'non_standard_input' in update) {
          uploadRow.non_standard = !!update.non_standard_input;
        }
        // RPR-6752 (QA re-open): only a definite boolean may change the overrun
        // verdict. The backend sends null when the deadline could not be read
        // this poll (unknown), and older backends omit the key entirely; in both
        // cases keep the last verdict -- a one-poll cache blip must not un-say
        // "taking longer than expected" once a user has been told it.
        if (typeof update?.processing_overrun === 'boolean') {
          uploadRow.overrun = update.processing_overrun;
        }
        // Deliberately NOT sticky, unlike the verdict above: a number that cannot
        // be verified this poll is dropped, because a stale "about 5 minutes
        // remaining" is worse than showing nothing (see the status_note note in
        // onVideoPollerUpdate). A proven overrun is monotone; a number decays.
        uploadRow.eta_label = portalHelperService.formatVideoEta(update?.estimated_seconds_remaining);
        // RPR-6923 review: carry the give-up FLAVOUR, not just the status word. 'timed_out'
        // arrives for two unrelated reasons (see replaceUpdateOutcome below) and the row kept
        // only the word, so the Document Manager's badge told a poll give-up it was "Still
        // processing on the server" -- asserting knowledge of a server we could not reach.
        // Unconditional like eta_label, not sticky like `overrun`: the flag describes THIS
        // poll. Derived from the same `poll_failed` as associated_documents' applyStatus
        // (takingLonger vs statusUnavailable) and rpr_video_player's onStatusUpdate, so every
        // surface that tells the two apart reads one flag instead of re-deriving it. What each
        // one then SAYS is its own: here only the tooltip changes. (The video picker's badge
        // tells them apart nowhere -- videoStatusBadgeHtml is handed the status word alone,
        // via videoStatusBadge -- and needs no split: it carries a label and a class, and
        // claims nothing about the server.)
        uploadRow.status_unavailable = update?.poll_failed === true;
      };

      // RPR-6923 review: the replace path's whole status / message / toast DECISION,
      // lifted out of onVideoPollerUpdate's closure for the same reason
      // applyVideoProcessingFields above sits here -- so it can be asserted directly.
      // It was previously inline in an unexported const reachable only from the poller
      // callback inside showFileSelectorPopup, so no spec could touch it: dropping the
      // `!pollFailed` guard below left the whole suite green while a poll give-up wrote
      // a permanent ERRORED row again. portal_helper_document_attach.spec.js pins it now.
      //
      // Pure: reads only `update` and CONSTANTS; writes no row and shows no toast. The
      // caller owns both, so a spec needs no DataTable, no scope, no uploader and no
      // toastr global. `error_message: null` means "leave the row's existing text
      // alone": the caller guards with `if (outcome.error_message)`, so a went-live or
      // still-transcoding poll does NOT clear a "Could not check the replacement status"
      // note a give-up left behind. Nothing surfaces that today -- the give-up calls the
      // poller's stop(), so no later poll can reach the row. `toast: null` means say
      // nothing.
      //
      // RPR-6711: a replace tracks the staged replacement via replace_status (the live
      // asset stays `ready` and keeps playing throughout).
      //
      // RPR-6923: 'timed_out' arrives for TWO unrelated reasons and only one is about
      // the replacement. A stall / hard-ceiling timeout (RPR-6752) means the server is
      // genuinely still working and may never finish, so the EM is told to refresh. A
      // give-up after repeated poll failures (`poll_failed`) means we stopped being able
      // to ask -- nothing is known to be wrong, so it stays PROCESSING. Reading the
      // status word alone mapped the second to ERRORED: the false, PERMANENT verdict
      // this ticket exists to stop, because the give-up also calls stop() so the row
      // never self-corrects. Branch ORDER is load-bearing: a real failure outranks a
      // give-up flag on the same payload, because a failure is knowledge.
      portalHelperService.replaceUpdateOutcome = function (update) {
        const statuses = CONSTANTS.videoProcessingStatuses;
        const toasts = CONSTANTS.typeOfToasts;
        const TOAST_TITLE = 'Video replacement';
        const pollFailed = update?.poll_failed === true;
        if (update?.replace_status === 'errored' || update?.status === statuses.ERRORED) {
          return {
            status: statuses.ERRORED,
            error_message: update?.replace_error_message || 'Replacement failed',
            toast: {
              type: toasts.ERROR, title: TOAST_TITLE,
              message: 'Replacement failed — the original video is still live.'
            }
          };
        }
        if (!update?.replace_status && update?.status === statuses.READY) {
          return {
            status: statuses.READY,
            error_message: null,
            toast: {
              type: toasts.SUCCESS, title: TOAST_TITLE,
              message: 'Replacement is now live — viewers now see the new video.'
            }
          };
        }
        if (update?.status === 'timed_out' && !pollFailed) {
          return {
            status: statuses.ERRORED,
            error_message: 'Replacement is taking longer than expected; '
              + 'the original video is still live. Refresh to check whether it went live.',
            toast: {
              type: toasts.WARNING, title: TOAST_TITLE,
              message: 'Replacement is taking longer than expected — the original video is still live. '
                + 'Refresh to check its status.'
            }
          };
        }
        if (pollFailed) {
          return {
            status: statuses.PROCESSING,
            error_message: 'Could not check the replacement status. '
              + 'Refresh to see whether it went live.',
            toast: {
              type: toasts.WARNING, title: TOAST_TITLE,
              message: 'Could not check the replacement status — the original video is still playing. '
                + 'Refresh to check.'
            }
          };
        }
        // Still transcoding; the existing video keeps playing, and we say nothing.
        return {status: statuses.PROCESSING, error_message: null, toast: null};
      };

      // RPR-S7721: hoisted to service scope (use $rootScope, so they can't go to
      // module scope). Called in production only by the per-upload handlers in
      // showFileSelectorPopup; onVideoPollerUpdate is additionally lifted onto the
      // service below so a spec can reach it.
      // `documentId` is passed in rather than read off `uploadRow.document_id`: that
      // property is assigned inside an $applyAsync block, and onVideoUploadComplete
      // documents the same hazard where it hands the local id to
      // syncVideoTableAfterUpload. Reading the property here would make the row-drop
      // silently no-op (phDropVideoRow's null guard) if the queue order ever changed.
      const onVideoPollerUpdate = function (uploadRow, update, uploader, documentId) {
        $rootScope.$applyAsync(function () {
          // RPR-6752: surface the backend's transcode progress + non-standard-input
          // flag + ETA on the row (Document Manager status pill) for BOTH replace
          // and normal rows -- mapped before the is_replace early return so a long
          // replacement's "needs extended processing" note shows too. (Only that
          // note, not an ETA: the backend gates both the ETA and the overrun on the
          // document still being in a processing state, and a staged replace leaves
          // the live document `ready` because the old video keeps playing, so during
          // a replace both come back null/false.)
          portalHelperService.applyVideoProcessingFields(uploadRow, update);
          if (uploadRow.is_replace) {
            // The decision itself lives in replaceUpdateOutcome (above) so a spec can
            // assert it; only the row writes and the toast happen here.
            const outcome = portalHelperService.replaceUpdateOutcome(update);
            uploadRow.status = outcome.status;
            // Guarded, not unconditional: the went-live and still-transcoding outcomes
            // carry no message and must leave the previous poll's text alone, exactly as
            // the inline chain this replaced did. An unconditional assignment would wipe
            // a "Could not check the replacement status" note the moment polling resumed.
            if (outcome.error_message) {
              uploadRow.error_message = outcome.error_message;
            }
            // One toast, not a per-tick one: the give-up fires once per poller.
            if (outcome.toast) {
              portalHelperService.showToast(outcome.toast.type, outcome.toast.message, outcome.toast.title);
            }
            // Composed here as well as at the end of the handler -- see the note
            // at the other assignment. In THIS branch status is only ever
            // ERRORED / READY / PROCESSING (a staged replace that times out maps to
            // ERRORED above), so the note's 'timed_out' suppression never applies.
            uploadRow.status_note = portalHelperService.formatVideoProcessingNote(uploadRow);
            return;
          }
          if (update?.status) {
            uploadRow.status = update.status;
          }
          if (update?.error_message) {
            uploadRow.error_message = update.error_message;
          }
          // RPR-6719: a corrupted video only fails once Mux transcodes it, so this
          // is the first and only point the EM can be told. Until now the row just
          // went quiet with an "Errored" pill carrying Mux's internal text, and the
          // unplayable clip stayed in the Videos tab -- mirroring what the replace
          // branch above already does for a failed replacement.
          if (phIsVideoIngestFailure(update, CONSTANTS.videoProcessingStatuses.ERRORED)) {
            uploadRow.error_message = PH_VIDEO_INGEST_FAILED_MESSAGE;
            portalHelperService.showToast(CONSTANTS.typeOfToasts.ERROR,
              PH_VIDEO_INGEST_FAILED_MESSAGE, 'Video upload');
            phDropVideoRow(documentId, uploader);
          }
          // RPR-6752 (QA re-open): precomputed once per poll rather than called from
          // the template on every digest, and only after `status` is settled -- the
          // note suppresses its overrun clause for 'timed_out' rows, so composing it
          // any earlier would read the wrong status.
          //
          // IF YOU ADD ANOTHER EARLY RETURN to this handler, assign status_note
          // before it. The row keeps its value between polls, so a skipped
          // assignment leaves the PREVIOUS poll's string on screen -- a permanently
          // stale "about 5 minutes remaining", which is worse than showing nothing.
          // (The RPR-6719 ingest-failure block above drops the row but does not
          // return, so this still runs for a corrupted clip.)
          uploadRow.status_note = portalHelperService.formatVideoProcessingNote(uploadRow);
          // RPR-6719 (QA re-open 2): mirror the verdict onto the picker's own row.
          // Deliberately NOT done in the is_replace branch above: a staged
          // replacement that fails leaves the LIVE asset ready and still playing, so
          // that row must stay attachable.
          phSyncVideoPickerRowStatus(uploadRow.document_id, uploadRow.status);
        });
      };

      // RPR-6923 review: exposed purely so a spec can drive the APPLICATION of
      // replaceUpdateOutcome -- the row writes and the showToast argument order --
      // which nothing could reach while this was a closure-local const. The decision
      // was already pinned; this pins that the row actually receives it. Nothing in
      // production reads this property: the poller callback in showFileSelectorPopup
      // still calls the const directly, so the export is test-only by design.
      portalHelperService.onVideoPollerUpdate = onVideoPollerUpdate;

      const onVideoUploadProgress = function (uploadRow, fraction) {
        $rootScope.$applyAsync(function () {
          uploadRow.progress = fraction;
        });
      };

      portalHelperService.showFileSelectorPopup = function (cur_scope, new_document_owner_id, list_of_documents,
        selected_document_ids, callback, callback_on_doc_uploaded) {
        // RPR-6094: lazy-resolve video factories. They're loaded by admin/index.html
        // and client/index.html; if a future portal embeds this helper without
        // them, video uploads simply fail gracefully with a friendly popup.
        let videoUploaderFactory = null;
        let videoStatusPollerFactory = null;
        try {
          videoUploaderFactory = $injector.get('videoUploaderFactory');
          videoStatusPollerFactory = $injector.get('videoStatusPollerFactory');
        } catch (e) {
          // Video factories not registered in this portal bundle — videos disabled.
        }

        // Define default document data structure
        cur_scope.document_uploader = {
          document: {
            owner_id: new_document_owner_id
          },
          new_document_added: false,
          scope: cur_scope,
          selected_documents: [],
          // RPR-6719: true while the pre-upload content check runs; greys the Upload
          // button so the wait is visible and a second click can't start a second
          // upload chain.
          verifying_content: false,
          // RPR-6094: per-row video upload state + active pollers for cleanup.
          video_uploads: [],
          _active_pollers: [],
          // RPR-6721: inline duplicate/overwrite confirmation (replaces the old
          // stacked $ngConfirm modal). onDuplicate sets this; the picker template
          // shows a focused confirm panel while it is non-null, and the buttons
          // below resolve the uploader's paused `event`.
          duplicate_prompt: null,
          // RPR-6758: collisions raised while another confirm is on screen wait
          // here (multi-file selection can collide several uploads at once).
          // Overwriting the single prompt slot would strand the earlier paused
          // upload at "Uploading 0%" with no way to resolve it.
          _pending_duplicate_prompts: [],
          getFlagUrl: portalHelperService.getFlagUrl,
          // Clear the visible prompt slot and surface the next queued one. The
          // queued prompt is applied via $timeout (NOT $applyAsync, which can
          // flush inside the ng-click digest) so the null state is digested
          // first: the ng-if panel fully tears down and `ng-init="dp = ..."`
          // rebinds to the new prompt instead of rendering the stale one.
          _closeDuplicatePrompt: function () {
            const uploader = cur_scope.document_uploader;
            uploader.duplicate_prompt = null;
            const next = uploader._pending_duplicate_prompts.shift();
            if (next) {
              $timeout(function () { uploader.duplicate_prompt = next; }, 0);
            }
          },
          confirmOverwrite: function () {
            // RPR-6711: "Replace" resolves the paused uploader event; the uploader
            // then re-runs in replace mode against the colliding clip.
            const prompt = cur_scope.document_uploader.duplicate_prompt;
            if (prompt?.event) { prompt.event.proceed(); }
            cur_scope.document_uploader._closeDuplicatePrompt();
          },
          uploadAnywayDuplicate: function () {
            const prompt = cur_scope.document_uploader.duplicate_prompt;
            if (prompt?.event) { prompt.event.proceed(); }
            cur_scope.document_uploader._closeDuplicatePrompt();
          },
          cancelDuplicate: function () {
            const prompt = cur_scope.document_uploader.duplicate_prompt;
            if (prompt?.event) { prompt.event.cancel(); }
            cur_scope.document_uploader.dropAbandonedUpload(prompt);
            cur_scope.document_uploader._closeDuplicatePrompt();
          },
          // Drop the in-flight status row of a cancelled upload so it doesn't
          // linger at "Uploading 0%" with a stuck progress bar -- the upload
          // was never completed.
          dropAbandonedUpload: function (prompt) {
            if (!prompt?.uploadRow) { return; }
            const rows = cur_scope.document_uploader.video_uploads;
            const idx = rows.indexOf(prompt.uploadRow);
            if (idx >= 0) { rows.splice(idx, 1); }
          },
          is_admin: authHelper.isUserAdmin(),
          // RPR-6717: tab-aware browse filter + supported-format hints. The accept
          // MIME list and the max-size label derive from the shared RPR-6094
          // constants; video_formats_label is a human-readable string kept in sync
          // with VIDEO_ACCEPTED_MIMES by hand (matching the popup copy below).
          accept_filter: function () {
            if (cur_scope.document_uploader.active_picker_tab === 'videos') {
              // Include extensions alongside MIME types so OS file pickers that
              // filter by extension also restrict to supported videos (RPR-6717).
              return (CONSTANTS.VIDEO_ACCEPTED_MIMES || [])
                .concat(CONSTANTS.VIDEO_ACCEPTED_EXTS || []).join(',');
            }
            return 'application/pdf,.pdf';
          },
          video_formats_label: 'MP4, MOV, WebM',
          video_max_size_label: Math.round((CONSTANTS.VIDEO_MAX_BYTES || 0) / (1024 * 1024 * 1024)) + ' GB'
        };

        // RPR-6094: branch by file type. Videos use the chunked S3 uploader +
        // status poller; PDFs (and anything else falling through to the existing
        // code path) keep the original single-shot multipart POST.
        const isVideoFile = function (file) {
          if (!file) return false;
          const acceptedMimes = CONSTANTS.VIDEO_ACCEPTED_MIMES || [];
          if (acceptedMimes.includes(file.type)) return true;
          const acceptedExts = CONSTANTS.VIDEO_ACCEPTED_EXTS || [];
          const name = (file.name || '').toLowerCase();
          for (const ext of acceptedExts) {
            if (name.endsWith(ext)) return true;
          }
          return false;
        };

        // RPR-6745: an upload creates its backing Document up front (_initiate),
        // so a dialog dismissed mid-upload -- or a page refresh / tab close --
        // would otherwise orphan a "Video not available" record that also blocks
        // re-uploading the same file. Retire any still-uploading placeholder on
        // dialog teardown, and warn before a page unload that would abandon one.
        const hasActiveVideoUpload = function () {
          const rows = cur_scope.document_uploader?.video_uploads || [];
          return rows.some(function (r) {
            return r && r.status === CONSTANTS.videoProcessingStatuses.UPLOADING;
          });
        };
        const beforeUnloadHandler = function (e) {
          if (!hasActiveVideoUpload()) { return undefined; }
          // Standard cross-browser trigger for the native "Leave site?" prompt.
          e.preventDefault();
          e.returnValue = '';
          return '';
        };
        let beforeUnloadRegistered = false;
        const registerBeforeUnloadGuard = function () {
          if (beforeUnloadRegistered) { return; }
          $window.addEventListener('beforeunload', beforeUnloadHandler);
          beforeUnloadRegistered = true;
        };
        const removeBeforeUnloadGuard = function () {
          if (!beforeUnloadRegistered) { return; }
          $window.removeEventListener('beforeunload', beforeUnloadHandler);
          beforeUnloadRegistered = false;
        };
        const abortInFlightVideoUploads = function () {
          const rows = cur_scope.document_uploader?.video_uploads || [];
          for (const row of rows) {
            if (row && row.status === CONSTANTS.videoProcessingStatuses.UPLOADING &&
              row._uploader && typeof row._uploader.abort === 'function') {
              try { row._uploader.abort(); } catch { /* best-effort cleanup */ }
            }
          }
        };

        // RPR-S2004: video upload handlers hoisted to depth 3 (showFileSelectorPopup
        // body) so the videoUploaderFactory.create() adapters below stay shallow.
        const syncVideoTableAfterUpload = function (uploadRow, surveyId, documentId, isReplace, data) {
          if (!$.fn.dataTable.isDataTable('#videos-list-table')) {
            // Dialog was dismissed before the upload completed; the refreshed
            // client lists above repopulate the table on the next open.
            return;
          }
          const videoTable = $('#videos-list-table').DataTable();
          const uploader = cur_scope?.document_uploader || {};
          const muxFields = {
            mux_thumbnail_url: data?.response?.mux_thumbnail_url || null,
            mux_playback_id: data?.response?.mux_playback_id || null,
            mux_processing_status: data?.response?.mux_processing_status
              || CONSTANTS.videoProcessingStatuses.PROCESSING
          };
          const existingRows = videoTable.rows(function (idx, rowData) {
            return rowData.id === documentId;
          });

          // RPR-6711: an in-place replace keeps the SAME document id and the
          // existing table row (its attachments already point at it). Mark that
          // row "Replaced" (green pill) and refresh its mux fields in place --
          // no row is added or dropped, and no attachment re-pointing is needed.
          if (isReplace) {
            existingRows.every(function () {
              this.data(_.extend({}, this.data(), muxFields, { is_recently_replaced: true }));
            });
            videoTable.draw();
            return;
          }

          // New upload: add the row unless it is somehow already listed.
          if (existingRows.any()) {
            videoTable.draw();
            return;
          }
          videoTable.rows.add([_.extend({
            id: documentId,
            name: uploadRow.file_name,
            survey_id: surveyId,
            added_datetime: new Date().toISOString(),
            media_type: 'video',
            is_attached: false,
            attached_sort: 0
          }, muxFields)]).draw();
          uploader.videos_count = (uploader.videos_count || 0) + 1;
        };

        // RPR-6758: show a duplicate confirm, or queue it when one is already
        // on screen (see _pending_duplicate_prompts). The assignment runs via
        // $applyAsync because onDuplicate fires from the uploader's promise
        // chain, outside Angular's digest.
        const enqueueDuplicatePrompt = function (prompt) {
          $rootScope.$applyAsync(function () {
            const uploader = cur_scope.document_uploader;
            if (uploader.duplicate_prompt) {
              uploader._pending_duplicate_prompts.push(prompt);
            } else {
              uploader.duplicate_prompt = prompt;
            }
          });
        };

        const onVideoUploadDuplicate = function (uploadRow, event) {
          // event = { duplicates, proceed(), cancel() }
          // RPR-6721: render the confirmation INLINE in the picker rather than
          // stacking a second $ngConfirm modal on top of it. Store the paused
          // `event` + match details on the picker scope; the picker template
          // shows a focused confirm panel bound to document_uploader.duplicate_prompt
          // and its buttons resolve the event via the document_uploader methods.
          if (!Array.isArray(event.duplicates) || event.duplicates.length === 0) {
            event.proceed();
            return;
          }
          // RPR-6758: a doc matching content AND name arrives as 'both' -- it is
          // a replace target, and its content-match info renders inside the SAME
          // (merged) replace panel instead of a second content popup.
          const filenameMatch = event.duplicates.find(function (d) {
            return d.match_type === 'filename' || d.match_type === 'both';
          });
          const contentMatches = event.duplicates.filter(function (d) {
            return d.match_type === 'content' || d.match_type === 'both';
          });

          if (filenameMatch) {
            // The prompt object is mutated in place by the usage fetch below, so
            // the bound impact list fills in when it resolves.
            const prompt = {
              type: 'filename',
              duplicate: filenameMatch,
              // Identical-content info shown inside the merged panel (empty in
              // the pure-filename and 409-fallback paths -- template guards on
              // length).
              contentMatches: contentMatches,
              event: event,
              // The in-flight status row, so Cancel can clear it (the upload is
              // abandoned and would otherwise linger at "Uploading 0%").
              uploadRow: uploadRow,
              usage: null,
              // RPR-6758 (QA restyle): plain-English impact phrase, set together
              // with `usage` when the fetch resolves.
              usage_summary: null,
              usageLoading: true,
              usageError: false
            };
            enqueueDuplicatePrompt(prompt);
            // Load the "replace impact" -- every question / section / country the
            // existing video is attached to -- so the confirm makes "replace
            // everywhere it's used" explicit rather than silent. RPR-6758: bounded
            // so a hung request can't pin "Replace everywhere" disabled forever;
            // on timeout the usageError fallback shows and the button re-enables.
            HttpAuth.get(apiHelper.getApiUrl() + '/api/authoring/video/' + filenameMatch.document_id + '/usage/', { timeout: 8000 }).then(
              function (resp) {
                prompt.usage = resp?.data || null;
                prompt.usage_summary = phBuildReplaceUsageSummary(prompt.usage);
                prompt.usageLoading = false;
              },
              function () {
                // Non-fatal: fall back to the generic warning text.
                prompt.usageError = true;
                prompt.usageLoading = false;
              }
            );
            return;
          }

          if (contentMatches.length) {
            enqueueDuplicatePrompt({
              type: 'content',
              duplicates: event.duplicates,
              event: event,
              uploadRow: uploadRow
            });
            return;
          }

          // No actionable match -- should not happen, but defensively just proceed.
          event.proceed();
        };

        const onVideoUploadComplete = function (uploadRow, surveyId, data) {
          // Read document_id from the response BEFORE the $applyAsync
          // block runs -- the poller is created synchronously below
          // and the deferred assignment to uploadRow.document_id has
          // not committed yet at that point.
          const documentId = data?.document_id;
          // RPR-6711: an in-place replace keeps the SAME document id (no new row);
          // the existing video keeps playing while the staged replacement
          // transcodes. The poller tracks it via replace_status, not status.
          const isReplace = !!data?.is_replace;
          $rootScope.$applyAsync(function () {
            uploadRow.document_id = documentId;
            uploadRow.is_replace = isReplace;
            uploadRow.status = CONSTANTS.videoProcessingStatuses.PROCESSING;
            uploadRow.progress = 1;
          });
          // A replace upgrades an existing row in place rather than adding one.
          // Only ever set the flag -- never clear it: it's dialog-level and
          // cumulative, so a replace completing after a fresh upload must not
          // reset a prior new-document signal.
          if (!isReplace) {
            cur_scope.document_uploader.new_document_added = true;
          }
          // Refresh the shared client lists so the new video shows up in
          // the "existing documents" picker without requiring a page
          // reload. Mirrors how the legacy PDF success handler triggers
          // callback_on_doc_uploaded after a successful upload.
          if (typeof callback_on_doc_uploaded === 'function') {
            callback_on_doc_uploaded(function () {
              // No-op success callback; clientListService updates the
              // cache in place so subsequent dialog opens pick it up.
            });
          }
          // RPR-6700: surface the freshly-uploaded video in the Videos tab's
          // DataTable straight away (mirrors the PDF path's rows.add below).
          // Without this the clip only appeared after closing/reopening the
          // dialog, even though its upload-status row already showed "Ready".
          $timeout(function () {
            syncVideoTableAfterUpload(uploadRow, surveyId, documentId, isReplace, data);
          }, 0);
          // Start polling Mux status. For a replace, poll the staged replacement
          // (replace_status) rather than the already-ready live asset.
          const poller = videoStatusPollerFactory.create({
            documentId: documentId,
            isReplace: isReplace,
            // The uploader is passed through so a failed ingest can also drop the
            // clip's row from the Videos tab and keep its badge count in step
            // (RPR-6719).
            onUpdate: function (update) {
              onVideoPollerUpdate(uploadRow, update, cur_scope.document_uploader, documentId);
            }
          });
          cur_scope.document_uploader._active_pollers.push(poller);
          poller.start();
        };

        const onVideoUploadError = function (uploadRow, err) {
          $rootScope.$applyAsync(function () {
            uploadRow.status = CONSTANTS.videoProcessingStatuses.ERRORED;
            if (err?.errors?.length) {
              uploadRow.error_message = err.errors.join('; ');
            } else if (err?.data?.detail) {
              uploadRow.error_message = err.data.detail;
            } else {
              uploadRow.error_message = 'Upload failed';
            }
          });
        };

        const startVideoUpload = function (file, surveyId) {
          if (!videoUploaderFactory || !videoStatusPollerFactory) {
            portalHelperService.showPopup('Video upload not available',
              'Video uploads are not enabled in this portal.', null, 'red');
            return;
          }
          const validationErrors = videoUploaderFactory.validateFile(file);
          if (validationErrors.length > 0) {
            portalHelperService.showPopup('Cannot upload video',
              validationErrors.join('<br>'), null, 'red');
            return;
          }
          // Unique key for ng-repeat / lookup; the document_id is unknown until
          // after _initiate, so we key by filename + size + a timestamp.
          const uploadKey = file.name + ':' + file.size + ':' + Date.now();
          const uploadRow = {
            key: uploadKey,
            file_name: file.name,
            status: CONSTANTS.videoProcessingStatuses.UPLOADING,
            progress: 0,
            document_id: null,
            error_message: null
          };
          cur_scope.document_uploader.video_uploads.push(uploadRow);

          const uploader = videoUploaderFactory.create({
            file: file,
            surveyId: surveyId,
            ownerId: new_document_owner_id,
            onDuplicate: function (event) { onVideoUploadDuplicate(uploadRow, event); },
            onProgress: function (fraction) { onVideoUploadProgress(uploadRow, fraction); },
            onComplete: function (data) { onVideoUploadComplete(uploadRow, surveyId, data); },
            onError: function (err) { onVideoUploadError(uploadRow, err); }
          });
          // RPR-6745: keep the uploader on its row so dialog teardown can abort
          // an interrupted upload, and guard against a page unload mid-upload.
          uploadRow._uploader = uploader;
          registerBeforeUnloadGuard();
          uploader.start();
        };

        // Document upload method
        // RPR-6721: clear the in-dropzone selected file (the "x" / remove control).
        // Single source for both browse + drag-drop selections.
        cur_scope.document_uploader.clearSelectedFile = function () {
          $('#file-picker').val('');
          cur_scope.document_uploader.document.files = null;
          cur_scope.document_uploader.selected_file_label = '';
          cur_scope.document_uploader.selected_file_size_label = '';
        };

        // RPR-S2004: PDF upload-success helpers hoisted to depth 3 so the
        // upload_method .then() success callback stays shallow.
        const addUploadedDocsToTables = function (newDocs) {
          // RPR-6678: route new docs to the right tab's DataTable AND
          // keep the tab badge counts in sync (initialized once on
          // dialog open; need explicit bumps when new rows are added).
          const newVideoDocs = newDocs.filter(function (d) { return d.media_type === 'video'; });
          const newOtherDocs = newDocs.filter(function (d) { return d.media_type !== 'video'; });
          const uploader = cur_scope?.document_uploader || {};
          if (newOtherDocs.length > 0) {
            $('#documents-list-table').DataTable().rows.add(newOtherDocs).draw();
            uploader.documents_count = (uploader.documents_count || 0) + newOtherDocs.length;
          }
          if (newVideoDocs.length > 0) {
            $('#videos-list-table').DataTable().rows.add(newVideoDocs).draw();
            uploader.videos_count = (uploader.videos_count || 0) + newVideoDocs.length;
          }
        };

        const isOwnDocument = function (documentArg) {
          return documentArg.owner_id == cur_scope.client_user_id;
        };

        const onPdfUploadSuccess = function (result, docObj, surveyId) {
          const newDocs = result.data.map(function (doc) {
            return {
              'id': doc.id,
              'name': doc.name,
              'survey_id': doc.survey,
              'added_datetime': doc.added_datetime,
              // RPR-6678: carry the video fields so the Videos tab can
              // render the thumbnail + status for freshly uploaded clips.
              'media_type': doc.media_type,
              'mux_thumbnail_url': doc.mux_thumbnail_url,
              'mux_playback_id': doc.mux_playback_id,
              'mux_processing_status': doc.mux_processing_status
            };
          });

          $timeout(function () {
            addUploadedDocsToTables(newDocs);
          }, 0);

          docObj.new_document_added = true;

          docObj.documents = [];

          docObj.scope.documentUploadForm.$setPristine();

          $('#file-picker').val('');
          cur_scope.document_uploader.selected_file_label = '';
          cur_scope.document_uploader.selected_file_size_label = '';

          // Stop propagation of click event on checkboxes
          $timeout(function () {
            $('#documents-list-table tbody input').on('click', phStopPropagation);
          });

          if (typeof callback_on_doc_uploaded === 'function') {
            callback_on_doc_uploaded(function (result) {
              clientListService.list.document = clientListService.list.document.filter(isOwnDocument);
            });
          }
        };

        // RPR-S2004 / RPR-6732: the routing + POST body, invoked only after the
        // client-side content sniff (phVerifyUploadContent) passes.
        const proceedWithUpload = function (document, surveyId, docObj) {
          // RPR-6094: split files into video vs PDF buckets. Videos are routed
          // through the chunked S3 uploader; PDFs continue through the existing
          // multipart POST below. Disallow mixing the two in a single submit so
          // error reporting stays simple.
          const videoFiles = [];
          const pdfFiles = [];
          for (let i = 0; i < document.files.length; i++) {
            const file = document.files[i];
            if (isVideoFile(file)) {
              videoFiles.push(file);
            } else if (/.PDF$/i.test(file.name)) {
              pdfFiles.push(file);
            } else {
              portalHelperService.showPopup('Unsupported file',
                'Please select a PDF or a supported video file (MP4, MOV, WebM).', null, 'red');
              return false;
            }
          }

          // RPR-6717: enforce the active tab as a backstop for when the soft
          // accept filter is bypassed (e.g. the user picks "All files" in the OS
          // dialog). This keeps the tab the user is on consistent with what gets
          // uploaded and yields a clearer message than the generic checks below.
          const onVideosTab = cur_scope.document_uploader.active_picker_tab === 'videos';
          if (onVideosTab && pdfFiles.length > 0) {
            portalHelperService.showPopup('Wrong tab for this file',
              'You are on the Videos tab. Only video files (' +
              cur_scope.document_uploader.video_formats_label + ') can be uploaded here.', null, 'red');
            return false;
          }
          if (!onVideosTab && videoFiles.length > 0) {
            portalHelperService.showPopup('Wrong tab for this file',
              'You are on the Documents tab. Only PDF files can be uploaded here. Switch to the Videos tab to upload videos.',
              null, 'red');
            return false;
          }

          // Unreachable under normal tab states (both tab backstops above handle
          // each file type); retained as a safety net for unexpected active_picker_tab values.
          if (videoFiles.length > 0 && pdfFiles.length > 0) {
            portalHelperService.showPopup('Mixed file types not supported',
              'Please upload PDFs and videos in separate batches.', null, 'red');
            return false;
          }

          if (videoFiles.length > 0) {
            for (const file of videoFiles) {
              startVideoUpload(file, surveyId);
            }
            // Cosmetic cleanup runs AFTER the upload has already started, so it
            // must not throw -- otherwise (e.g. the form is gone mid dialog
            // teardown) the outer .catch would show "Upload failed" for an
            // upload that actually began. Optional-chain the fragile bits.
            $('#file-picker').val('');
            cur_scope.document_uploader.document.files = null;
            cur_scope.document_uploader.selected_file_label = '';
            cur_scope.document_uploader.selected_file_size_label = '';
            cur_scope.document_uploader.scope?.documentUploadForm?.$setPristine?.();
            return;
          }

          cur_scope.document_uploading = true;

          const url = apiHelper.getApiUrl() + '/api/authoring/document.json';
          const http_method = HttpAuth.post;
          const data = new FormData();
          for (let i = 0; i < document.files.length; i++) {
            data.append('files', document.files[i]);
          }
          data.append('survey', surveyId);
          data.append('owner_id ', document.owner_id);

          // Content-Type set to undefined for file uploads that allows browser to set correct multipart boundary and
          // ensures proper multipart/form-data encoding. This will avoids potential conflicts with manual Content-Type setting.
          const headers = {
            headers: { 'Content-Type': undefined }
          };

          http_method(url, data, headers).then(function (result) {
            onPdfUploadSuccess(result, docObj, surveyId);
          }, function (result) {
            portalHelperService.showErrorCommon(result);
          }).finally(function () {
            cur_scope.document_uploading = false;
          });
        };

        // RPR-S2004: hoisted so the phVerifyUploadContent callbacks stay shallow. Both the
        // success and failure legs clear the same latch and $applyAsync takes the function by
        // reference, so one named helper serves both. Queuing it twice (a throw out of the
        // success leg runs the catch too) is harmless -- the assignment is idempotent.
        const clearVerifyingContent = function () {
          cur_scope.document_uploader.verifying_content = false;
        };

        cur_scope.document_uploader.upload_method = function (document, surveyId) {
          if ((cur_scope.document_uploading != undefined && cur_scope.document_uploading === true)
            || cur_scope.document_uploader.verifying_content === true) {
            return;
          }

          if (!document.files || document.files.length === 0) {
            portalHelperService.showPopup('Documents not selected',
              'Please select documents to upload.', null, 'red');
            return false;
          }

          // RPR-6732: sniff the real file contents up front so renamed/mismatched
          // files are rejected with a friendly message before any upload begins,
          // then hand off to the existing routing/POST path.
          const docObj = this;
          const onVideosTab = cur_scope.document_uploader.active_picker_tab === 'videos';
          const files = Array.prototype.slice.call(document.files);
          // RPR-6719: that check now decodes a frame for videos, so it is a visible
          // wait rather than the near-instant byte sniff it used to be. Latch a flag
          // across it -- document_uploading alone does not cover this window (the
          // video branch of proceedWithUpload returns without ever setting it), so a
          // second click would start a second chain and fan out a duplicate upload.
          cur_scope.document_uploader.verifying_content = true;
          phVerifyUploadContent(files, onVideosTab).then(function (problem) {
            // Resolution lands outside the digest (native Promise, not $q), so the
            // button would stay greyed until something else happened to trigger one.
            $rootScope.$applyAsync(clearVerifyingContent);
            if (problem) {
              portalHelperService.showPopup(problem.title, problem.message, null, 'red');
              return;
            }
            proceedWithUpload(document, surveyId, docObj);
          }).catch(function (error_) {
            $rootScope.$applyAsync(clearVerifyingContent);
            // Before the RPR-6732 refactor this body ran synchronously, so a
            // throw surfaced via Angular's $exceptionHandler. Now it runs inside
            // a promise: without this catch, a throw after proceedWithUpload sets
            // document_uploading=true would become a swallowed rejection, leaving
            // the flag stuck true so the guard above silently blocks every later
            // upload. Reset it and tell the user instead.
            cur_scope.document_uploading = false;
            // ...but reporting matters as much as recovering. Every deliberate
            // can't-decide path inside the precheck resolves rather than rejects, so
            // anything arriving HERE is a genuine fault. Catching it takes it out of
            // $exceptionHandler's reach (which forwards to Sentry since RPR-6314) AND
            // marks the rejection handled, so Sentry's unhandledrejection listener
            // never sees it either -- the generic popup below would be the only trace,
            // and "please try again" is a lie when the retry will fail identically.
            phReportCaughtError('document upload', 'content verification or upload start failed', error_);
            portalHelperService.showPopup('Upload failed',
              'Something went wrong while starting the upload. Please try again.', null, 'red');
          });
        };

        // Actual method starts here
        // RPR-6721: previously already-attached docs were FILTERED OUT of the
        // picker. Hiding them by id broke when an overwrite minted a NEW document
        // id -- the replacement leaked back in as an "available" row because the
        // exclusion set still held the old id. Instead, keep every doc but flag
        // the attached ones so the tables render them greyed, non-selectable, and
        // sorted to the bottom: a declarative view of the survey's docs rather
        // than a fragile add-only delta that goes stale on id churn.
        const attachedDocumentIds = new Set((selected_document_ids || []).map(function (id) {
          return Number.parseInt(id, 10);
        }));
        const documentList = _.map(list_of_documents, function (doc) {
          const isAttached = attachedDocumentIds.has(Number.parseInt(doc.id, 10));
          // Shallow copy so we never mutate the shared clientListService objects.
          return _.extend({}, doc, { is_attached: isAttached, attached_sort: isAttached ? 1 : 0 });
        });

        let deregisterTabWatch;

        // RPR-S2004: DataTable setup hoisted to depth 3 so the onReady $timeout
        // callback only calls a helper instead of nesting the build inline.
        const setupPickerTables = function (scope, docList, videoList) {
          const documentsListTable = $('#documents-list-table').DataTable({
            bDestroy: true,
            // RPR-6738: autoWidth measures the longest filename and writes that as an
            // inline width on the name column, which table-layout:fixed (in
            // .document-manager CSS) then honors -- defeating the ellipsis. Disable it
            // so the width-less name column takes the remaining space and truncates.
            autoWidth: false,
            ordering: true,
            data: docList,
            paging: false,
            // RPR-6721: relocate the search above a table-only scroll region.
            // f (filter) -> .dm-table-controls; t (table) wrapped in .dm-table-scroll
            // so only rows scroll under the sticky header; i (info) below. Length
            // menu (l) was never displayed; pagination (p) is off.
            dom: '<"dm-table-controls"f><"dm-table-scroll"t><"dm-table-foot"i>',
            language: {
              searchPlaceholder: 'Search documents',
              emptyTable: 'No documents in the repository yet. Upload one above to get started.'
            },
            // RPR-6721: attached rows (attached_sort=1) sink to the bottom,
            // then newest-first within each group.
            order: [[5, 'asc'], [4, 'desc']],
            createdRow: function (rowEl, rowData) {
              if (rowData.is_attached) { $(rowEl).addClass('attached-row'); }
            },
            columns: [
              {
                data: 'id',
                visible: false,
                type: 'num'
              },
              {
                data: 'id',
                width: '35px',
                orderable: false,
                render: function (data, type, row, meta) {
                  // RPR-6721: attached docs are read-only -- a disabled (checked)
                  // checkbox shows they're already in; the "Attached" tag sits
                  // beside the name. Add-Selected collectors skip :disabled.
                  if (row.is_attached) {
                    return [
                      '<div class=\'center aligned\'>',
                      '<input type=\'checkbox\' checked disabled title=\'Already attached to this survey\' />',
                      '</div>'
                    ].join('\n');
                  }
                  return [
                    '<div class=\'center aligned\'>',
                    '<input type=\'checkbox\' data-id=\'' + data + '\' id=\'doc-id-' + data + '\' />',
                    '</div>'
                  ].join('\n');
                }
              },
              {
                data: 'name',
                title: 'Document',
                // RPR-6738: tag the cell so the .document-manager SCSS can cap its
                // width and ellipsis-truncate long filenames instead of letting them
                // overflow into the Survey ID column.
                className: 'dm-name-cell',
                render: function (data, type, row, meta) {
                  const nameClass = row.is_attached ? ' class=\'attached-doc-name\'' : '';
                  const tag = row.is_attached
                    ? '<span class=\'attached-tag\' title=\'Already attached to this survey\'>Attached</span>'
                    : '';
                  // RPR-6754: the .dm-name-cell ellipsis-truncates long names, so
                  // expose the full name via a native title tooltip on hover.
                  const escapedName = _.escape(data);
                  return '<label' + nameClass + ' title=\'' + escapedName + '\'>' + escapedName + '</label>' + tag;
                }
              },
              {
                data: 'survey_id',
                title: 'Survey ID',
                width: '100px',
                render: function (data, type, row) {
                  return 'MAT_' + data;
                }
              },
              {
                data: 'added_datetime',
                title: 'Uploaded',
                type: 'date',
                width: '120px',
                defaultContent: '',
                render: function (data, type, row, meta) {
                  if (type === 'display' || type === 'filter') {
                    return $filter('date')(data, CONSTANTS.dateTimeFormat.MEDIUM_ONLY_DATE);
                  }

                  return data;
                }
              },
              {
                // RPR-6721: hidden sort key -- attached rows (1) sink below available (0).
                data: 'attached_sort',
                defaultContent: 0,
                visible: false,
                type: 'num'
              }
            ]
          });

          // RPR-6678: the Videos tab gets its own DataTable instance.
          // First column is the cached Mux thumbnail (or a dark CSS
          // placeholder + play glyph if the thumbnail isn't ready).
          const videosListTable = $('#videos-list-table').DataTable({
            bDestroy: true,
            // RPR-6738: see documents table -- autoWidth + table-layout:fixed pins the
            // name column to the longest filename; disable so it truncates instead.
            autoWidth: false,
            ordering: true,
            data: videoList,
            paging: false,
            // RPR-6721: see documents table above -- search above a table-only
            // scroll region so the sticky header and rows stay aligned.
            dom: '<"dm-table-controls"f><"dm-table-scroll"t><"dm-table-foot"i>',
            language: {
              searchPlaceholder: 'Search videos',
              emptyTable: 'No videos in the repository yet. Upload one above to get started.'
            },
            // RPR-6721: attached rows (attached_sort=1) sink to the bottom,
            // then newest-first within each group.
            order: [[6, 'asc'], [5, 'desc']],
            createdRow: function (rowEl, rowData) {
              if (rowData.is_attached) { $(rowEl).addClass('attached-row'); }
            },
            columns: [
              {
                data: 'id',
                visible: false,
                type: 'num'
              },
              {
                data: 'id',
                width: '35px',
                orderable: false,
                // RPR-6719: the shared render also gates on mux_processing_status,
                // so an errored/soft-deleted clip cannot be selected.
                render: portalHelperService.renderVideoPickerCheckbox
              },
              {
                data: 'mux_thumbnail_url',
                width: '72px',
                orderable: false,
                title: '',
                render: function (data) {
                  if (data) {
                    return '<div class="video-thumb"><img src="' + _.escape(data) + '" alt="" /><span class="play-overlay">&#9658;</span></div>';
                  }
                  return '<div class="video-thumb video-thumb-placeholder"><span class="play-overlay">&#9658;</span></div>';
                }
              },
              {
                data: 'name',
                title: 'Video',
                // RPR-6738: same width/ellipsis treatment as the Documents table so
                // long video names don't overlap the Survey ID column.
                className: 'dm-name-cell',
                // RPR-6719: the shared render adds the Mux status badge, so a row
                // disabled by the checkbox render above explains itself.
                render: portalHelperService.renderVideoPickerNameCell
              },
              {
                data: 'survey_id',
                title: 'Survey ID',
                width: '100px',
                render: function (data) {
                  return 'MAT_' + data;
                }
              },
              {
                data: 'added_datetime',
                title: 'Uploaded',
                type: 'date',
                width: '120px',
                defaultContent: '',
                render: function (data, type) {
                  if (type === 'display' || type === 'filter') {
                    return $filter('date')(data, CONSTANTS.dateTimeFormat.MEDIUM_ONLY_DATE);
                  }
                  return data;
                }
              },
              {
                // RPR-6721: hidden sort key -- attached rows (1) sink below available (0).
                data: 'attached_sort',
                defaultContent: 0,
                visible: false,
                type: 'num'
              }
            ]
          });

          // RPR-S2004: depth-4 named row handlers so the $(document).ready(...)
          // callback below holds no inline literal. They use `this` (the matched
          // element jQuery's .on sets), so they stay function expressions.
          const onDocRowClick = function (event) {
            if ($(event.target).is(':checkbox')) return;
            $(this).find('input').click();
          };
          const onVideoRowClick = function (event) {
            if ($(event.target).is(':checkbox')) return;
            $(this).find('input').click();
          };
          // RPR-S2004: depth-4 named tab-watch helpers so the $watch callback and
          // its inner $timeout hold no inline literal.
          const adjustActiveTableColumns = function (activeTab) {
            const activeTable = activeTab === 'videos' ? videosListTable : documentsListTable;
            if (activeTable) {
              activeTable.columns.adjust();
            }
          };
          const onActivePickerTabChange = function (activeTab, previousTab) {
            // RPR-6749: the upload dropzone is shared across both tabs (it sits
            // outside the per-tab ng-show blocks), and its icon/header/button are
            // keyed off active_picker_tab -- so a file staged on one tab lingers on
            // the other with the wrong media-type icon (a PDF showing a video icon).
            // The accept-filter, client-side validation and upload routing are all
            // tab-scoped, so a half-staged file for the other type is meaningless:
            // drop it on a real tab switch. The guard skips the watch's initial fire
            // (newVal === oldVal on registration); clearSelectedFile() is a no-op
            // when nothing is staged (e.g. the duplicate-resolution flow).
            if (previousTab !== undefined && activeTab !== previousTab) {
              cur_scope.document_uploader.clearSelectedFile();
            }
            // RPR-6721: keep the footer action verb in step with the active media type.
            // The button lives in the $ngConfirm footer (created once); tag it with
            // .dm-add-selected and retext it here rather than rebuilding the dialog.
            $('.dm-add-selected').text(activeTab === 'videos' ? 'Add selected videos' : 'Add selected documents');
            // RPR-6758: same for the dialog title. Anchor on .dm-add-selected so
            // only THIS picker's .ng-confirm is retitled (a bare .ng-confirm-title
            // selector would also hit any other open $ngConfirm dialog, e.g.
            // showPopupError / showPopupWarning).
            $('.dm-add-selected').closest('.ng-confirm').find('.ng-confirm-title').text(
              activeTab === 'videos' ? 'Select Videos to attach to the Survey'
                : 'Select Documents to attach to the Survey');
            $timeout(adjustActiveTableColumns.bind(null, activeTab));
          };

          $(document).ready(function () {
            // RPR-6715: delegate the checkbox handler on tbody (not a direct
            // bind) so it also covers rows added live via DataTable
            // rows.add() -- e.g. a just-uploaded video. The :checkbox guard
            // stops the row handler from re-clicking the input the user
            // already clicked: previously that synthetic click bubbled back to
            // the <tr> and recursed until the tab froze, so the checkbox
            // appeared to "do nothing".
            $('#documents-list-table tbody').on('click', 'tr', onDocRowClick);
            $('#documents-list-table tbody').on('click', 'input', phStopPropagation);
            $('#videos-list-table tbody').on('click', 'tr', onVideoRowClick);
            $('#videos-list-table tbody').on('click', 'input', phStopPropagation);
          });

          // RPR-6717: scrollY tables measure column widths at init, but the
          // modal is still animating and the Videos tab starts hidden, so the
          // header and body can size to different widths. Re-adjust the active
          // tab's table after layout settles -- the watch fires once for the
          // Documents tab on open and again when the Videos tab is first shown.
          deregisterTabWatch = scope.$watch('document_uploader.active_picker_tab', onActivePickerTabChange);
        };

        $ngConfirm({
          title: 'Select Documents to attach to the Survey',
          contentUrl: portalHelperService.getUrlRev('html_templates/dialogs/client_document_manager.be05c8be.html'),
          type: 'blue',
          closeIcon: true,
          columnClass: 'large',
          escapeKey: 'cancel',
          scope: cur_scope,
          // RPR-6094: stop any in-flight Mux status pollers when the dialog
          // closes so we don't leak setInterval handles after the user dismisses.
          // RPR-6717: also deregister the active_picker_tab watcher so repeated
          // dialog open/close cycles don't accumulate live watchers on cur_scope.
          onDestroy: function () {
            if (deregisterTabWatch) { deregisterTabWatch(); }
            const pollers = cur_scope.document_uploader?._active_pollers || [];
            for (const poller of pollers) {
              try { poller.stop(); } catch (e) { console.warn('Failed to stop poller during dialog cleanup', e); } // eslint-disable-line no-console
            }
            // RPR-6758: resolve any paused duplicate confirms (visible + queued)
            // so their gate promises don't stay pending -- retaining the File
            // via closure -- after the dialog is dismissed mid-decision.
            const uploader = cur_scope.document_uploader;
            const pausedPrompts = [uploader?.duplicate_prompt].concat(uploader?._pending_duplicate_prompts || []);
            for (const prompt of pausedPrompts) {
              try { prompt?.event?.cancel(); } catch (e) { console.warn('Failed to cancel paused duplicate prompt during dialog cleanup', e); } // eslint-disable-line no-console
            }
            if (uploader) {
              uploader.duplicate_prompt = null;
              uploader._pending_duplicate_prompts = [];
            }
            // RPR-6745: retire any still-uploading placeholder so a dialog
            // dismissed mid-upload doesn't leave an orphaned "Video not
            // available" record, then drop the page-unload guard.
            abortInFlightVideoUploads();
            removeBeforeUnloadGuard();
          },
          onReady: function (scope) {
            scope.document_uploader.selected_documents = [];

            $(document).ready(phBindFilePicker.bind(null, scope));
            // RPR-6748: bind drag-and-drop on the same final modal DOM.
            $(document).ready(phBindDropzone);

            // RPR-6678: split the picker list by media_type so the
            // Documents tab and the Videos tab each render only their
            // own type. The split happens once on dialog open; new
            // uploads route to the right tab via the upload-success
            // handler above.
            const isVideoDoc = function (doc) { return doc.media_type === 'video'; };
            const docList = _.reject(documentList, isVideoDoc);
            const videoList = _.filter(documentList, isVideoDoc);
            scope.document_uploader.documents_count = docList.length;
            scope.document_uploader.videos_count = videoList.length;
            // Default to Documents tab on open (matches pre-RPR-6678 behavior).
            scope.document_uploader.active_picker_tab = scope.document_uploader.active_picker_tab || 'documents';

            $timeout(function () {
              setupPickerTables(scope, docList, videoList);
            }, 0);
          },
          buttons: {
            cancel: {
              text: 'Cancel',
              btnClass: 'mat ui button',
              action: function (scope, button) {
              }
            },
            select: {
              text: 'Add selected documents',
              btnClass: 'mat ui primary button dm-add-selected',
              action: function (scope, button) {
                scope.document_uploader.selected_documents = [];
                // Get list of all selected checkboxes -- both tabs.
                // RPR-6678: videos live in their own tab/table, so we
                // collect from both #documents-list-table and
                // #videos-list-table before validating.
                // RPR-6721: :not(:disabled) excludes already-attached rows -- their
                // checkbox is checked+disabled, which :checked alone would still match.
                $('#documents-list-table input[type=checkbox]:checked:not(:disabled)').each(function () {
                  scope.document_uploader.selected_documents.push($(this).data('id'));
                });
                $('#videos-list-table input[type=checkbox]:checked:not(:disabled)').each(function () {
                  scope.document_uploader.selected_documents.push($(this).data('id'));
                });
                scope.document_uploader.selected_documents =
                  Array.from(new Set(scope.document_uploader.selected_documents));

                if (scope.document_uploader.selected_documents.length === 0) {
                  portalHelperService.showPopup('No documents selected',
                    'Please select one or more documents to attach.', null, 'red');
                  return false;
                }

                if (typeof callback === 'function') {
                  callback({
                    selected_documents: scope.document_uploader.selected_documents,
                    new_document_added: scope.document_uploader.new_document_added
                  });
                }
              }
            }
          }
        });
      };

      /**
       * @namespace portalHelper
       * @desc Shows a pop up which allows a user to select a question from a list of questions.
       *
       * @param scope             The current scope of page calling this
       * @param questionBankList  List of questions
       *
       * @returns string
       * Question selected if user selects one.
       * null if no question is selected.
       */
      portalHelperService.initQuestionBankTable = function (scope, questionBankList) {

        const columns = [
          {
            data: 'id',
            visible: false,
            type: 'num'
          },
          {
            data: 'text',
            orderable: false
          },
          {
            data: 'id',
            orderable: false,
            render: function (data, type, row, meta) {
              return [
                '<button data-ng-click=\'submit_question(' + data + ')\' class=\'mat ui primary button\'>Include</button>'
              ].join('\n');
            }
          }
        ];

        $('#questions-list-table').DataTable({
          bDestroy: true,
          autoWidth: false,
          ordering: true,
          order: [[0, 'desc']],
          data: questionBankList,
          scrollCollapse: true,
          paging: false,
          columns: columns,
          createdRow: function (row, data, index) {
            $compile(angular.element(row).contents())(scope);
          },
          responsive: {
            details: {
              display: $.fn.dataTable.Responsive.display.childRowImmediate,
              type: ''
            }
          },
          initComplete: function (settings, json) {
            // Wait a bit to make datatable recalculate it's dimensions to be responsive
            setTimeout(function () {
              $('#table-copy-questions').DataTable().columns.adjust().responsive.recalc();
              preventDataTableMenuClipping();
            }, 500);
          }
        }).draw();
      };

      portalHelperService.showQuestionBankPopup = function (cur_scope, questionBankList, callback) {
        let questionBankPopup = null;

        cur_scope.submit_question = function (questionId) {
          const question = _.findWhere(questionBankList, { id: questionId });
          if (question !== undefined) {
            if (callback != null && typeof (callback) === 'function') {
              callback(question.text);

              // Close pop up
              if (questionBankPopup) {
                questionBankPopup.close();
                questionBankPopup = null;
              }
            }
          }
        };

        questionBankPopup = $ngConfirm({
          title: '<strong>Select a Question to use</strong>',
          contentUrl: portalHelperService.getUrlRev('html_templates/dialogs/question_bank_popup.789e040e.html'),
          type: 'blue',
          columnClass: 'col-md-8',
          closeIcon: true,
          escapeKey: 'cancel',
          scope: cur_scope,
          onReady: function (scope) {
            portalHelperService.initQuestionBankTable(scope, questionBankList);
          },
          buttons: {
            cancel: {
              text: 'Cancel',
              btnClass: 'mat ui button',
              action: function (scope, button) {
              }
            }
          }
        });
      };

      portalHelperService.retrieveCurrentUserAndEnterPortal = function(){
        // retrieve current user
        portalHelperService.retrieveMeShared(function (data) {
          if (portalHelperService.checkTfaRequired(data)) {
            $location.path('/TfaRequired');
            return;
          }

          // cur and original user are just the same
          authHelper.setMeSharedOrig(data);
          authHelper.redirectLoggedIn($routeParams.returnUrl);
        }, false, true);
      };


      portalHelperService.handleBlockedPopup = function(win, surveyId){
        if (!win || win.closed || typeof win.closed=='undefined') {
          const popupBlockedMessage = $ngConfirm({
            title: ' ',
            closeIcon: false,
            columnClass: 'large',
            type: 'red',
            contentUrl: portalHelperService.getUrlRev('html_templates/dialogs/blocked_popup.9b6cf474.html'),
            onScopeReady: function(scope) {
              const blockCountKey = 'count_blocked_survey';

              if (localStorage.getItem(blockCountKey) == null) {
                localStorage.setItem(blockCountKey, 0);
              } else {
                scope.blockedCount = localStorage.getItem(blockCountKey) == null
                  ? 0
                  : parseInt(localStorage.getItem(blockCountKey));

                scope.blockedCount += 1;
                localStorage.setItem(blockCountKey, scope.blockedCount);
                scope.surveyId = surveyId;
              }

              scope.openSurveyDirectly = function(){
                $timeout(
                  function(){
                    popupBlockedMessage.close();
                    window.location.reload();
                  }, 200
                );
                $location.path('Payers/SurveyDescription/' + surveyId);
              };
            },
            buttons: {
              OK: {
                btnClass: 'mat ui primary button',
                action: function () {
                  popupBlockedMessage.close();
                  location.reload();
                }
              }
            }
          });

          return true;
        }
      };

      portalHelperService.showLoaderWithMessage = function (title, message) {
        return $ngConfirm({
          title: title,
          contentUrl: portalHelperService.getUrlRev(
            'html_templates/dialogs/message_with_loader.bc47b42f.html'),
          type: 'orange',
          onScopeReady: function (scope) {
            scope.message = message;
          },
          buttons: {
            OK: {
              btnClass: 'mat ui primary button'
            }
          }
        });
      };

      portalHelperService.enableWeekSelectionOnCalendar = function () {
        $('tbody').addClass('week-selection');
      };

      portalHelperService.handleDataTableRowClick = function (tableId, clickHandler) {
        // Add class to highlight rows on selection
        $('#' + tableId).addClass('highlight-rows');

        const dt = $('#' + tableId).DataTable();

        $('#' + tableId + ' tbody').on('click', 'tr', function () {
          if (clickHandler !== null && typeof(clickHandler) === 'function') {
            clickHandler(dt.row(this).data());
          }
        });
      };


      /*
       * This is a utility method which converts something like this:
       * { "IN": 1, "AU": 3, "GB": 3 }
       * to:
       * 1 (India), 3 (Australia, United Kingdom)
       * for the `loadProjectMasterReport` report
       */
      portalHelperService.process_country_counts = function(data, country_dict) {
        const tempArray = [];
        let result = '';

        // Creating proper json objects from the data into an array
        for (const key in data) {
          tempArray.push({ 'k': key, 'v': data[key] });
        }

        // Using _.js's group method to group array by numbers
        const grouped = _.groupBy(tempArray, 'v');

        // Expand all the country codes into proper country names
        for (const key in grouped) {
          const countries = [];
          grouped[key].forEach(function (elem, index) {
            countries.push(country_dict[elem.k].name);
          });

          result += key + ' (' + countries.join(', ') + '); ';
        }

        return result;
      };

      /***
       * Returns an integer value for a milestone. Later milestone > Earlier milestone in lifecycle
       *
       * @param {string} milestone
       * The milestone whose value needs to be found out
       *
       * @returns {number}
       * -1 if milestone is not found in the list
       */
      portalHelperService.get_milestone_index = function (milestone) {
        const milestoneOrdering = [
          CONSTANTS.surveyStatuses.SCOPING,
          CONSTANTS.surveyStatuses.QUESTION_DEVELOPMENT,
          CONSTANTS.surveyStatuses.COMPLIANCE,
          CONSTANTS.surveyStatuses.FIELDING_AND_ANALYSIS,
          CONSTANTS.surveyStatuses.FOLLOW_UP,
          CONSTANTS.surveyStatuses.DELIVERED
        ];

        return milestoneOrdering.indexOf(milestone);
      };

      portalHelperService.AppendColumnFiltersOnDatatable = function(tableRef, tableId){
        const tableSelector = '#' + tableId;
        const searchRow = $('<tr class="filter-row">');
        const numOfColumns = tableRef.columns(':visible').nodes().length;
        for (let i=0; i<numOfColumns; i++) {
          searchRow.append('<th>');
        }

        $(searchRow).appendTo(tableSelector + ' thead');
        $(tableSelector + ' thead tr:eq(1) th').each(function (i) {
          const parentHeaderCell = $(tableSelector + ' thead tr:eq(0) th')[i];
          if (!$(parentHeaderCell).hasClass('skipCol')) {
            const title = $(parentHeaderCell).text();
            $(this).html( '<input type="text" placeholder="Search '+title+'" />' );

            $( 'input', this ).on( 'keyup change', function () {
              if ( tableRef.column(i).search() !== this.value ) {
                tableRef
                  .column(i)
                  .search( this.value )
                  .draw();
              }
            } );
          }
        } );
      };

      portalHelperService.render_clarification_statuses = function (clarification_statuses) {

        if (!clarification_statuses) {
          return '';
        }
        let output = '';
        for (let i = 0; i < clarification_statuses.length; i++) {
          const cur_status = clarification_statuses[i];
          // question_number is null when the answered question is no longer
          // in the current country layout (e.g. replaced by a per-country
          // edit after submission). The tooltip carries the question id so
          // multiple 'Q?' badges stay distinguishable.
          //
          // question_label is admin/client-authored free text, so escape it before it
          // goes anywhere near this string concatenation. Escaped HERE, once, rather
          // than in each branch below: there are four near-identical badge branches and
          // a fifth status would otherwise be one forgotten _.escape away from a hole.
          // (cur_status.status is not escaped because each branch is gated on an
          // equality check against a literal, so the value interpolated IS that literal.)
          const question_ref = _.escape(
            cur_status.question_label || cur_status.question_number || '?'
          );
          const replaced_hint = (question_ref === '?') ?
            ' (replaced question #' + _.escape(cur_status.question_id) + ')' : '';

          // ng-non-bindable on every badge: two of the three callers ($compile'd
          // DataTables rows in admin_live_surveys.js and survey_responses.js) run this
          // markup through $compile, and _.escape above does NOT neutralise `{{ }}` — an
          // authored label of `{{ ... }}` would be evaluated as an Angular expression
          // (CSTI). It covers the title attribute as well as the text. Harmless on the
          // third caller (payers_clar_requests.html uses ng-bind-html, which sanitizes
          // and never compiles). See the escaping note in RPR-6437's name renderers.
          if (cur_status.status === 'received') {
          // received
            output += (
              '<span ng-non-bindable class=\'badge bg-info\' title=\'' + cur_status.status + replaced_hint + '\'>' +
            '<i class=\'fa fa-fw fa-arrow-circle-down\'></i> Q' +
            question_ref +
            '</span> '
            );
          } else if (cur_status.status === 'approved') {
          // approved
            output += (
              '<span ng-non-bindable class=\'badge bg-success\' title=\'' + cur_status.status + replaced_hint + '\'>' +
            '<i class=\'fa fa-fw fa-check\'></i> Q' +
            question_ref +
            '</span> '
            );
          } else if (cur_status.status === 'not_sent') {
            // clarification raised but not sent back to payer
            output += (
              '<span ng-non-bindable class=\'badge bg-secondary\' title=\'Clarification raised but not sent'
              + replaced_hint + '\'>' +
            '<i class=\'fa fa-fw fa-arrow-circle-up\'></i> Q' +
            question_ref +
            '</span> '
            );
          } else if (cur_status.status === 'pending') {
            output += (
              '<span ng-non-bindable class=\'badge bg-warning\' title=\'Waiting for response from Payer'
              + replaced_hint + '\'>' +
            '<i class=\'fa fa-fw fa-arrow-circle-up\'></i> Q' +
            question_ref +
            '</span> '
            );
          }
        }
        return output;
      };

      portalHelperService.validateEmail = function (email_address){
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email_address))
        {
          return (true);
        }
        return (false);
      };

      /***
       * From a given array of IDs and values and supplied an array of IDs (ints), this method
       * will return an array of names from the array.
       *
       * Eg: Used for picking out all payer locality names from an array when we have only the
       * payer locality IDs from the user object.
       *
       * @param values
       * @param ids
       * @param separator
       * @return {string|null}
       */
      portalHelperService.fetch_names_from_array = function (values, ids, separator) {
        if (values == null || ids == null || values.length === 0 || ids.length === 0) {
          return null;
        }

        separator = separator == undefined ? ', ' : separator;

        return _.pluck(
          _.filter(values,
            function (value) {
              return ids.indexOf(value.id) > -1;
            }), 'name').join(separator);
      };

      /***
       * Given a survey object, calculates the start date of it's first milestone.
       * i.e. QD if available. Else fielding date.
       *
       * @param survey
       * @return {null|Document.surveyForm.start_date|Document.projectBrief.start_date|Document.start_date}
       */
      portalHelperService.calculate_first_survey_milestone_date = function (survey) {
        if (survey.question_development === true && survey.question_development_minimum_date != null) {
          return survey.question_development_minimum_date;
        }

        return survey.start_date;
      };

      /** *
       * Detects if the browser is Internet Explorer. Returns the version number of IE
       * Else, returns false.
       * @return {boolean|number}
       */
      portalHelperService.is_browser_ie = function () {
        const ua = window.navigator.userAgent;

        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          const rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        // other browser
        return false;
      };

      /** *
       * For an array of Dropdown options, checks if the text in them is long or short.
       * @param options {Array<Object>}
       * @return {boolean}
       */
      portalHelperService.tor_classic_has_long_dropdown_options = function(options) {
        const DROPDOWN_TEXT_LENGTH_MAX = 10;

        if (options) {
          for (let i=0; i<options.length; i++) {
            if (options[i].option_name.length > DROPDOWN_TEXT_LENGTH_MAX) {
              return true;
            }
          }
        }

        return false;
      };

      /** *
       * Looks at the path of the current page and determines whether it is in the Admin, Client or
       * Payer portal.
       * @return {string|null} CONSTANTS.typeOfPage enum which is either admin, client or payer.
       * Returns null if it cannot determine which page this is.
       */
      portalHelperService.fetch_type_of_page = function() {
        const absPath = $location.absUrl().toLowerCase();

        if (absPath.indexOf('/admin/#/') >= 0) {
          return CONSTANTS.typeOfPage.ADMIN;
        }

        if (absPath.indexOf('/client/#/') >= 0) {
          return CONSTANTS.typeOfPage.CLIENT;
        }

        if (absPath.indexOf('/payer/#/') >= 0) {
          return CONSTANTS.typeOfPage.PAYER;
        }

        return null;
      };

      /** *
       * Adds the autosize functionality to the specified text area boxes
       * @param classname
       * @param waitDuration
       */
      portalHelperService.set_auto_size_text_areas = function (classname, waitDuration) {
        const selector = 'textarea.' + classname;

        // If no waitDuration is specified, make it 100ms
        const duration = waitDuration ? waitDuration : 100;
        $timeout(function () {
          autosize(angular.element(selector));
        }, duration);
      };

      portalHelperService.initializeTelephoneInput = function (idSelector) {
        const input = document.querySelector(idSelector);
        const utilScriptUrl = '../../lib/thirdparty/intl-tel-input-17.0.0/js/utils.js';
        const iti = window.intlTelInput(input, {
          separateDialCode: true,
          utilsScript: utilScriptUrl
        });
        // intl-tel-input does not load utilscripts if intialized after window load
        // https://github.com/jackocnr/intl-tel-input/issues/350
        // so need to load the utilscripts to handle international numbers
        window.intlTelInputGlobals.loadUtils(utilScriptUrl);
        $(idSelector).keypress(function (e) {
          const keyCode = e.which;
          /*
          48-57 - (0-9)Numbers
          65-90 - (A-Z)
          97-122 - (a-z)
          8 - (backspace)
          32 - (space)
          */
          // Not allow special
          if (!((keyCode >= 48 && keyCode <= 57))
            && [8, 32, 40, 41, 43, 45].indexOf(keyCode) === -1) {
            e.preventDefault();
          }
        });

        // below object is created using 'validationError' object from
        // https://github.com/jackocnr/intl-tel-input/blob/master/src/js/utils.js#L153
        // for mapping error codes to strings
        const validationErrors = {
          '0' : 'Invalid number',
          '1' : 'Invalid country code',
          '2' : 'Too short',
          '3' : 'Too long',
          '4' : 'Invalid number',
          '5' : 'Invalid length',
          '-99' : 'Invalid number'
        };

        const telInputHandle = {
          'get_number': function () {
            return iti.getNumber();
          },
          'set_number': function (phoneNumber) {
            if (!phoneNumber) {
              return null;
            }
            return iti.setNumber(phoneNumber);
          },
          'is_valid_number': function () {
            return iti.isValidNumber();
          },
          'get_validation_error': function () {
            const error = iti.getValidationError();
            return validationErrors[error] + '. Enter a valid international number';
          }
        };

        return telInputHandle;

      };

      /**
       * This is based on Fischer-Yates alogorithm.
       * Array is shuffled inline using the given seed.
       *
       * Since, javascript doesn't provide random numbers with a seed at the time of writing this.
       * A random function has been written using Mat.sin which makes it a pseudo random number generator.
       *
       */
      portalHelperService.shuffleArrayWithSeed = function (array, seed) {
        let currentIndex = array.length, temporaryValue, randomIndex;
        seed = seed || 1;
        const random = function() {
          const x = Math.sin(seed++) * 10000;
          return x - Math.floor(x);
        };

        // Iterate over the array, generate a randomIndex for each element and exchange items
        // at currentIndex and randomIndex.
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
          // Pick a remaining element...
          randomIndex = Math.floor(random() * currentIndex);
          currentIndex -= 1;
          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
      };

      /**
       * Performs a banker's rounding or a half round up on the given number.
       * This is used for credits calculations.
       * See: https://stackoverflow.com/a/3109234/7082
       * @param num
       * @param decimalPlaces
       * @returns {number|number}
       */
      portalHelperService.bankersRounding = function (num, decimalPlaces) {
        const d = decimalPlaces || 0;
        const m = Math.pow(10, d);
        const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
        const i = Math.floor(n), f = n - i;
        const e = 1e-8; // Allow for rounding errors in f
        const r = (f > 0.5 - e && f < 0.5 + e) ?
          ((i % 2 === 0) ? i : i + 1) : Math.round(n);
        return d ? r / m : r;
      };

      portalHelperService.is_test_survey = function () {
        return $location.path().indexOf('TestSurvey/') !== -1;
      };

      /**
       * Checks if the string is valid JSON
       * @param str
       * @returns {boolean}
       */
      portalHelperService.isValidJsonString = function (str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      };

      // Via authHelper so a session that cannot belong to this sub-app is discarded rather than
      // returned (RPR-6770). Still null when there is nothing usable, as before.
      portalHelperService.getMyDetails = function () {
        return authHelper.getCachedLoginDetails();
      };

      /**
      * Autosizes all the text areas which have the expandable class
      */
      portalHelperService.autosizeTextAreas = function () {
        $timeout(function () {
          autosize(angular.element('textarea.expandable'));
        });
      };

      /***
       * Given 2 moment objects returns the difference in years and months between them
       * @param momentDate1
       * @param momentDate2
       * @returns {string|*}
       */
      portalHelperService.humanize_date_diff = function (momentDate1, momentDate2) {
        return moment.duration(momentDate1.diff(momentDate2)).humanize();
      };
      /***
       * returns the date difference between them 2 moment objects (with decimals)
       * @param momentDate1
       * @param momentDate2
       * @returns {string}
       */
      portalHelperService.calculate_date_diff = function (momentDate1, momentDate2) {
        const years = momentDate1.diff(momentDate2, 'years', true).toFixed(1);
        const months = momentDate1.diff(momentDate2, 'months', true).toFixed(1);
        const days = momentDate1.diff(momentDate2, 'days', true).toFixed(1);
        const hours = momentDate1.diff(momentDate2, 'hours', true).toFixed(1);
        const minutes = momentDate1.diff(momentDate2, 'minutes', true).toFixed(1);
        const seconds = momentDate1.diff(momentDate2, 'seconds', true).toFixed(1);

        if (years >= 1) {
          return years + ' years';
        }
        if (years < 1 && months >= 1) {
          return months + ' months';
        }
        if (months < 1 && days >= 1) {
          return days + ' days';
        }
        if (days < 1 && hours >= 1) {
          return hours + ' hours';
        }
        if (hours < 1 && minutes >= 1) {
          return minutes + ' minutes';
        }

        return seconds + ' seconds';
      };

      /**
       * Given a string, checks if it is a JSON object (has json structure and not primitive)
       * @param str
       * @returns {boolean}
       */
      portalHelperService.has_json_format = function (str) {
        if (typeof str !== 'string') return false;
        try {
          const result = JSON.parse(str);
          const type = Object.prototype.toString.call(result);
          return type === '[object Object]'
            || type === '[object Array]';
        } catch (err) {
          return false;
        }
      };

      /**
       * Given a string, remove all html tags if present any
       * @param str
       * @returns {str}
       */
      portalHelperService.removeHTMLTags = function (str) {
        if (typeof str !== 'string') return str;
        // Iterative HTML tag removal to avoid regex backtracking (S5852)
        const parts = [];
        let inTag = false;
        let contentStart = 0;
        let tagStartIdx = -1;
        for (let i = 0; i < str.length; i++) {
          if (str.charAt(i) === '<') {
            if (!inTag) {
              if (i > contentStart) {
                parts.push(str.substring(contentStart, i));
              }
              inTag = true;
              tagStartIdx = i;
            }
          } else if (str.charAt(i) === '>' && inTag) {
            inTag = false;
            tagStartIdx = -1;
            contentStart = i + 1;
          }
        }
        // Preserve content after unclosed '<' (matches original regex behavior)
        if (inTag && tagStartIdx !== -1) {
          parts.push(str.substring(tagStartIdx));
        } else if (contentStart < str.length) {
          parts.push(str.substring(contentStart));
        }
        str = parts.join('');
        str = str.replace(/&nbsp;|&emsp;/g,'');
        return str;
      };

      /**
       * Given a string, convert to 24 Hour and minutes format
       * @param str
       * @returns {str}
       */
      portalHelperService.get_utc_time_in_24HH_mm_format = function (dateStr) {
        return moment.utc(dateStr).format(CONSTANTS.dateTimeFormatMoment.MEDIUM_24H_TIME_NO_SEC);
      };

      /**
       * Given a url and target, opens new tab and show pop if alerts are blocked
       * @param url
       * @param target
       * @param options
       * @returns {promiseObject} promise object conataing handle of the window
       */
      portalHelperService.popup_window_open = function (url, target, options) {
        const promiseObj = new Promise(function (resolve, reject) {
          // we are using setTimeout because some browsers like firefox blocks
          // synchronous window.open calls from the click handler, if pop blocker
          // is enabled
          window.setTimeout(function() {
            const handle = window.open(url, target || '_blank', options || '');
            if (!handle) { // popups are blocked
              portalHelperService.showPopupError('Your browser prevented a pop up from opening.',
                'Please allow your browser to show pop ups from this website to continue.');
            }
            resolve(handle);
          }, 200);
        });
        return promiseObj;
      };

      /**
       * function to be passed on route resolve, so that there is no need
       * to call portalReady function in any controller to load the data
       * which check if user is logged in or not
       * @returns promise
       */
      portalHelperService.routeResolve = function () {
        return authHelper.getLoginDetils.then(
          function (result) {
            const myDetails = result.data;
            // If contract signing required, send the payer to contract page.
            if (myDetails.is_contract_sign_required && myDetails.docusign_enabled) {
              sendPayerToContractPage();
            }
            // If terms are not yet accpeted, send to the terms of use page.
            else if (myDetails.show_terms) {
              sendPayerToTermsOfUsePage();
            }

            return myDetails;
          },
          function (error) {
            // firefox aborts the current requests in case we change the page
            // which result in logout
            if ('abort' != error.xhrStatus) {
              portalHelperService.showErrorCommon(error);
            }
          }
        );
      };

      /**
       * Parse content of paste event and return list of text items
       * @param pasteEvent {event} paste event
       * @returns [] array of list items
       */
      portalHelperService.get_list_items_from_paste_event = function (pasteEvent) {
        // angular wraps browser paste event in originalEvent key
        const event = pasteEvent.originalEvent || pasteEvent;
        const clipboardData = event.clipboardData || window.clipboardData;
        let pastedText = clipboardData.getData('text/html');
        if (!pastedText) {
          // no html content, means text copied from a source
          // which does not having formating, means plain simple text
          return [];
        }

        // remove html comments
        pastedText = pastedText.replace(/<!--[\s\S]*?-->/g, '');

        // word add these !supportLists tags, which are not needed so remove those
        pastedText = pastedText.replace(/<!\[if !supportLists\]>[\s\S]*?<!\[endif\]>/g, '');
        const doc = document.implementation.createHTMLDocument();
        doc.body.innerHTML = pastedText;

        let listItems = doc.getElementsByTagName('li');
        if (!listItems.length) {
          listItems = doc.getElementsByTagName('tr');
        }

        if (!listItems.length) {
          listItems = doc.getElementsByTagName('p');
        }

        return _.map(listItems, function (item) {
          return {
            text: (item.innerText.trim()).replace(/\n/g,'')
          };
        });
      };

      /**
       * @param payer_relevance_rating_choices
       * @param relevanceRatingObj
       * @returns modified relevance rating object
       */
      portalHelperService.addChangeHistoryLabel = function(payer_relevance_rating_choices, relevanceRatingObj) {
        if (!relevanceRatingObj.rating_history_json || (relevanceRatingObj.rating_history_json.length === 0 && !relevanceRatingObj.updated_datetime)) {
          return relevanceRatingObj;
        }
        relevanceRatingObj.rating_history_log = [...relevanceRatingObj.rating_history_json];
        const ratingHistory = relevanceRatingObj.rating_history_log;
        let currentRating, currentRatingLabel, previousRating, previousRatingLabel, lastRating, lastRatingLabel;

        _.forEach(relevanceRatingObj.rating_history_log, function(historyObj, index) {
          if (index === 0) {
            const initialRatingLabel = `${payer_relevance_rating_choices[ratingHistory[0].rating].label} (${ratingHistory[0].rating})`;
            relevanceRatingObj.rating_history_log[0].change_history_log_label = `Initial Rating: ${initialRatingLabel}`;
          } else {
            previousRating = ratingHistory[index - 1].rating ? ratingHistory[index - 1].rating : 0;
            currentRating = ratingHistory[index].rating ? ratingHistory[index].rating : 0;
            previousRatingLabel = `${payer_relevance_rating_choices[previousRating].label} (${previousRating})`;
            currentRatingLabel = `${payer_relevance_rating_choices[currentRating].label} (${currentRating})`;
            relevanceRatingObj.rating_history_log[index].change_history_log_label = `${previousRatingLabel} to ${currentRatingLabel}`;
          }
        });

        currentRating = relevanceRatingObj.rating ? relevanceRatingObj.rating : 0;
        currentRatingLabel = `${payer_relevance_rating_choices[currentRating].label} (${currentRating})`;

        if (ratingHistory.length > 0) {
          // append the most recent rating to the rating history log
          lastRating = ratingHistory[ratingHistory.length - 1].rating ? ratingHistory[ratingHistory.length - 1].rating : 0;
          lastRatingLabel = `${payer_relevance_rating_choices[lastRating].label} (${lastRating})`;

          relevanceRatingObj.rating_history_log.push({
            rating: relevanceRatingObj.rating,
            updated_datetime: relevanceRatingObj.updated_datetime,
            change_history_log_label: `${lastRatingLabel} to ${currentRatingLabel}`
          });
        } else if (relevanceRatingObj.updated_datetime) {
          // append the first rating to the rating history log
          relevanceRatingObj.rating_history_log.push({
            rating: relevanceRatingObj.rating,
            updated_datetime: relevanceRatingObj.updated_datetime,
            change_history_log_label: `Initial Rating: ${currentRatingLabel}`
          });
        }
        return relevanceRatingObj;
      };

      portalHelperService.getSortedTimezones = function (timezones) {
        if (timezones) {
          const sortedTimezones = timezones.sort(function (a, b) {
            const aHourPart = parseInt(a.utcoffset.split(':')[0]) * 60;
            const aMinutePart = parseInt(a.utcoffset.split(':')[1]);
            const bHourPart = parseInt(b.utcoffset.split(':')[0]) * 60;
            const bMinutePart = parseInt(b.utcoffset.split(':')[1]);
            const aOffsetValue = aHourPart + (aHourPart > 0 ? aMinutePart : -aMinutePart);
            const bOffsetValue = bHourPart + (bHourPart > 0 ? bMinutePart : -bMinutePart);
            return aOffsetValue - bOffsetValue;
          });
          return sortedTimezones;
        }
      };


      portalHelperService.getLastAgreementInfo = function (payer) {
        if (!payer || !payer.contract_status_label) {
          return '';
        }
        let contract_status_label = payer.contract_status_label;
        switch (payer.contract_status_label) {
          case 'Signed': {
            const signedDate = moment(payer.last_contract_details.signed_datetime).format(CONSTANTS.dateTimeFormatMoment.MEDIUM_ONLY_DATE);
            contract_status_label = 'Signed On: <i>' + signedDate + '</i>';
            break;
          }
          case 'Declined': {
            const declinedDate = moment(payer.last_contract_details.declined_datetime).format(CONSTANTS.dateTimeFormatMoment.MEDIUM_ONLY_DATE);
            contract_status_label = ('Declined on: <i>' + declinedDate + '</i><br/>For reason: <i>' + payer.last_contract_details.decline_reason + '</i>');
            break;
          }
          case 'Voided': {
            const voidedDate = moment(payer.last_contract_details.voided_datetime).format(CONSTANTS.dateTimeFormatMoment.MEDIUM_ONLY_DATE);
            contract_status_label =  ('Voided on: <i>' + voidedDate + '</i>');
          }
        }
        return contract_status_label;
      };

      /**
       * @param {*} data This needs to be alist of user objects with `full_name` property.
       * @param {*} data This will have the type of rendering if used from a datatable context.
       * @param {*} data This will be the entire row data if used from a datatable context
       * @returns Function will return the string with comma separated names of all the users in the list passed.
       *
       */
      portalHelperService.getCommaSeparatedNames = function (listOfUsers, type, row) {
        const listOfNames = _.pluck(listOfUsers, 'full_name').sort();
        const commaSeparatedNames = listOfNames.join(', ');
        return commaSeparatedNames;
      };

      const changeHoldStatus = function (newStatus, url, entity, options) {
        const texts = options.texts;
        const confirmationTitle = newStatus ? texts.holdTitle : texts.resumeTitle;
        const confirmationMessage = newStatus ? texts.holdMessage : texts.resumeMessage;

        portalHelperService.showPopupYesNo(confirmationTitle,
          confirmationMessage,
          function () {
            if (options.processing_status) {
              options.processing_status.is_processing_resume_survey_request = true;
            }
            HttpAuth.patch(apiHelper.getApiUrl() + url, { 'on_hold': newStatus }).then(function (result) {
              const currentHoldStatus = result.data.on_hold;
              entity.on_hold = currentHoldStatus;

              const message = currentHoldStatus ? texts.nowOnHold : texts.noLongerOnHold;
              portalHelperService.showToast(CONSTANTS.typeOfToasts.SUCCESS, message, 'Success');
              if (options.onSuccess) {
                options.onSuccess(currentHoldStatus);
              }
            },
            portalHelperService.showErrorCommon
            ).finally(function () {
              if (options.processing_status) {
                options.processing_status.is_processing_resume_survey_request = false;
              }
            });
          });
      };

      portalHelperService.changeSurveyHoldStatus = function (newStatus, survey, processing_status) {
        changeHoldStatus(newStatus, '/api/admin/survey/all/details/' + survey.id + '.json', survey, {
          processing_status: processing_status,
          texts: {
            holdTitle: 'Put Survey on Hold?',
            resumeTitle: 'Resume Survey?',
            holdMessage: 'Are you sure you want to put this survey on hold?',
            resumeMessage: 'Are you sure you want to resume this survey?',
            nowOnHold: 'The survey is now <strong>on Hold</strong>.',
            noLongerOnHold: 'The survey is no longer on hold.'
          }
        });
      };

      portalHelperService.changeIdiProjectHoldStatus = function (newStatus, idiProject, onSuccess) {
        changeHoldStatus(newStatus, '/api/admin/idi_project/' + idiProject.id + '.json', idiProject, {
          onSuccess: onSuccess,
          texts: {
            holdTitle: 'Put IDI Project on Hold?',
            resumeTitle: 'Resume IDI Project?',
            holdMessage: 'Are you sure you want to put this IDI Project on hold?',
            resumeMessage: 'Are you sure you want to resume this IDI Project?',
            nowOnHold: 'The IDI Project is now <strong>on Hold</strong>.',
            noLongerOnHold: 'The IDI Project is no longer on hold.'
          }
        });
      };

      /**
       * autosuggest username from first_name and last_name if
       * its not already defined during user creation, called on blur
       * event of first_name, last_name
       * @param user
       */
      portalHelperService.autosuggest_username = function(user) {
        if (user.id) {
          // do nothing for existing users
          return;
        }

        if (user.first_name && user.last_name) {
          // remove spaces and convert to lowercase
          // suggest on any change in first_name or last_name
          user.username = user.first_name.replace(/\s/g,'').toLowerCase() + '.'
             + user.last_name.replace(/\s/g,'').toLowerCase();
        }
      };

      /**
       * function to check if current tab is active or not
       * return true/false
       */
      portalHelperService.is_current_tab_active = (function () {
        let stateKey, eventKey;
        const keys = {
          hidden: 'visibilitychange',
          webkitHidden: 'webkitvisibilitychange',
          mozHidden: 'mozvisibilitychange',
          msHidden: 'msvisibilitychange'
        };

        for (stateKey in keys) {
          if (stateKey in document) {
            eventKey = keys[stateKey];
            break;
          }
        }

        return function (c) {
          if (c) document.addEventListener(eventKey, c);
          return !document[stateKey];
        };
      })();

      /**
       * function to check if the ul with id passed as input is having li items or not
       * used to disable or hide ul having no li items
       * return true/false
       */
      portalHelperService.ul_has_li_items = function (id) {
        const elem = angular.element('#' + id);
        if (!elem) {
          return null;
        }
        if (elem.length > 0) {
          return elem.find('li').length > 0;
        }
        return false;
      };

      // Function to add target="_blank" to all links in the HTML
      portalHelperService.addTargetBlankToLinks = function(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        const links = div.getElementsByTagName('a');
        for (let i = 0; i < links.length; i++) {
          links[i].setAttribute('target', '_blank');
        }
        return div.innerHTML;
      };


      portalHelperService.runCreditTransactionHistoryReport = function (options = {}) {
        if (options.event) {
          options.event.preventDefault();
        }

        const scope = $rootScope.$new(true);
        scope.selected = {'from_date': '', 'to_date': '', 'popup_error': '' };
        scope.open_calendar = function () {
          scope.calendar.opened = true;
        };

        scope.open_from_calendar = function () {
          scope.from_calendar.opened = true;
        };

        scope.open_to_calendar = function () {
          scope.to_calendar.opened = true;
        };

        scope.min_date_options = {
          startingDay: 1,
          showWeeks: false,
          maxDate: new Date()
        };

        scope.max_date_options = {
          startingDay: 1,
          showWeeks: false,
          maxDate: new Date()
        };

        scope.$watchGroup(['selected.from_date', 'selected.to_date'],
          function (newValues) {
            if (newValues[0]) {
              scope.max_date_options.minDate = new Date(newValues[0]);
            }
            if (newValues[1]) {
              scope.min_date_options.maxDate = new Date(newValues[1]);
            }
          }
        );

        scope.calendar = {
          opened: false
        };

        scope.from_calendar = {
          opened: false
        };

        scope.to_calendar = {
          opened: false
        };

        const popup = $ngConfirm({
          title: 'Report Date Range',
          columnClass: 'large',
          type: 'green',
          closeIcon: true,
          contentUrl: '../' + 'html_templates/dialogs/admin_start_end_date_picker_popup.e89420e3.html',
          scope: scope,
          escapeKey: 'Cancel',
          buttons: {
            OK: {
              btnClass: 'mat ui primary button',
              action: function () {
                if (!scope.selected.from_date) {
                  scope.selected.popup_error = 'Please enter from date.';
                  return false;
                }

                if (!scope.selected.to_date) {
                  scope.selected.popup_error = 'Please enter to date.';
                  return false;
                }

                const from_date_str = $filter('date')(
                  scope.selected.from_date,
                  CONSTANTS.dateTimeFormat.API_DATE);

                const to_date_str = $filter('date')(
                  scope.selected.to_date,
                  CONSTANTS.dateTimeFormat.API_DATE);

                let url = $window.location.pathname +
                '#/Admin/Reports/' +
                CONSTANTS.adminReports.CREDIT_TRANSACTION_HISTORY + '/' + from_date_str + '/' + to_date_str;
                if (options.type == 'client' && $routeParams.id && $routeParams.id != 0) {
                  url = url + '?client=' + $routeParams.id;
                }
                if (options.type == 'subscription' && $routeParams.licence_id && $routeParams.licence_id != 0) {
                  url = url + '?subscription=' + $routeParams.licence_id;
                }
                portalHelperService.popup_window_open(url);
              }
            },
            Cancel: {
              btnClass: 'mat ui critical button'
            }
          }
        });
      };

      portalHelperService.convertScaleOptionsFromResponse = function (questionType, options) {
        if (questionType !== CONSTANTS.questionTypeIds.RATING && questionType !== CONSTANTS.questionTypeIds.RADIO_RANKING) {
          return options;
        }

        if (!options || !Array.isArray(options)) {
          return options;
        }

        return options.map(function (option) {
          const transformedOption = angular.copy(option);
          const rationaleObj = {};

          // Map the separate fields to the object structure - only if they have values
          if (option.rationale_placeholder && option.rationale_placeholder.trim() !== '') {
            rationaleObj['0'] = option.rationale_placeholder;
          }
          if (option.rationale_placeholder1 && option.rationale_placeholder1.trim() !== '') {
            rationaleObj['1'] = option.rationale_placeholder1;
          }
          if (option.rationale_placeholder2 && option.rationale_placeholder2.trim() !== '') {
            rationaleObj['2'] = option.rationale_placeholder2;
          }

          // Replace with the transformed object
          transformedOption.rationale_placeholder = rationaleObj;

          // Remove the original separate fields
          delete transformedOption.rationale_placeholder1;
          delete transformedOption.rationale_placeholder2;

          return transformedOption;
        });
      };

      portalHelperService.convertScaleOptionsForRequest = phConvertScaleOptionsForRequest;

      portalHelperService.getMoreInfoBoxArray = function (questionScale) {
        if (!questionScale) {
          return [1];
        }

        if (!questionScale.numberOfMoreInfoColumns && questionScale.more_info_columns_count) {
          questionScale.numberOfMoreInfoColumns = questionScale.more_info_columns_count;
        }
        const count = questionScale.numberOfMoreInfoColumns || 1;
        return Array.from({ length: count }, (_, i) => i + 1);
      };

      // Normalise a per-column value (array or sparse keyed object) into a dense array of `count`, preserving indexes.
      portalHelperService.normalizeColumnArray = function (value, count) {
        const arr = new Array(count);
        const isArr = Array.isArray(value);
        const src = isArr ? value : (value || {});
        for (let i = 0; i < count; i++) {
          if (isArr) {
            arr[i] = src[i] ?? null;
          } else {
            arr[i] = Object.hasOwn(src, i) ? src[i] : null;
          }
        }
        return arr;
      };

      // Normalise a scale's per-column rationale_min_chars into a dense array and derive the enable flags.
      portalHelperService.initRationaleMinChars = function (questionScale) {
        const cols = questionScale.numberOfMoreInfoColumns || 1;
        questionScale.rationale_min_chars = portalHelperService.normalizeColumnArray(questionScale.rationale_min_chars, cols);
        questionScale.rationale_min_chars_enabled = questionScale.rationale_min_chars.map(function (v) {
          return v !== null && v !== undefined && v !== '';
        });
      };

      // Clear a column's minimum when its enable checkbox is unticked.
      portalHelperService.toggleRationaleMinChars = function (questionScale, index) {
        if (!questionScale.rationale_min_chars_enabled[index]) {
          questionScale.rationale_min_chars[index] = null;
        }
      };

      portalHelperService.getOptionsColumnClass = function (isMoreInfoBoxEnabled, questionScale) {
        if (questionScale && !questionScale.numberOfMoreInfoColumns && questionScale.more_info_columns_count) {
          questionScale.numberOfMoreInfoColumns = questionScale.more_info_columns_count;
        }

        if (isMoreInfoBoxEnabled && questionScale && questionScale.numberOfMoreInfoColumns) {
          switch (questionScale.numberOfMoreInfoColumns) {
            case 1: return 'col-7';
            case 2: return 'col-6';
            case 3: return 'col-5';
          }
        }
        return 'col-8';
      };

      portalHelperService.getMoreInfoBoxColumnClass = function (isMoreInfoBoxEnabled, questionScale) {
        if (!isMoreInfoBoxEnabled) {
          return '';
        }
        if (!questionScale) {
          return 'col-1';
        }
        if (!questionScale.numberOfMoreInfoColumns && questionScale.more_info_columns_count) {
          questionScale.numberOfMoreInfoColumns = questionScale.more_info_columns_count;
        }
        switch (questionScale.numberOfMoreInfoColumns) {
          case 1: return 'col-1';
          case 2: return 'col-2';
          case 3: return 'col-3';
          default: return 'col-3';
        }
      };
      function createScopeForStartEndDatePickerDialog() {
        const scope = $rootScope.$new(true);
        scope.selected = {'from_date': '', 'to_date': '', 'popup_error': '' };

        scope.open_from_calendar = function () {
          scope.from_calendar.opened = true;
        };

        scope.open_to_calendar = function () {
          scope.to_calendar.opened = true;
        };

        scope.min_date_options = {
          startingDay: 1,
          showWeeks: false,
          maxDate: new Date()
        };

        scope.max_date_options = {
          startingDay: 1,
          showWeeks: false,
          maxDate: new Date()
        };

        scope.$watchGroup(
          ['selected.from_date', 'selected.to_date'],
          function ([fromDate, toDate]) {
            // Update minDate for the 'to' calendar when 'from' date changes
            if (fromDate) {
              scope.max_date_options.minDate = new Date(fromDate);
            } else {
              // Optionally reset if fromDate is cleared
              scope.max_date_options.minDate = undefined;
            }

            // Update maxDate for the 'from' calendar when 'to' date changes
            if (toDate) {
              scope.min_date_options.maxDate = new Date(toDate);
            } else {
              // Optionally reset if toDate is cleared
              scope.min_date_options.maxDate = new Date();
            }
          }
        );

        scope.from_calendar = {
          opened: false
        };

        scope.to_calendar = {
          opened: false
        };

        return scope;
      }

      /**
       * Validates the date range for reports.
       * @param {Date} from_date - The start date.
       * @param {Date} to_date - The end date.
       * @returns {string|null} - Returns an error message if validation fails, otherwise null.
       */
      const validateDateRange = function (from_date, to_date) {
        if (!from_date) {
          return 'Please enter start date.';
        }

        if (!to_date) {
          return 'Please enter end date.';
        }

        // Additional validation
        if (from_date > to_date) {
          return 'Start date cannot be after end date.';
        }

        if (from_date > new Date()) {
          return 'Start date cannot be in the future.';
        }

        if (to_date > new Date()) {
          return 'End date cannot be in the future.';
        }

        return null; // No errors
      };

      portalHelperService.runCreditsUtilisedByEngagementLeadsReport = function (options = {}) {
        if (options.event) {
          options.event.preventDefault();
        }

        const scope = createScopeForStartEndDatePickerDialog();

        $ngConfirm({
          title: 'Select Date Range for Credits Utilised by Engagement Leads Report',
          columnClass: 'large',
          type: 'green',
          closeIcon: true,
          contentUrl: '../' + 'html_templates/dialogs/admin_start_end_date_picker_popup.e89420e3.html',
          scope: scope,
          escapeKey: 'Cancel',
          buttons: {
            OK: {
              btnClass: 'mat ui primary button',
              action: function () {
                const errorMessage = validateDateRange(scope.selected.from_date, scope.selected.to_date);
                if (errorMessage) {
                  scope.selected.popup_error = errorMessage;
                  return false;
                }

                // URL construction using from_date and to_date
                const start_date_str = $filter('date')(
                  scope.selected.from_date,
                  CONSTANTS.dateTimeFormat.API_DATE);

                const end_date_str = $filter('date')(
                  scope.selected.to_date,
                  CONSTANTS.dateTimeFormat.API_DATE);

                let url = $window.location.pathname +
                '#/Admin/Reports/' +
                CONSTANTS.adminReports.CREDITS_UTILISED_BY_ENGAGEMENT_LEADS +
                '?start_date=' + start_date_str + '&end_date=' + end_date_str;

                if (options.type == 'client' && $routeParams.id && $routeParams.id != 0) {
                  url = url + '&client=' + $routeParams.id;
                }
                if (options.type == 'subscription' && $routeParams.licence_id && $routeParams.licence_id != 0) {
                  url = url + '&subscription=' + $routeParams.licence_id;
                }

                portalHelperService.popup_window_open(url);
              }
            },
            Cancel: {
              btnClass: 'mat ui critical button'
            }
          }
        });
      };
    }
  ]);
